(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var AISContest = /*#__PURE__*/function () {
  function AISContest(settings) {
    _classCallCheck(this, AISContest);
    this.helper = new AISHelper();
    this.contestId = settings.contestId;
    this.aisContestId = settings.aisContestId;
    this.aisRoot = settings.aisRoot;
    this.startTime = new Date(settings.startTimeUtc);
    this.endTime = new Date(settings.endTimeUtc);
    this.winnerCount = settings.winnerCount;
    this.pageSize = 100;
    this.myRank = -1;
    this.cbfProfileId = settings.clientProfileId;
    this.myPosition = -1;
    this.tableSortParam = {
      sortParam: "rank",
      sortOrder: "asce"
    };
    this.maximumDrawdown = settings.maximumDrawdown;
    this.newAccountRequiredContest = settings.newAccountRequiredContest;
    this.isFinalContest = settings.isFinalContest;
    this.qualifiersTable = {
      pageSize: 100,
      page: 1,
      tableSortParam: {
        sortParam: "user",
        sortOrder: "asce"
      }
    };
  }
  _createClass(AISContest, [{
    key: "SetMaximumDrawdown",
    value: function SetMaximumDrawdown(maximumDrawdown) {
      this.maximumDrawdown = maximumDrawdown;
    }
  }, {
    key: "InitializeEventTriggers",
    value: function InitializeEventTriggers() {
      var myThis = this;
      $(document).on('keyup', '.phone-number-input', function () {
        $(".phone-number-input-box").removeClass("has-error");
      });
      $(document).on('keyup', '.verification-code-group input', function (e) {
        if (e.keyCode === 8) {
          $(this).prev('input').val('');
          $(this).prev('input').focus();
        }
      });
      $(document).on('input', '.verification-code-group input', function (e) {
        if (e.keyCode != 8) {
          $(this).next('input').focus();
          $("#verification-code-message").removeClass("has-error");
          if ($(this).next('input').length == 0) {
            myThis.VerifyPhoneNumber();
          }
        }
      });
      $(document).on('focus', '.verification-code-group input', function (e) {
        $(this).select();
      });
      $(document).on('click', '#contest-ranking-table-container th.sort[data-sort-param]', function (e) {
        var $this = $(this);
        var selector = "#contest-ranking-table-container";
        var dir = "asce";
        if ($this.hasClass("asce")) dir = "desc";else dir = "asce";
        $(selector + " td.sort[data-sort-param]").removeClass("asce");
        $(selector + " td.sort[data-sort-param]").removeClass("desc");
        $this.addClass(dir);
        myThis.tableSortParam = {
          sortParam: $this.data("sort-param"),
          sortOrder: dir
        };
        $(selector).pagination($(selector).pagination('getSelectedPageNum'));
      });
      $(document).on('click', '#qualifiers-table-container th.sort[data-sort-param]', function (e) {
        var $this = $(this);
        var selector = "#qualifiers-table-container";
        var dir = "asce";
        if ($this.hasClass("asce")) dir = "desc";else dir = "asce";
        $(selector + " td.sort[data-sort-param]").removeClass("asce");
        $(selector + " td.sort[data-sort-param]").removeClass("desc");
        $this.addClass(dir);
        myThis.qualifiersTable.tableSortParam = {
          sortParam: $this.data("sort-param"),
          sortOrder: dir
        };
        $(selector).pagination($(selector).pagination('getSelectedPageNum'));
      });
    }
  }, {
    key: "InitializeContestStartTimer",
    value: function InitializeContestStartTimer() {
      var myThis = this;
      var currentTime = new Date();
      var seconds = (myThis.startTime - currentTime) / 1000;
      if (seconds <= 0) {
        myThis.LoadMyLoginCredential();
        myThis.InitializeContestEndTimer();
      } else {
        $('[data-elem="contest-start-timer-text"]').html(window.contestStrings["ThisContestStartsIn"] + ":");
        var days = parseInt(seconds / 86400).toLocaleString("en");
        var timeStr = "";
        if (seconds >= 86400) {
          // days
          timeStr += window.contestStrings['_0Days'].replace("{0}", parseInt(seconds / 86400)) + " ";
          seconds %= 86400;
        }
        var hours = parseInt(seconds / 3600).toLocaleString("en", {
          minimumIntegerDigits: 2
        });
        seconds %= 3600;
        var minutes = parseInt(seconds / 60).toLocaleString("en", {
          minimumIntegerDigits: 2
        });
        seconds %= 60;
        seconds = parseInt(seconds).toLocaleString("en", {
          minimumIntegerDigits: 2
        });
        timeStr += "".concat(hours, ":").concat(minutes, ":").concat(seconds);
        var pwdStr = window.contestStrings["PasswordShowsAtContestStart0"].replace("{0}", timeStr);
        $(".contest-timer-item[data-elem=day] span:first-child").html(days);
        $(".contest-timer-item[data-elem=hour] span:first-child").html(hours);
        $(".contest-timer-item[data-elem=minute] span:first-child").html(minutes);
        $(".contest-timer-item[data-elem=second] span:first-child").html(seconds);
        $("[data-id=login-password]").html(pwdStr);
        setTimeout(function () {
          myThis.InitializeContestStartTimer();
        }, 1000);
      }
    }
  }, {
    key: "InitializeContestEndTimer",
    value: function InitializeContestEndTimer() {
      var myThis = this;
      var currentTime = new Date();
      var seconds = (myThis.endTime - currentTime) / 1000;
      if (seconds <= 0) {
        $('[data-elem="contest-start-timer-text"]').html(window.contestStrings['ThisContestIsEnded']);
      } else {
        $('[data-elem="contest-start-timer-text"]').html(window.contestStrings["ThisContestEndsIn"] + ":");
        var days = parseInt(seconds / 86400).toLocaleString("en");
        seconds %= 86400;
        var hours = parseInt(seconds / 3600).toLocaleString("en", {
          minimumIntegerDigits: 2
        });
        seconds %= 3600;
        var minutes = parseInt(seconds / 60).toLocaleString("en", {
          minimumIntegerDigits: 2
        });
        seconds %= 60;
        seconds = parseInt(seconds).toLocaleString("en", {
          minimumIntegerDigits: 2
        });
        $(".contest-timer-item[data-elem=day] span:first-child").html(days);
        $(".contest-timer-item[data-elem=hour] span:first-child").html(hours);
        $(".contest-timer-item[data-elem=minute] span:first-child").html(minutes);
        $(".contest-timer-item[data-elem=second] span:first-child").html(seconds);
        setTimeout(function () {
          myThis.InitializeContestEndTimer();
        }, 1000);
      }
    }
  }, {
    key: "Url",
    value: function Url(key) {
      return this.aisRoot + (this.urls || {})[key];
    }
  }, {
    key: "InitializePage",
    value: function InitializePage() {
      var myThis = this;
      myThis.InitContestPageInfo();
      myThis.InitRankingTable();
      myThis.InitQualifiersTable();
      myThis.InitializeContestStartTimer();
    }
  }, {
    key: "OpenContestJoinDialog",
    value: function OpenContestJoinDialog() {
      var myThis = this;
      $("#join-modal-payload").html(window.joinModalPayload['phone-verification']);
      myThis.InitializePhoneInputField();
      $("#contest-join-dialog").modal('show');
    }
  }, {
    key: "OpenVerifyCodeDialog",
    value: function OpenVerifyCodeDialog(phoneNumber) {
      var myThis = this;
      $("#join-modal-payload").html(window.joinModalPayload['verify-code']);
      $("#phone-number").val(phoneNumber);
      var mid = '';
      for (var i = 0; i < phoneNumber.length - 4; i++) mid += '*';
      var displayPhoneNumber = phoneNumber.substring(0, 2) + mid + phoneNumber.substring(phoneNumber.length - 2, phoneNumber.length);
      $("#code-sent-info").html(window.contestStrings['WeSentConfirmation6SymbolsCodeToTheNumber0'].replace("{0}", displayPhoneNumber));
      $("#contest-join-dialog").modal('show');
    }
  }, {
    key: "OpenSuccessDialog",
    value: function OpenSuccessDialog(login, password, instagram, tiktok, facebook) {
      var myThis = this;
      $("#join-modal-payload").html(window.joinModalPayload['success']);
      $("#join-modal-payload [data-id=login-number]").html(login);
      $("#join-modal-payload [data-id=login-password]").html(password);
      $("#contest-join-dialog").modal('show');
      $('#contest-join-dialog').on('hidden.bs.modal', function () {
        myThis.OpenSocialMediaLinksDialog(instagram, tiktok, facebook);
      });
    }
  }, {
    key: "OpenCreationQueuedDialog",
    value: function OpenCreationQueuedDialog() {
      var myThis = this;
      $("#join-modal-payload").html(window.joinModalPayload['queued']);
      $("#contest-join-dialog").modal('show');
      $('#contest-join-dialog').on('hidden.bs.modal', function () {
        window.location.reload();
      });
    }
  }, {
    key: "OpenSocialMediaLinksDialog",
    value: function OpenSocialMediaLinksDialog(instagram, tiktok, facebook) {
      $("#join-modal-payload").html(window.joinModalPayload['social-media-links']);
      $('#join-modal-payload input[name="social-instagram"]').val(instagram);
      $('#join-modal-payload input[name="social-tiktok"]').val(tiktok);
      $('#join-modal-payload input[name="social-facebook"]').val(facebook);
      $("#contest-join-dialog").modal('show');
      $('#contest-join-dialog').on('hidden.bs.modal', function () {
        window.location.reload();
      });
    }
  }, {
    key: "OpenMyLoginCredentialDialog",
    value: function OpenMyLoginCredentialDialog() {
      var myThis = this;
      $("#join-modal-payload").html(window.joinModalPayload['my-login-credential']);
      $("#contest-join-dialog").modal('show');
      myThis.LoadMyLoginCredential();
    }
  }, {
    key: "LoadMyLoginCredential",
    value: function LoadMyLoginCredential() {
      var myThis = this;
      myThis.VerificationLoading(true);
      $.ajax({
        url: '/contests/' + myThis.contestId + '/my-login-credential',
        type: 'POST',
        cache: false,
        success: function success(res) {
          if (res.status != "error") {
            if (res.status === "queued") {
              $("#join-modal-payload [data-id=queued-message]").show();
            } else {
              $("#join-modal-payload [data-id=queued-message]").hide();
            }
            $("#join-modal-payload [data-id=login-number]").html(res.login);
            $("#join-modal-payload [data-id=login-password]").html(res.password);
            $('#join-modal-payload input[name="social-instagram"]').val(res.instagram);
            $('#join-modal-payload input[name="social-tiktok"]').val(res.tiktok);
            $('#join-modal-payload input[name="social-facebook"]').val(res.facebook);
          }
        },
        complete: function complete() {
          myThis.VerificationLoading(false);
        }
      });
    }
  }, {
    key: "InitializePhoneInputField",
    value: function InitializePhoneInputField() {
      var myThis = this;
      if (!!myThis.phoneInput) {
        myThis.phoneInput.destroy();
        myThis.phoneInput = null;
      }
      myThis.phoneInputField = document.querySelector("#phone-input");
      myThis.phoneInput = window.intlTelInput(myThis.phoneInputField, {
        initialCountry: window.InitialCountryCode,
        autoHideDialCode: false,
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/21.2.4/js/utils.js"
      });
    }
  }, {
    key: "ResendVerificationCode",
    value: function ResendVerificationCode(channel) {
      var myThis = this;
      var number = $("#phone-number").val();
      myThis.VerificationLoading(true);
      $.ajax({
        url: '/contests/' + myThis.contestId + '/send-verification-code',
        data: {
          phoneNumber: number,
          channel: channel
        },
        type: 'POST',
        cache: false,
        success: function success(res) {
          if (res.status == "pending") {
            $("#verification-code-message").removeClass("has-error");
          } else if (res.status == "twilio-error") {
            $("#verification-code-message").addClass("has-error");
            $("#verification-code-message span.validation-message").html(res.message);
          } else {
            $("#verification-code-message").addClass("has-error");
            $("#verification-code-message span.validation-message").html(window.contestStrings['FailedToResendVerificationCode']);
          }
        },
        error: function error() {
          $("#verification-code-message").addClass("has-error");
          $("#verification-code-message span.validation-message").html(window.contestStrings['FailedToResendVerificationCode']);
        },
        complete: function complete() {
          myThis.VerificationLoading(false);
        }
      });
    }
  }, {
    key: "SendVerificationCode",
    value: function SendVerificationCode() {
      var myThis = this;
      if (!myThis.phoneInput || !myThis.phoneInput.isValidNumber()) {
        $(".phone-number-input-box").addClass('has-error');
        $(".phone-number-input-box .validation-message").html(window.contestStrings['TheMobileNumberYouEnteredIsInvalid']);
        return;
      }
      var number = myThis.phoneInput.getNumber();
      myThis.VerificationLoading(true);
      $.ajax({
        url: '/contests/' + myThis.contestId + '/send-verification-code',
        data: {
          phoneNumber: number,
          channel: 'sms'
        },
        type: 'POST',
        cache: false,
        success: function success(res) {
          if (res.status == "pending") {
            myThis.OpenVerifyCodeDialog(number);
          } else if (res.status == "error") {
            $(".phone-number-input-box").addClass('has-error');
            $(".phone-number-input-box .validation-message").html(res.message);
          } else if (res.status == "phone-number") {
            $(".phone-number-input-box").addClass('has-error');
            $(".phone-number-input-box .validation-message").html(res.message);
          } else {
            $(".phone-number-input-box").addClass('has-error');
            $(".phone-number-input-box .validation-message").html(window.contestStrings['TheMobileNumberYouEnteredIsInvalid']);
          }
        },
        error: function error() {
          $(".phone-number-input-box").addClass('has-error');
          $(".phone-number-input-box .validation-message").html(window.contestStrings['TheMobileNumberYouEnteredIsInvalid']);
        },
        complete: function complete() {
          myThis.VerificationLoading(false);
        }
      });
    }
  }, {
    key: "JoinWithPhoneNumber",
    value: function JoinWithPhoneNumber() {
      var myThis = this;
      if (!myThis.phoneInput || !myThis.phoneInput.isValidNumber()) {
        $(".phone-number-input-box").addClass('has-error');
        $(".phone-number-input-box .validation-message").html(window.contestStrings['TheMobileNumberYouEnteredIsInvalid']);
        return;
      }
      var rebateAccountId;
      if ($("#validation-rebate-account-id").length > 0) rebateAccountId = $("#validation-rebate-account-id").val();
      var number = myThis.phoneInput.getNumber();
      myThis.VerificationLoading(true);
      $.ajax({
        url: '/contests/' + myThis.contestId + '/join-with-phone-number',
        data: {
          phoneNumber: number,
          rebateAccountId: rebateAccountId
        },
        type: 'POST',
        cache: false,
        success: function success(res) {
          if (res.status == "created") {
            myThis.CallContestBrokerAPI();
            myThis.OpenSuccessDialog(res.login, res.password, res.instagram, res.tiktok, res.facebook);
          } else if (res.status == "queued") {
            myThis.OpenCreationQueuedDialog();
          } else if (res.status == "error") {
            $("#contest-join-dialog #validation-summary").html(res.message);
          } else {
            $("#verification-code-message").addClass("has-error");
            $("#verification-code-message span.validation-message").html(window.contestStrings['FailedToCreateADemoAccountPleaseTryAgainLater']);
            toastr.error(window.contestStrings['FailedToCreateADemoAccountPleaseTryAgainLater']);
          }
        },
        error: function error() {
          $(".phone-number-input-box").addClass('has-error');
          $(".phone-number-input-box .validation-message").html(window.contestStrings['FailedToCreateADemoAccountPleaseTryAgainLater']);
          toastr.error(window.contestStrings['FailedToCreateADemoAccountPleaseTryAgainLater']);
        },
        complete: function complete() {
          myThis.VerificationLoading(false);
        }
      });
    }
  }, {
    key: "VerifyPhoneNumber",
    value: function VerifyPhoneNumber() {
      var myThis = this;
      var inputs = $(".verification-code-group input");
      var code = '';
      for (var i = 0; i < inputs.length; i++) code += $(inputs[i]).val();
      if (code.length < 6) return;
      var number = $("#phone-number").val();
      myThis.VerificationLoading(true);
      $.ajax({
        url: '/contests/' + myThis.contestId + '/join-with-verification-code',
        data: {
          phoneNumber: number,
          code: code
        },
        type: 'POST',
        cache: false,
        success: function success(res) {
          if (res.status == "created") {
            myThis.CallContestBrokerAPI();
            myThis.OpenSuccessDialog(res.login, res.password, res.instagram, res.tiktok, res.facebook);
          } else if (res.status == "queued") {
            myThis.OpenCreationQueuedDialog();
          } else if (res.status == "expired") {
            $("#verification-code-message").addClass("has-error");
            $("#verification-code-message span.validation-message").html(window.contestStrings['Expired']);
          } else if (res.status == "pending") {
            $("#verification-code-message").addClass("has-error");
            $("#verification-code-message span.validation-message").html(window.contestStrings['InvalidVerificationCode']);
          } else if (res.status == "twilio-error") {
            $("#verification-code-message").addClass("has-error");
            $("#verification-code-message span.validation-message").html(window.contestStrings['InvalidVerificationCode']);
          } else if (res.status == "error") {
            $("#verification-code-message").addClass("has-error");
            $("#verification-code-message span.validation-message").html(res.message);
          } else {
            $("#verification-code-message").addClass("has-error");
            $("#verification-code-message span.validation-message").html(window.contestStrings['FailedToCreateADemoAccountPleaseTryAgainLater']);
          }
        },
        error: function error() {
          $("#verification-code-message").addClass("has-error");
          $("#verification-code-message span.validation-message").html(window.contestStrings['FailedToCreateADemoAccountPleaseTryAgainLater']);
          toastr.error(window.contestStrings['FailedToCreateADemoAccountPleaseTryAgainLater']);
        },
        complete: function complete() {
          for (var i = 0; i < inputs.length; i++) $(inputs[i]).val('');
          $(".verification-code-group input:first-child").focus();
          myThis.VerificationLoading(false);
        }
      });
    }
  }, {
    key: "VerificationLoading",
    value: function VerificationLoading(load) {
      if (load) {
        $("#join-modal-payload [data-trigger=loading]").addClass("loading");
      } else {
        $("#join-modal-payload [data-trigger=loading]").removeClass("loading");
      }
    }
  }, {
    key: "InitContestPageInfo",
    value: function InitContestPageInfo() {
      var myThis = this;
      window.APIHelper.SafeServiceAPICall({
        url: myThis.aisRoot + '/api/v1/mt4/contests/' + myThis.aisContestId + '/info',
        type: "GET",
        success: function success(res) {
          var _res$myRank;
          if (!res) return;
          myThis.myRank = (_res$myRank = res === null || res === void 0 ? void 0 : res.myRank) !== null && _res$myRank !== void 0 ? _res$myRank : -1;
          if (res.myRank != -1) {
            $("#my-rank").html("<img src=\"/Content/dist/images/icons/my_rank_icon.svg\"/>".concat(window.contestStrings["MyRank0"].replace("{0}", res.myRank + 1)));
            $("#my-rank").show();
          }
          if (res.autoSuggestions.length > 0) {
            $("#contestants-search").mdb_autocomplete({
              data: res.autoSuggestions
            });
          }
        },
        error: function error(_error) {
          console.log(_error);
        }
      });
    }
  }, {
    key: "InitQualifiersTable",
    value: function InitQualifiersTable(query) {
      var myThis = this;
      var selector = '#qualifiers-table-container';
      if ($(selector).length == 0) return;
      var link = '/api/contests/' + myThis.contestId + '/qualifiers';
      if (!!query) link += '?query=' + query;
      $(selector).pagination({
        dataSource: link,
        locator: 'Items',
        pageSize: myThis.qualifiersTable.pageSize,
        pageRange: 1,
        ajax: {
          beforeSend: function beforeSend(jqXHR, settings) {
            if (myThis.qualifiersTable.tableSortParam != undefined) {
              settings.url += '&sortParam=' + myThis.qualifiersTable.tableSortParam.sortParam + '&sortOrder=' + myThis.qualifiersTable.tableSortParam.sortOrder;
            }
            return true;
          }
        },
        afterRender: function afterRender() {
          $("#qualifiers-table-paginater").html('');
          $("#qualifiers-table-paginater").append($('#qualifiers-table-container .paginationjs').clone(true));
        },
        totalNumberLocator: function totalNumberLocator(response) {
          if (!response) return 0;
          return response.TotalCount;
        },
        callback: function callback(data, pagination) {
          var sortParam = "user",
            sortOrder = "asce";
          if (!!myThis.qualifiersTable.tableSortParam) {
            sortParam = myThis.qualifiersTable.tableSortParam.sortParam;
            sortOrder = myThis.qualifiersTable.tableSortParam.sortOrder.toLowerCase();
          }
          var html = '<table class="statistics-table row-border-table">';
          var header = '<tr>';
          if (sortParam == "user") header += "<th data-sort-param=\"user\" class=\"sort ".concat(sortOrder, "\">").concat(window.contestStrings['User'], "</th>");else header += "<th data-sort-param=\"user\" class=\"sort\">".concat(window.contestStrings['User'], "</th>");

          // hide country column
          if (sortParam == "country") header += "<th data-sort-param=\"country\" class=\"sort ".concat(sortOrder, "\">").concat(window.contestStrings['Country'], "</th>");else header += "<th data-sort-param=\"country\" class=\"sort\">".concat(window.contestStrings['Country'], "</th>");
          if (sortParam == "account") header += "<th data-sort-param=\"account\" class=\"sort ".concat(sortOrder, "\">").concat(window.contestStrings['ContestAccount'], "</th>");else header += "<th data-sort-param=\"account\" class=\"sort\">".concat(window.contestStrings['ContestAccount'], "</th>");
          if (sortParam == "contest") header += "<th data-sort-param=\"contest\" class=\"sort ".concat(sortOrder, "\">").concat(window.contestStrings['Contest'], "</th>");else header += "<th data-sort-param=\"contest\" class=\"sort\">".concat(window.contestStrings['Contest'], "</th>");
          header += '</tr>';
          html += header;
          var langSlug = "";
          if (window.CURRENT_LANG != 'en') langSlug += '/' + window.CURRENT_LANG;
          var _iterator = _createForOfIteratorHelper(data),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var element = _step.value;
              var cls = '';
              var row = '';
              if (element.ClientProfileId == myThis.cbfProfileId) {
                cls += ' mine';
              }
              if (cls != '') {
                row += '<tr class="' + cls + '">';
              } else {
                row = '<tr>';
              }
              row += "<td><a href=\"".concat(langSlug, "/social-profile/view?scid=").concat(element.ClientProfileId, "\">").concat(element === null || element === void 0 ? void 0 : element.ClientProfileName, "</a></td>");

              // hide country column
              if (!!(element !== null && element !== void 0 && element.CountryCode)) {
                row += "<td><span><i data-action=\"country\" data-country=\"".concat(element === null || element === void 0 ? void 0 : element.CountryCode, "\" class=\"flag flag-").concat(element === null || element === void 0 ? void 0 : element.CountryCode.toLowerCase(), "\"></i></span></td>");
              } else {
                row += "<td></td>";
              }
              row += "<td><a href=\"".concat(langSlug, "/trading-account?said=").concat(element.AISAccountId, "\">").concat(element.AISAccountId, "</a></td>");
              row += "<td><a href=\"/contests/".concat(element.ContestId, "\">").concat(element === null || element === void 0 ? void 0 : element.ContestName, "</a></td>");
              row += '</tr>';
              html += row;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          html += '</table>';
          html = '<div class="section-tab-body">' + html + '</div>';
          $(selector + " .table-wrapper").html(html);
          InitializeScrollTable(selector + " .table-wrapper .section-tab-body table");
          myThis.helper.InitializeCountryCodeTooltip();
        }
      });
    }
  }, {
    key: "SearchQualifiers",
    value: function SearchQualifiers() {
      var query = $("#qualifiers-search").val();
      this.InitQualifiersTable(query);
      return false;
    }
  }, {
    key: "InitRankingTable",
    value: function InitRankingTable(query) {
      var myThis = this;
      var selector = '#contest-ranking-table-container';
      var link = myThis.aisRoot + '/api/v1/mt4/contests/' + myThis.aisContestId + '/ranking' + '?cbfProfileId=' + myThis.cbfProfileId;
      if (!!query) link += '&query=' + query;
      $(selector).pagination({
        dataSource: link,
        ajaxFunction: function ajaxFunction(t) {
          return window.APIHelper.SafeServiceAPICall(t);
        },
        locator: 'items',
        pageSize: myThis.pageSize,
        pageRange: 1,
        ajax: {
          beforeSend: function beforeSend(jqXHR, settings) {
            if (myThis.tableSortParam != undefined) {
              settings.url += '&sortParam=' + myThis.tableSortParam.sortParam + '&sortOrder=' + myThis.tableSortParam.sortOrder;
            }
            return true;
          }
        },
        afterRender: function afterRender() {
          $("#ranking-table-paginater").html('');
          $("#ranking-table-paginater").append($('#contest-ranking-table-container .paginationjs').clone(true));
        },
        totalNumberLocator: function totalNumberLocator(response) {
          var _response$myPosition;
          if (!response) return 0;
          myThis.myPosition = (_response$myPosition = response === null || response === void 0 ? void 0 : response.myPosition) !== null && _response$myPosition !== void 0 ? _response$myPosition : -1;
          return response.totalCount;
        },
        callback: function callback(data, pagination) {
          var sortParam = "rank",
            sortOrder = "asce";
          if (!!myThis.tableSortParam) {
            sortParam = myThis.tableSortParam.sortParam;
            sortOrder = myThis.tableSortParam.sortOrder.toLowerCase();
          }
          var html = '<table class="statistics-table row-border-table">';
          var header = '<tr>';
          if (sortParam == "rank") header += "<th data-sort-param=\"rank\" class=\"sort ".concat(sortOrder, "\">#</th>");else header += "<th data-sort-param=\"rank\" class=\"sort\">#</th>";
          if (sortParam == "user") header += "<th data-sort-param=\"user\" class=\"sort ".concat(sortOrder, "\">").concat(window.contestStrings['User'], "</th>");else header += "<th data-sort-param=\"user\" class=\"sort\">".concat(window.contestStrings['User'], "</th>");

          // hide country column
          if (sortParam == "country") header += "<th data-sort-param=\"country\" class=\"sort ".concat(sortOrder, "\">").concat(window.contestStrings['Country'], "</th>");else header += "<th data-sort-param=\"country\" class=\"sort\">".concat(window.contestStrings['Country'], "</th>");
          if (sortParam == "account") header += "<th data-sort-param=\"account\" class=\"sort ".concat(sortOrder, "\">").concat(window.contestStrings['Account'], "</th>");else header += "<th data-sort-param=\"account\" class=\"sort\">".concat(window.contestStrings['Account'], "</th>");
          if (sortParam == "equity") header += "<th data-sort-param=\"equity\" class=\"sort ".concat(sortOrder, "\">").concat(window.contestStrings['Equity'], "</th>");else header += "<th data-sort-param=\"equity\" class=\"sort\">".concat(window.contestStrings['Equity'], "</th>");
          if (sortParam == "open-profit") header += "<th data-sort-param=\"open-profit\" class=\"sort ".concat(sortOrder, "\">").concat(window.contestStrings['OpenProfit'], "</th>");else header += "<th data-sort-param=\"open-profit\" class=\"sort\">".concat(window.contestStrings['OpenProfit'], "</th>");
          if (sortParam == "profit-percent") header += "<th data-sort-param=\"profit-percent\" class=\"sort ".concat(sortOrder, "\">").concat(window.contestStrings['ProfitPercent'], "</th>");else header += "<th data-sort-param=\"profit-percent\" class=\"sort\">".concat(window.contestStrings['ProfitPercent'], "</th>");
          if (sortParam == "peak-drawdown") header += "<th data-sort-param=\"peak-drawdown\" class=\"sort ".concat(sortOrder, "\">").concat(window.contestStrings['PeakDrawdown'], "</th>");else header += "<th data-sort-param=\"peak-drawdown\" class=\"sort\">".concat(window.contestStrings['PeakDrawdown'], "</th>");
          if (sortParam == "calculated-trades") header += "<th data-sort-param=\"calculated-trades\" class=\"sort ".concat(sortOrder, "\">").concat(window.contestStrings['CalculatedTrades'], "</th>");else header += "<th data-sort-param=\"calculated-trades\" class=\"sort\">".concat(window.contestStrings['CalculatedTrades'], "</th>");
          if (sortParam == "excluded-trades") header += "<th data-sort-param=\"excluded-trades\" class=\"sort ".concat(sortOrder, "\">").concat(window.contestStrings['ExcludedTrades'], "</th>");else header += "<th data-sort-param=\"excluded-trades\" class=\"sort\">".concat(window.contestStrings['ExcludedTrades'], "</th>");
          header += '</tr>';
          html += header;
          var langSlug = "";
          if (window.CURRENT_LANG != 'en') langSlug += '/' + window.CURRENT_LANG;
          var _iterator2 = _createForOfIteratorHelper(data),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var element = _step2.value;
              var cls = '';
              var row = '';
              if (element.rank < myThis.winnerCount) {
                cls += 'winner';
              }
              if (element.cbfProfileId == myThis.cbfProfileId) {
                cls += ' mine';
              }
              if (cls != '') {
                row += '<tr class="' + cls + '">';
              } else {
                row = '<tr>';
              }
              if (!!myThis.maximumDrawdown && myThis.maximumDrawdown > 0 && element.peakDrawdown > myThis.maximumDrawdown) {
                row += '<td><div class="disqualified" data-action="drawdown-disqualified-tooltip" data-reason="drawdown">!</div></td>';
              } else if (element.manualDisqualified) {
                row += '<td><div class="disqualified" data-action="drawdown-disqualified-tooltip" data-reason="manual">!</div></td>';
              } else {
                row += '<td><div>' + (element.rank + 1) + '</div></td>';
              }
              row += "<td><a href=\"".concat(langSlug, "/social-profile/view?scid=").concat(element.cbfProfileId, "\">").concat(element === null || element === void 0 ? void 0 : element.cbfClientName, "</a></td>");

              // hide country column
              if (!!(element !== null && element !== void 0 && element.country)) {
                row += "<td><span><i data-action=\"country\" data-country=\"".concat(element === null || element === void 0 ? void 0 : element.country, "\" class=\"flag flag-").concat(element === null || element === void 0 ? void 0 : element.country.toLowerCase(), "\"></i></span></td>");
              } else {
                row += "<td>";
              }
              row += "<td><a href=\"".concat(langSlug, "/trading-account?said=").concat(element.aisAccountId, "\">").concat(element === null || element === void 0 ? void 0 : element.name, "</a></td>");
              if (element.hasStats) {
                var _element$excludedTrad;
                row += '<td>' + myThis.helper.ToDecimal(element.equity) + '</td>';
                row += '<td>' + myThis.helper.ToDecimal(element.openProfit) + '</td>';
                row += '<td>' + myThis.helper.ToPercent(element.profit / element.deposits) + '</td>';
                if (element.peak != null && element.peakTime != null && element.valley != null && element.valleyTime != null) {
                  var popoverContent = "<table><tr><td>".concat(window.contestStrings["EquityHigh"], ":</td><td><div class='ml-2 mr-2'>").concat(myThis.helper.ToDecimal(element.peak), "</br><span class='opacity-3'>").concat(myThis.helper.ToShortDateTime(element.peakTime, 'short', 'UTC'), "</span></div></td></tr><tr><td>").concat(window.contestStrings["SubsequentEquityLow"], ":</td><td><div class='ml-2 mr-2'>").concat(myThis.helper.ToDecimal(element.valley), "<br/><span class='opacity-3'>").concat(myThis.helper.ToShortDateTime(element.valleyTime, 'short', 'UTC'), "</span></div></td></tr></table>");
                  var peakHtml = "<span class=\"text-dotted-underline\" data-html=\"true\" data-toggle=\"drawdown-popover\" data-trigger=\"hover toggle\" data-content=\"".concat(popoverContent, "\">").concat(myThis.helper.ToPercent(element.peakDrawdown), "</span>");
                  row += '<td>' + peakHtml + '</td>';
                } else {
                  row += '<td>' + myThis.helper.ToPercent(element.peakDrawdown) + '</td>';
                }
                row += '<td>' + myThis.helper.ToIntNumber(element.calculatedTrades) + '</td>';
                row += '<td>' + myThis.helper.ToIntNumber((_element$excludedTrad = element.excludedTrades) !== null && _element$excludedTrad !== void 0 ? _element$excludedTrad : element.excludedByLimit + element.excludedByMinTradeDuration) + '</td>';
              } else {
                row += '<td> - </td>';
                row += '<td> - </td>';
                row += '<td> - </td>';
                row += '<td> - </td>';
                row += '<td> - </td>';
                row += '<td> - </td>';
              }
              row += '</tr>';
              html += row;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          html += '</table>';
          html = '<div class="section-tab-body">' + html + '</div>';
          $(selector + " .table-wrapper").html(html);
          InitializeScrollTable(selector + " .table-wrapper .section-tab-body table");
          myThis.helper.InitializeRankingTableTooltips();
        }
      });
    }
  }, {
    key: "SearchContestants",
    value: function SearchContestants() {
      var query = $("#contestants-search").val();
      this.InitRankingTable(query);
      return false;
    }
  }, {
    key: "GoToMyPosition",
    value: function GoToMyPosition() {
      var myThis = this;
      if (myThis.myPosition != -1) {
        window.Tabs.LoadTab($("#tab-contest-rankings"));
        var page = parseInt(myThis.myPosition / myThis.pageSize);
        var order = myThis.myPosition - page * myThis.pageSize + 1;
        $("#contest-ranking-table-container").pagination('go', page + 1);
        var elem = $("#contest-ranking-table-container table tr:nth-child(" + order + ")");
        if (elem.length > 0) {
          $('html, body').animate({
            scrollTop: elem.offset().top
          }, 500);
        }
      }
    }
  }, {
    key: "UpdateSocialMediaLinks",
    value: function UpdateSocialMediaLinks() {
      var instagram = $('#contest-join-dialog input[name="social-instagram"]').val();
      var tiktok = $('#contest-join-dialog input[name="social-tiktok"]').val();
      var facebook = $('#contest-join-dialog input[name="social-facebook"]').val();
      $('#contest-join-dialog').modal('hide');
      $.ajax({
        url: '/api/settings/update-social-links',
        type: 'post',
        data: {
          instagram: instagram,
          tiktok: tiktok,
          facebook: facebook
        },
        success: function success() {
          toastr.success(window.contestStrings["YourSocialMediaUsernamesHaveBeenSavedSuccessfully"]);
        },
        error: function error() {
          toastr.error(window.contestStrings["SomethingWentWrongFailedToSaveYourSocialMediaUsernames"]);
        }
      });
    }
  }, {
    key: "CallContestBrokerAPI",
    value: function CallContestBrokerAPI() {
      if (window.contestBrokerAPIEnabled) {
        ContestBrokerAPI();
      }
    }
  }, {
    key: "OpenNewLiveAccountLinkDialog",
    value: function OpenNewLiveAccountLinkDialog() {
      $("#link-new-live-account-modal-payload").html(this.GetCorrectedHtml(window.linkLiveAccountModalPayload["submit-live-account"]));
      this.InitializePhoneInputField();
      $("#link-new-live-account-dialog").modal('show');
    }
  }, {
    key: "OpenRestrictedCountryDialog",
    value: function OpenRestrictedCountryDialog() {
      $("#link-new-live-account-modal-payload").html(this.GetCorrectedHtml(window.linkLiveAccountModalPayload["restricted-country"]));
      $("#link-new-live-account-dialog").modal('show');
    }
  }, {
    key: "GetCorrectedHtml",
    value: function GetCorrectedHtml(html) {
      var newHtml = html;
      if (window.contestBrokerName) {
        newHtml = newHtml.replace("{{brokerName}}", window.contestBrokerName);
      }
      if (window.contestBrokerJurisidiction) {
        newHtml = newHtml.replace("{{brokerJurisidiction}}", window.contestBrokerJurisidiction);
      }
      return newHtml;
    }
  }, {
    key: "SubmitLiveAccount",
    value: function SubmitLiveAccount() {
      var myThis = this;
      var accountNumber = $('#link-new-live-account-modal-payload input[name="new-account-login"]').val();
      if (!accountNumber) {
        $("#new-account-login-validation-message").addClass("has-error");
        $("#new-account-login-validation-message span.validation-message").html(window.contestStrings['PleaseEnterYourAccountNumber']);
        return;
      }
      if (!myThis.phoneInput || !myThis.phoneInput.isValidNumber()) {
        $(".phone-number-input-box").addClass('has-error');
        $(".phone-number-input-box .validation-message").html(window.contestStrings['TheMobileNumberYouEnteredIsInvalid']);
        return;
      }
      var number = myThis.phoneInput.getNumber();
      var id = myThis.contestId;
      myThis.NewAccountLoginLoading(true);
      $.ajax({
        url: window.submitNewLiveAccountUrl,
        type: 'POST',
        data: {
          accountNumber: accountNumber,
          id: id,
          brokerId: window.contestSponsorBrokerId,
          phoneNumber: number
        },
        cache: false,
        async: true,
        success: function success(res) {
          if (res.status == "ok") {
            myThis.OpenNewAccountSuccessDialog();
          } else if (res.status == "pending") {
            myThis.OpenNewAccountPendingDialog();
          } else if (res.status == "invalid") {
            $("#new-account-login-validation-message").addClass("has-error");
            $("#new-account-login-validation-message span.validation-message").html(myThis.GetCorrectedHtml(res.message));
          } else if (res.status == "existing") {
            $("#new-account-login-validation-message").addClass("has-error");
            $("#new-account-login-validation-message span.validation-message").html(myThis.GetCorrectedHtml(res.message));
          } else {
            myThis.OpenNewAccountNotFoundDialog();
          }
        },
        error: function error() {
          myThis.OpenNewAccountFailDialog();
        },
        complete: function complete() {
          myThis.NewAccountLoginLoading(false);
        }
      });
    }
  }, {
    key: "OpenNewAccountSuccessDialog",
    value: function OpenNewAccountSuccessDialog() {
      $("#link-new-live-account-modal-payload").html(this.GetCorrectedHtml(window.linkLiveAccountModalPayload['live-account-found']));
      $("#link-new-live-account-dialog").modal('show');
    }
  }, {
    key: "OpenNewAccountPendingDialog",
    value: function OpenNewAccountPendingDialog() {
      $("#link-new-live-account-modal-payload").html(this.GetCorrectedHtml(window.linkLiveAccountModalPayload['live-account-pending']));
      $("#link-new-live-account-dialog").modal('show');
    }
  }, {
    key: "OpenNewAccountNotFoundDialog",
    value: function OpenNewAccountNotFoundDialog() {
      $("#link-new-live-account-modal-payload").html(this.GetCorrectedHtml(window.linkLiveAccountModalPayload['live-account-not-found']));
      $("#link-new-live-account-dialog").modal('show');
    }
  }, {
    key: "OpenNewAccountFailDialog",
    value: function OpenNewAccountFailDialog() {
      $("#link-new-live-account-modal-payload").html(this.GetCorrectedHtml(window.linkLiveAccountModalPayload['live-account-fail']));
      $("#link-new-live-account-dialog").modal('show');
    }
  }, {
    key: "NewAccountLoginLoading",
    value: function NewAccountLoginLoading(load) {
      if (load) {
        $("#link-new-live-account-modal-payload [data-trigger=loading]").addClass("loading");
      } else {
        $("#link-new-live-account-modal-payload [data-trigger=loading]").removeClass("loading");
      }
    }
  }]);
  return AISContest;
}();
var _default = AISContest;
exports["default"] = _default;

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var AISHelper = /*#__PURE__*/function () {
  function AISHelper() {
    _classCallCheck(this, AISHelper);
  }
  _createClass(AISHelper, [{
    key: "ToPercent",
    value: function ToPercent(val, hasStyle, strWhenZero) {
      if (val == null) return '-';
      val = parseFloat(val);
      if (Number.isNaN(val)) return '<i class="mdi mdi-lock"/>';
      if (!!strWhenZero && val == 0) return strWhenZero;
      var localeCode = window.CURRENT_CULTURE;
      if (!localeCode || localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (!localeCode) localeCode = "en-GB";
      var str = val.toLocaleString(localeCode, {
        style: 'percent',
        maximumFractionDigits: 2
      });
      if (hasStyle === true) {
        if (val >= 0) return '<span class="stats-positive">' + str + '</span>';else return '<span class="stats-negative">' + str + '</span>';
      }
      return str;
    }
  }, {
    key: "ToCurrency",
    value: function ToCurrency(val, hasStyle) {
      if (val == null) return '-';
      val = parseFloat(val);
      if (Number.isNaN(val)) return '<i class="mdi mdi-lock"/>';
      var localeCode = window.CURRENT_CULTURE;
      if (!localeCode || localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (!localeCode) localeCode = "en-GB";
      var str = val.toLocaleString(localeCode, {
        style: 'currency',
        maximumFractionDigits: 2,
        currency: 'USD'
      });
      if (hasStyle === true) {
        if (val >= 0) return '<span class="stats-positive">' + str + '</span>';else return '<span class="stats-negative">' + str + '</span>';
      }
      return str;
    }
  }, {
    key: "ToDecimal",
    value: function ToDecimal(val, hasStyle) {
      if (val == null) return '-';
      val = parseFloat(val);
      if (Number.isNaN(val)) return '<i class="mdi mdi-lock"/>';
      var localeCode = window.CURRENT_CULTURE;
      if (!localeCode || localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (!localeCode) localeCode = "en-GB";
      var str = val.toLocaleString(localeCode, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      if (hasStyle === true) {
        if (val >= 0) return '<span class="stats-positive">' + str + '</span>';else return '<span class="stats-negative">' + str + '</span>';
      }
      return str;
    }
  }, {
    key: "ToDigitsDecimal",
    value: function ToDigitsDecimal(val, digits) {
      if (val == null) return '-';
      val = parseFloat(val);
      if (Number.isNaN(val)) return '-';
      var localeCode = window.CURRENT_CULTURE;
      if (!localeCode || localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (!localeCode) localeCode = "en-GB";
      var str = '';
      if (digits == null || digits == undefined) str = val.toLocaleString(localeCode);else str = val.toLocaleString(localeCode, {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      });
      return str;
    }
  }, {
    key: "ToIntNumber",
    value: function ToIntNumber(val, hasStyle) {
      if (val == null) return '-';
      val = parseFloat(val);
      if (Number.isNaN(val)) return '<i class="mdi mdi-lock"/>';
      var localeCode = window.CURRENT_CULTURE;
      if (!localeCode || localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (!localeCode) localeCode = "en-GB";
      var str = val.toLocaleString(localeCode, {
        maximumFractionDigits: 0
      });
      if (hasStyle === true) {
        if (val >= 0) return '<span class="stats-positive">' + str + '</span>';else return '<span class="stats-negative">' + str + '</span>';
      }
      return str;
    }
  }, {
    key: "ToTimeSpan",
    value: function ToTimeSpan(val) {
      var res = '';
      if (val.days > 0) res += val.days + 'd';
      if (val.hours > 0) res += ' ' + val.hours + 'h';
      if (val.minutes > 0) res += ' ' + val.minutes + 'm';
      return res;
    }
  }, {
    key: "GetDuraction",
    value: function GetDuraction(t1, t2) {
      t1 = new Date(t1);
      t2 = new Date(t2);
      var res = '';
      var span = (t2 - t1) / 1000;
      if (span > 24 * 3600) {
        res += parseInt(span / (24 * 3600)) + "d";
        span = span % (24 * 3600);
      }
      if (span > 3600) {
        res += ' ' + parseInt(span / 3600) + 'h';
        span = span % 3600;
      }
      if (span > 60) {
        res += ' ' + parseInt(span / 60) + 'm';
        span = span % 60;
      }
      if (res == '') res = parseInt(span) + 's';
      return res;
    }
  }, {
    key: "ToShortDate",
    value: function ToShortDate(val, type, timezone) {
      var date = new Date(val);
      var yearType = 'numeric';
      if (date.getFullYear() == new Date().getFullYear()) yearType = undefined;
      var localeCode = window.CURRENT_CULTURE;
      if (!localeCode || localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (!localeCode) localeCode = "en-GB";
      if (!type) type = "short";
      return date.toLocaleDateString(localeCode, {
        weekday: undefined,
        year: yearType,
        month: type,
        day: 'numeric',
        timeZone: timezone
      });
    }
  }, {
    key: "ToShortDateTime",
    value: function ToShortDateTime(val, type, timezone) {
      var date = new Date(val);
      var yearType = 'numeric';
      if (date.getFullYear() == new Date().getFullYear()) yearType = undefined;
      var localeCode = window.CURRENT_CULTURE;
      if (!localeCode || localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (!localeCode) localeCode = "en-GB";
      if (!type) type = "short";
      return date.toLocaleDateString(localeCode, {
        weekday: undefined,
        year: yearType,
        month: type,
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: timezone
      });
    }
  }, {
    key: "ToLongDate",
    value: function ToLongDate(val, timezone) {
      var date = new Date(val);
      var localeCode = window.CURRENT_CULTURE;
      if (!localeCode || localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (!localeCode) localeCode = "en-GB";
      return date.toLocaleString(localeCode, {
        weekday: undefined,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: timezone
      });
    }
  }, {
    key: "ToStatus",
    value: function ToStatus(lastUpdated, hasError) {
      var desc = '';
      if (new Date(lastUpdated).getTime() < 0) {
        desc = 'never';
      } else {
        desc = this.GetDuraction(lastUpdated, new Date()) + ' ago';
      }
      var res = '';
      if (hasError == false) {
        res += '<span data-toggle="tooltip" title="Connection Succeeded"><i class="mdi mdi-sync"/> <span class="dotted-border-bottom">(' + desc + ')</span></span>';
      } else {
        res += '<span data-toggle="tooltip" title="Connection Failed"><i class="mdi mdi-sync-off"/> <span class="dotted-border-bottom">(' + desc + ')</span></span>';
      }
      return res;
    }
  }, {
    key: "ToChartMoney",
    value: function ToChartMoney(value) {
      if (Math.abs(value) >= 1000000) {
        return (value / 1000000).toFixed(1) + "M";
      } else if (Math.abs(value) >= 1000) {
        return (value / 1000).toFixed(1) + "K";
      } else return value.toFixed(2);
    }
  }, {
    key: "InitializeRankingTableTooltips",
    value: function InitializeRankingTableTooltips() {
      this.InitializeCountryCodeTooltip();
      $("[data-action=drawdown-disqualified-tooltip]").each(function (i, ele) {
        $(ele).data('toggle', 'tooltip');
        if ($(ele).data('reason') == 'manual') {
          var _window$contestString;
          $(ele).data('title', (_window$contestString = window.contestStrings["DisqualifiedDueToAViolation"]) !== null && _window$contestString !== void 0 ? _window$contestString : "Disqualified due to a violation");
        } else {
          var _window$contestString2;
          $(ele).data('title', (_window$contestString2 = window.contestStrings["DisqualfiedDueToDrawdown"]) !== null && _window$contestString2 !== void 0 ? _window$contestString2 : "Disqualified due to drawdown");
        }
        $(ele).tooltip('dispose').tooltip({
          boundary: 'window'
        });
      });
      $("[data-toggle='drawdown-popover']").popover();
    }
  }, {
    key: "InitializeCountryCodeTooltip",
    value: function InitializeCountryCodeTooltip() {
      var displayNames = new Intl.DisplayNames(window.CURRENT_LANG, {
        type: 'region'
      });
      $("[data-action=country]").each(function (i, ele) {
        try {
          var countryCode = $(ele).data('country');
          $(ele).data('toggle', 'tooltip');
          $(ele).data('title', displayNames.of(countryCode));
          $(ele).tooltip('dispose').tooltip({
            boundary: 'window'
          });
        } catch (err) {}
      });
    }
  }, {
    key: "GetLocalizedCurrencyName",
    value: function GetLocalizedCurrencyName(currencyCode) {
      var currencyNames = new Intl.DisplayNames(window.CURRENT_LANG, {
        type: 'currency'
      });
      // Get currency names
      return currencyNames.of(currencyCode);
    }
  }, {
    key: "GetLocalizedLanguageName",
    value: function GetLocalizedLanguageName(langCode) {
      var languageNames = new Intl.DisplayNames(window.CURRENT_LANG, {
        type: 'language'
      });
      return languageNames.of(langCode);
    }
  }, {
    key: "GetLocalizedRegionName",
    value: function GetLocalizedRegionName(regionCode) {
      var regionNames = new Intl.DisplayNames(window.CURRENT_LANG, {
        type: 'region'
      });
      return regionNames.of(regionCode);
    }
  }]);
  return AISHelper;
}();
var _default = AISHelper;
exports["default"] = _default;

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var AISPerformances = /*#__PURE__*/function () {
  function AISPerformances(aisRoot) {
    _classCallCheck(this, AISPerformances);
    this.aisRoot = aisRoot;
    this.helper = new AISHelper();
    this.performancesQuery = '';
    this.urls = {
      PerformancesLink: '/api/v1/mt/performances'
    };
  }
  _createClass(AISPerformances, [{
    key: "InitializePage",
    value: function InitializePage() {
      var myThis = this;
      InitializeScrollTable('#performances-table');
      myThis.performancesQuery = window.location.search;
      myThis.UpdateFormByQuery();
      myThis.PerformanceFormStateUpdated(true);
      myThis.InitialzePerformancesTableSort();
      myThis.LoadMorePerformances();
      $(document).scroll(function () {
        if (myThis.NeedLoadMorePerformances() && $('#performances-table tfoot tr[data-trigger="load-more"]').data("loading") === false) {
          myThis.LoadMorePerformances();
        }
      });
      $("#performances-query-form input").on('change', function () {
        myThis.PerformanceFormStateUpdated();
      });
    }
  }, {
    key: "Url",
    value: function Url(key) {
      return this.aisRoot + (this.urls || {})[key];
    }
  }, {
    key: "LoadMorePerformances",
    value: function LoadMorePerformances(replace) {
      var myThis = this;
      $('#performances-table tfoot tr[data-trigger="load-more"]').data("loading", true);
      var targetPage = $('#performances-table tfoot tr[data-trigger="load-more"]').data("next-page");
      $("#broker-list-loading").show();
      window.APIHelper.SafeServiceAPICall({
        type: "GET",
        cache: false,
        url: myThis.Url('PerformancesLink') + myThis.performancesQuery,
        data: {
          pageNumber: targetPage,
          pageSize: 50
        },
        success: function success(res) {
          var html = '';
          var langSlug = "";
          if (window.CURRENT_LANG != 'en') langSlug = "/" + window.CURRENT_LANG;
          for (var i = 0; i < res.items.length; i++) {
            var _res$items$i, _res$items$i4;
            html += '<tr>';
            html += "<td><a href=\"".concat(langSlug, "/social-profile/view?scid=").concat(res.items[i].cbfClientId, "\">").concat((_res$items$i = res.items[i]) === null || _res$items$i === void 0 ? void 0 : _res$items$i.clientName, "</a></td>");
            if (!!res.items[i].country) {
              var _res$items$i2, _res$items$i3;
              if (res.items[i].country.toLowerCase() == 'us') res.items[i].country = 'GB';
              html += "<td><span><i data-action=\"country\" data-country=\"".concat((_res$items$i2 = res.items[i]) === null || _res$items$i2 === void 0 ? void 0 : _res$items$i2.country, "\" class=\"flag flag-").concat((_res$items$i3 = res.items[i]) === null || _res$items$i3 === void 0 ? void 0 : _res$items$i3.country.toLowerCase(), "\"></i></span></td>");
            } else {
              html += "<td></td>";
            }
            html += "<td><a href=\"".concat(langSlug, "/trading-account?said=").concat(res.items[i].aisAccountId, "\">").concat((_res$items$i4 = res.items[i]) === null || _res$items$i4 === void 0 ? void 0 : _res$items$i4.name, "</a></td>");
            html += "<td>".concat(myThis.helper.ToDecimal(res.items[i].equity), "</td>");
            html += "<td>".concat(myThis.helper.ToDecimal(res.items[i].profit), "</td>");
            html += "<td>".concat(myThis.helper.ToPercent(res.items[i].profitPercent), "</td>");
            if (res.items[i].peakDrawdown < 0) res.items[i].peakDrawdown = 0;
            html += "<td>".concat(myThis.helper.ToPercent(res.items[i].peakDrawdown), "</td>");
            html += "<td>".concat(myThis.helper.ToPercent(res.items[i].monthlyProfitPercent), "</td>");
            html += "<td>".concat(res.items[i].broker, "</td>");
            html += "</tr>";
          }
          if (replace === true) {
            $("#performances-table tbody").html(html);
          } else {
            $("#performances-table tbody").append(html);
          }
          myThis.helper.InitializeCountryCodeTooltip();
          if (res.hasNext == true) {
            $('#performances-table tfoot tr[data-trigger="load-more"]').data("next-page", res.currentPage + 1);
          } else {
            $('#performances-table tfoot tr[data-trigger="load-more"]').remove();
          }
        },
        complete: function complete() {
          $("#broker-list-loading").hide();
          $('#performances-table tfoot tr[data-trigger="load-more"]').data("loading", false);
        }
      });
    }
  }, {
    key: "PerformanceFormStateUpdated",
    value: function PerformanceFormStateUpdated(silience) {
      var myThis = this;
      var searchForm = $("#performances-query-form");
      var filterForm = $("#performances-filter-form");
      var data = searchForm.serializeArray().concat(filterForm.serializeArray());
      var query = '?';
      $.each(data, function (i, v) {
        if (query.includes(v.name + "=")) {
          var splitOne = query.lastIndexOf(v.name + "=");
          var splitTwo = query.substring(splitOne).indexOf("&") + 1;
          splitTwo = splitTwo === 0 ? string.length : splitTwo;
          var currentEntry = query.substring(splitOne, splitTwo);
          var newEntry = currentEntry + "," + v.value;
          query = query.replace(currentEntry, newEntry);
        } else if (v.value != '') {
          if (query !== "?") {
            query += "&";
          }
          query += v.name + "=" + v.value;
        }
      });
      myThis.performancesQuery = query;
      if (!silience) window.history.pushState("", "", myThis.performancesQuery);
      myThis.ReloadPerformancesTable();
    }
  }, {
    key: "UpdateFormByQuery",
    value: function UpdateFormByQuery() {
      var params = new URLSearchParams(window.location.search);
      var _iterator = _createForOfIteratorHelper(params),
        _step;
      try {
        var _loop = function _loop() {
          var param = _step.value;
          $("#performances-query-form [name=\"".concat(param[0].toLowerCase(), "\"]")).val(param[1]);
          $("#performances-filter-form [name=\"".concat(param[0].toLowerCase(), "\"]")).val(param[1]);
          if (param[0].toLowerCase() == "broker") {
            setTimeout(function () {
              $("#performances-filter-form [name=\"".concat(param[0].toLowerCase(), "\"]")).selectpicker('val', param[1]);
            }, 2000);
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "ReloadPerformancesTable",
    value: function ReloadPerformancesTable() {
      $('#performances-table tfoot').html('<tr data-trigger="load-more" data-next-page="1" data-page-count="" data-loading=false></tr>');
      this.LoadMorePerformances(true);
    }
  }, {
    key: "NeedLoadMorePerformances",
    value: function NeedLoadMorePerformances() {
      var $elem = $('#performances-table tfoot tr[data-trigger="load-more"]');
      if ($elem.length == 0) return false;
      var elementPos = $elem.offset().top;
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      var height = $(window).height();
      return viewportTop < elementPos && elementPos < viewportBottom + height;
    }
  }, {
    key: "ResetPerformancesFilter",
    value: function ResetPerformancesFilter() {
      $.each($("#performances-filter-form [name]"), function (i, elem) {
        if ($(elem).data('default') !== undefined) {
          if ($(elem).hasClass("selectpicker")) {
            $(elem).selectpicker('val', $(elem).data('default'));
          } else {
            $(elem).val($(elem).data('default'));
          }
        }
      });
      this.PerformanceFormStateUpdated();
    }
  }, {
    key: "OnPerformancePageTradingPlatformUpdated",
    value: function OnPerformancePageTradingPlatformUpdated() {
      var tradingPlatform = $("#trading-platform-type").val();
      if (window.brokerServers == undefined) return;
      var brokers;
      if (tradingPlatform == 'MT4' || tradingPlatform == 'MT5') brokers = window.brokerServers.filter(function (x) {
        return x.platformType == tradingPlatform;
      });else brokers = window.brokerServers;
      var uniqueBrokers = _toConsumableArray(new Set(brokers.map(function (item) {
        return item.broker;
      }))).sort();
      var html = '';
      for (var i = 0; i < uniqueBrokers.length; i++) {
        html += '<option value="' + uniqueBrokers[i] + '" data-tokens="' + uniqueBrokers[i] + '">' + uniqueBrokers[i] + '</option>';
      }
      $("#filter-broker").html(html);
      $("#filter-broker").selectpicker('refresh');
    }
  }, {
    key: "InitialzePerformancesTableSort",
    value: function InitialzePerformancesTableSort() {
      var myThis = this;
      var sortParam = $("#performances-query-form [name=sortparam]").val().toLowerCase();
      var sortOrder = $("#performances-query-form [name=sortorder]").val().toLowerCase();
      if (!sortParam) sortParam = 'profit-percent';
      if (!sortOrder) sortOrder = 'desc';
      $("#performances-table th.sort").removeClass('desc');
      $("#performances-table th.sort").removeClass('asce');
      $("#performances-table th.sort[data-sort-param=\"".concat(sortParam, "\"]")).addClass(sortOrder);
      var thSorts = document.querySelectorAll('th.sort');
      for (var i = 0; i < thSorts.length; i++) {
        thSorts[i].addEventListener('click', function (e) {
          myThis.OnPerformancesTableSortUpdated(e);
          myThis.PerformanceFormStateUpdated();
        }, false);
      }
    }
  }, {
    key: "OnPerformancesTableSortUpdated",
    value: function OnPerformancesTableSortUpdated(e) {
      if (!e.target.matches("th.sort")) return;
      var sortParam = $(e.target).data('sort-param');
      var sortOrder = 'desc';
      if ($(e.target).hasClass('desc')) sortOrder = 'asce';else sortOrder = 'desc';
      $("#performances-table th.sort").removeClass('asce');
      $("#performances-table th.sort").removeClass('desc');
      $(e.target).addClass(sortOrder);
      $("#performances-query-form [name=sortparam]").val(sortParam);
      $("#performances-query-form [name=sortorder]").val(sortOrder);
    }
  }]);
  return AISPerformances;
}();
var _default = AISPerformances;
exports["default"] = _default;

},{}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var AISPortfolio = /*#__PURE__*/function () {
  function AISPortfolio(aisRoot, aisDataRoot) {
    _classCallCheck(this, AISPortfolio);
    var urlParam = new URLSearchParams(location.search);
    if (urlParam.get('scid')) this.cbfProfileId = urlParam.get('scid');
    if (urlParam.get('spid')) this.portfolioId = urlParam.get('spid');else this.portfolioId = 0;
    this.aisRoot = aisRoot;
    this.aisDataRoot = aisDataRoot;
    this.helper = new AISHelper();
    this.portfolioInfo = {};
    this.currentRiskFactor = null;
    this.currencyRates = {};
    this.totalsCurrency = null;
    this.urls = {
      ProfileStatisticsLink: '/api/v1/mt/statistics',
      ProfilePeriodStatisticsLink: '/api/v1/mt/statistics/historical-stats',
      ProfileGrowthChartLink: '/api/v1/mt/statistics/chart/profile-growth',
      ProfileStatsHubLink: '/profile-stats-hub',
      AddStatsHubLink: '/add-stats-hub',
      PortfoliosLink: '/api/v1/mt/cbf-profile/portfolios'
    };
  }
  _createClass(AISPortfolio, [{
    key: "InitializeEventTriggers",
    value: function InitializeEventTriggers() {
      var myThis = this;
      var profileConnection = new signalR.HubConnectionBuilder().withUrl(myThis.SignalRUrl('ProfileStatsHubLink')).configureLogging(signalR.LogLevel.Warning).withAutomaticReconnect().build();
      profileConnection.start();
      profileConnection.on("UpdateCbfProfileStats", function (cbfId, state) {
        if (state == "updated" && cbfId == myThis.cbfProfileId) {
          console.log('Refresh cbf profile page');
          myThis.InitializePage();
        }
      });
      var addMt4Connection = new signalR.HubConnectionBuilder().withUrl(myThis.SignalRUrl('AddStatsHubLink')).configureLogging(signalR.LogLevel.Warning).withAutomaticReconnect().build();
      addMt4Connection.start();
      addMt4Connection.on("AddMT4Account", function (accountId, state, message) {
        if (state == "finish") {
          myThis.InitializePage();
        } else if (state == "error") {
          myThis.InitializePage();
        }
      });
      addMt4Connection.on("VerifyMT4Account", function (accountId, state, message) {
        if (state == "finish") {
          toastr.success(window.portfolioStrings['YourAccountHasBeenSuccessfullyVerified']);
          OpenEditMt4AccontDialog(accountId);
        } else if (state == "error") {
          $("#verificaton-process[data-id=" + accountId + "]").html(window.portfolioStrings['FailedToVerify']);
          $("#verificaton-process[data-id=" + accountId + "]").removeClass("processing");
          $("#verificaton-process[data-id=" + accountId + "]").addClass("error");
        } else {
          $("#verificaton-process[data-id=" + accountId + "]").removeClass("error");
          $("#verificaton-process[data-id=" + accountId + "]").removeClass("finish");
          $("#verificaton-process[data-id=" + accountId + "]").addClass("processing");
          $("#verificaton-process[data-id=" + accountId + "]").html(window.portfolioStrings['ConnectingToAccount']);
        }
      });
      $(document).on('input', "#risk-factor", function () {
        myThis.ApplyRiskFactor($(this).val());
      });
      $(document).on('input', "#PortfolioRiskFactor", function () {
        myThis.ApplyRiskFactor($(this).val());
      });
      $("#PortfolioDefaultCurreny").infiniteselect({
        types: [{
          option: 'all',
          text: window.portfolioStrings['All']
        }, {
          option: 'forex',
          text: window.portfolioStrings['Forex']
        }, {
          option: 'crypto',
          text: window.portfolioStrings['Crypto']
        }],
        url: '/api/widgets/currencies',
        placeholder: 'Select a default totals currency',
        showDescription: true,
        culture: window.CURRENT_LANG,
        btnClass: 'browser-default frn-override'
      });
      document.getElementById('PortfolioDefaultCurreny').addEventListener('change', function () {
        var targetCurrency = $("#PortfolioDefaultCurreny").infiniteselect('val');
        myThis.totalsCurrency = targetCurrency;
        myThis.UpdateAllValuesByRiskFactorAndCurrency(myThis);
      });
    }
  }, {
    key: "Url",
    value: function Url(key) {
      return this.aisRoot + (this.urls || {})[key];
    }
  }, {
    key: "SignalRUrl",
    value: function SignalRUrl(key) {
      return this.aisDataRoot + (this.urls || {})[key];
    }
  }, {
    key: "InitializePage",
    value: function InitializePage() {
      var myThis = this;
      myThis.InitProfilePortfolio();
      myThis.InitProfileGrowthChartSection();
    }
  }, {
    key: "InitPorfilePeriodsStatsSection",
    value: function InitPorfilePeriodsStatsSection() {
      var type = $("#periods-stats-account-type-select").val();
      this.InitPorfilePeriods(type);
    }
  }, {
    key: "InitProfileGrowthChartSection",
    value: function InitProfileGrowthChartSection() {
      var type = $("#profit-chart-account-type-select").val();
      this.DrawProfileGrowthChart(type);
    }
  }, {
    key: "DrawProfileGrowthChart",
    value: function DrawProfileGrowthChart(type) {
      var myThis = this;
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('ProfileGrowthChartLink') + '?id=' + myThis.cbfProfileId + '&portfolioId=' + myThis.portfolioId,
        type: "GET",
        data: {
          type: type
        },
        success: function success(res) {
          var options = {
            chart: {
              type: 'line',
              height: 400
            },
            series: res.series,
            xaxis: {
              type: 'datetime'
            },
            stroke: {
              width: 1,
              curve: 'smooth'
            },
            markers: {
              size: 0
            },
            yaxis: {
              forceNiceScale: false,
              labels: {
                formatter: function formatter(value) {
                  return myThis.helper.ToPercent(value);
                }
              }
            }
          };
          if (!myThis.growthChart) {
            myThis.growthChart = new ApexCharts(document.querySelector("#cbf-profile-growth-chart"), options);
            myThis.growthChart.render();
          } else {
            myThis.growthChart.updateOptions(options);
          }
        }
      });
    }
  }, {
    key: "InitProfilePortfolio",
    value: function InitProfilePortfolio() {
      var myThis = this;
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('ProfileStatisticsLink') + '?id=' + myThis.cbfProfileId + '&portfolioId=' + myThis.portfolioId,
        type: "GET",
        success: function success(res, textStatus, xhr) {
          if (xhr.status == 204) {
            $("#cbf-portfolio-account-stats-summary").html(window.portfolioStrings['NoAccounts']);
            $("#cbf-portfolio-period-stats").html(window.portfolioStrings['NoData']);
          } else {
            myThis.portfolioInfo = res;
            myThis.PopulateBasicInfo(res);
            myThis.PopulateAccountStatsSummary(res, 'real');
            myThis.PopulateAccountStatsSummary(res, 'demo');
            myThis.InitPorfilePeriodsStatsSection();
          }
        },
        error: function error(e) {
          $(".portfolio-pane").html("<span class=\"not-found\">".concat(window.portfolioStrings['OopsThatPageCanTBeFound'], "</span>"));
        }
      });
    }
  }, {
    key: "InitPorfilePeriods",
    value: function InitPorfilePeriods(type) {
      var myThis = this;
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('ProfilePeriodStatisticsLink') + '?id=' + myThis.cbfProfileId + '&portfolioId=' + myThis.portfolioId,
        type: "GET",
        data: {
          type: type
        },
        success: function success(res, textStatus, xhr) {
          if (xhr.status == 204) {
            $("#cbf-portfolio-period-stats").html('');
            $("#cbf-portfolio-period-stats-section").css('display', 'none');
          } else {
            myThis.PopulatePeriodsStatsSummary(res);
            myThis.UpdateAllValuesByRiskFactorAndCurrency(myThis);
          }
        },
        error: function error(e) {
          $(".portfolio-pane").html("<span class=\"not-found\">".concat(window.portfolioStrings['OopsThatPageCanTBeFound'], "</span>"));
        }
      });
    }
  }, {
    key: "PopulateBasicInfo",
    value: function PopulateBasicInfo(res) {
      var myThis = this;
      if (this.currentRiskFactor == null) {
        this.currentRiskFactor = res.riskFactor;
        if (!this.currentRiskFactor) this.currentRiskFactor = 1;
        $("#risk-factor").val(this.currentRiskFactor);
      } else {
        this.currentRiskFactor = $("#risk-factor").val();
      }
      if (!res.isPortfolio && !res.portfolioName) {
        res.portfolioName = res.publicName;
      }
      $("#trading-accounts-page-title").html(res.portfolioName);
      $("head title").html(res.portfolioName);
      if (res !== null && res !== void 0 && res.owner) {
        $("#portfolio-setting").css("display", "flex");
        if ((res === null || res === void 0 ? void 0 : res.isPublic) === false) $("#portfolio-private").css("visibility", "visible");else $("#portfolio-private").css("visibility", "hidden");
        $("#add-trading-account-link").css("display", "block");
      } else {
        $("#portfolio-setting").css("display", "none");
      }
      //  if (res.isPortfolio) {
      var langSlug = "";
      if (window.CURRENT_LANG != 'en') langSlug += "/" + window.CURRENT_LANG;
      var breadcrumb = "<a class=\"breadcrumb-item\" href=\"".concat(langSlug, "/\">").concat(window.portfolioStrings['Home'], "</a>");
      breadcrumb += "<a class=\"breadcrumb-item\" href = \"".concat(langSlug, "/performances\" >").concat(window.portfolioStrings['Performances'], "</a >");
      if (res.owner) {
        breadcrumb += "<a class=\"breadcrumb-item\" href=\"".concat(langSlug, "/trading-accounts?scid=").concat(res.cbfProfileId, "\">").concat(window.portfolioStrings['MyPerformances'], "</a>");
      } else {
        breadcrumb += "<a class=\"breadcrumb-item\" href=\"".concat(langSlug, "/trading-accounts?scid=").concat(res.cbfProfileId, "\">").concat(res.publicName, "</a>");
      }
      if (res.portfolioName != res.publicName) breadcrumb += "<span class=\"breadcrumb-item\">".concat(res.portfolioName, "</span>");
      $("#site-breadcrumb").html(breadcrumb);
      //} else {
      //    $("#site-breadcrumb").html('');
      //}

      if (myThis.totalsCurrency == null) {
        myThis.totalsCurrency = res.defaultTotalCurrency;
        if (!myThis.totalsCurrency) myThis.totalsCurrency = "USD";
        if ($(".infinite-select-wrap #periods-currency-select-list").length > 0) {
          $("#periods-currency-select-list").infiniteselect('val', myThis.totalsCurrency);
        } else {
          $("#periods-currency-select-list").infiniteselect({
            types: [{
              option: 'all',
              text: window.portfolioStrings['All']
            }, {
              option: 'forex',
              text: window.portfolioStrings['Forex']
            }, {
              option: 'crypto',
              text: window.portfolioStrings['Crypto']
            }],
            url: '/api/widgets/currencies',
            placeholder: 'Select a currency',
            "default": res.defaultTotalCurrency,
            showDescription: true,
            culture: window.CURRENT_LANG,
            btnClass: 'browser-default frn-override'
          });
          document.getElementById('periods-currency-select-list').addEventListener('change', function () {
            var targetCurrency = $("#periods-currency-select-list").infiniteselect('val');
            myThis.totalsCurrency = targetCurrency;
            myThis.UpdateAllValuesByRiskFactorAndCurrency(myThis);
          });
        }
      }
    }
  }, {
    key: "PopulateAccountStatsSummary",
    value: function PopulateAccountStatsSummary(data, type) {
      var myThis = this;
      var table = '<table class="statistics-table row-border-table">';
      table += '<tr>';
      if (data.owner) {
        table += '<td></td>';
      }
      table += "<td>".concat(window.portfolioStrings['Name'], "</td>");
      table += "<td>".concat(window.portfolioStrings['Portfolios'], "</td>");
      if (data.owner) {
        table += "<td>".concat(window.portfolioStrings['AccountNumber'], "</td>");
      }
      if (data.owner) {
        table += "<td>".concat(window.portfolioStrings['Private'], "</td>");
      }
      table += "<td>".concat(window.portfolioStrings['Connected'], "</td>") + "<td>".concat(window.portfolioStrings['Equity'], "</td>") + "<td>".concat(window.portfolioStrings['OpenProfit'], "</td>") + "<td>".concat(window.portfolioStrings['Balance'], "</td>") + "<td>".concat(window.portfolioStrings['Profit'], "</td>") + "<td>".concat(window.portfolioStrings['ProfitPercent'], "</td>") + "<td>".concat(window.portfolioStrings['PeakDrawdown'], "</td>") + "<td>".concat(window.portfolioStrings['MonthlyProfitPercent'], "</td>") + "<td>".concat(window.portfolioStrings['Currency'], "</td>") + "<td>".concat(window.portfolioStrings['BrokerString'], "</td>") + "<td>".concat(window.portfolioStrings['TradingPlatform'], "</td>") + "</tr>";
      if (data.showTotal) {
        var totalSummary = data.realTotalSummary;
        if (type == "demo") totalSummary = data.demoTotalSummary;
        if (!!totalSummary && !!totalSummary.accountCurrency) {
          table += '<tr>';
          if (data.owner) {
            table += "<td></td>";
          }
          table += "<td><span class=\"bold\">".concat(window.portfolioStrings['Total'], "</span></td>") + '<td></td>';
          if (data.owner) {
            table += '<td></td>' + '<td></td>';
          }
          table += '<td>' + '</td>' + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-sum=\"".concat(totalSummary.deposits + totalSummary.withdrawals, "\" data-mul=\"").concat(totalSummary.profit + totalSummary.openProfit, "\" data-currency=\"").concat(totalSummary.accountCurrency, "\">").concat(myThis.helper.ToDecimal(totalSummary.equity), "</td>") + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-sum=\"0\" data-mul=\"".concat(totalSummary.openProfit, "\" data-currency=\"").concat(totalSummary.accountCurrency, "\">").concat(myThis.helper.ToDecimal(totalSummary.openProfit), "</td>") + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-sum=\"".concat(totalSummary.deposits + totalSummary.withdrawals, "\" data-mul=\"").concat(totalSummary.profit, "\"  data-currency=\"").concat(totalSummary.accountCurrency, "\">").concat(myThis.helper.ToDecimal(totalSummary.balance), "</td>") + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-sum=\"0\" data-mul=\"".concat(totalSummary.profit, "\" data-currency=\"").concat(totalSummary.accountCurrency, "\">").concat(myThis.helper.ToDecimal(totalSummary.profit), "</td>") + "<td data-update=\"risk-factor\" data-type=\"percent\" data-sum=\"0\" data-mul=\"".concat(totalSummary.profitPercent, "\">").concat(myThis.helper.ToPercent(totalSummary.profitPercent), "</td>") + "<td data-update=\"risk-factor\" data-type=\"percent\" data-sum=\"0\" data-mul=\"".concat(totalSummary.drawDown, "\" data-zerostr=\"--\">").concat(myThis.helper.ToPercent(totalSummary.drawDown, false, '--'), "</td>") + "<td data-update=\"risk-factor\" data-type=\"percent\" data-sum=\"0\" data-mul=\"".concat(totalSummary.monthlyProfit, "\">").concat(myThis.helper.ToPercent(totalSummary.monthlyProfit), "</td>") + '<td data-update="currency">' + totalSummary.accountCurrency + '</td>' + '<td>' + '</td>' + '<td>' + '</td>' + '</tr>';
        }
      }
      var accountStatsSummaries = [];
      if (type == 'real') accountStatsSummaries = data.realAccountStatSummaries;else accountStatsSummaries = data.demoAccountStatSummaries;
      var langSlug = '';
      if (window.CURRENT_LANG != 'en') langSlug = '/' + window.CURRENT_LANG;
      var _iterator = _createForOfIteratorHelper(accountStatsSummaries),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;
          table += '<tr>';
          if (data.owner) {
            table += '<td>' + '<a class="d-flex justify-content-center" href="javascript:void(0);" onclick = "OpenEditMt4AccontDialog(' + (element === null || element === void 0 ? void 0 : element.aisAccountId) + ')"><i class="mdi mdi-settings" /></a>' + '</td>';
          }
          table += "<td><a href=\"".concat(langSlug, "/trading-account?said=").concat(element === null || element === void 0 ? void 0 : element.aisAccountId, "\">").concat(element === null || element === void 0 ? void 0 : element.name, "</a></td>");
          table += '<td><div class="portfolios-field">';
          if (!!(element !== null && element !== void 0 && element.portfolios) && Array.isArray(element === null || element === void 0 ? void 0 : element.portfolios)) {
            element.portfolios.forEach(function (x) {
              return table += "<a href= \"".concat(langSlug, "/trading-accounts?scid=").concat(myThis.cbfProfileId, "&spid=").concat(x.id, "\">").concat(x.portfolioName, "</a>");
            });
          }
          table += '</div></td>';
          if (data.owner) {
            table += '<td>' + element.accountNumber + '</td>';
          }
          if (data.owner) {
            table += '<td>' + (element !== null && element !== void 0 && element.isPublic ? '' : '<i class="mdi mdi-lock" >') + '</td>';
          }
          table += '<td>' + myThis.helper.ToStatus(element.lastUpdated, element.hasError) + '</td>' + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-sum=\"".concat(element.deposits + element.withdrawals, "\" data-mul=\"").concat(element.profit + element.openProfit, "\">").concat(myThis.helper.ToDecimal(element.equity), "</td>") + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-sum=\"0\" data-mul=\"".concat(element.openProfit, "\">").concat(myThis.helper.ToDecimal(element.openProfit), "</td>") + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-sum=\"".concat(element.deposits + element.withdrawals, "\" data-mul=\"").concat(element.profit, "\">").concat(myThis.helper.ToDecimal(element.balance), "</td>") + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-sum=\"0\" data-mul=\"".concat(element.profit, "\">").concat(myThis.helper.ToDecimal(element.profit), "</td>") + "<td data-update=\"risk-factor\" data-type=\"percent\" data-sum=\"0\" data-mul=\"".concat(element.profitPercent, "\">").concat(myThis.helper.ToPercent(element.profitPercent), "</td>") + "<td data-update=\"risk-factor\" data-type=\"percent\" data-sum=\"0\" data-mul=\"".concat(element.drawDown, "\">").concat(myThis.helper.ToPercent(element.drawDown), "</td>") + "<td data-update=\"risk-factor\" data-type=\"percent\" data-sum=\"0\" data-mul=\"".concat(element.monthlyProfit, "\">").concat(myThis.helper.ToPercent(element.monthlyProfit), "</td>") + "<td>".concat(element.accountCurrency, "</td>") + "<td>".concat(element.broker, "</td>") + "<td>".concat(element.platformType, "</td>") + '</tr>';
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      table += '</table>';
      $("#cbf-portfolio-account-stats-summary-" + type).html(table);
      InitializeScrollTable("#cbf-portfolio-account-stats-summary-" + type + " table");
      $('[data-toggle="tooltip"]').tooltip('dispose').tooltip({
        boundary: 'window'
      });
    }
  }, {
    key: "PopulatePeriodsStatsSummary",
    value: function PopulatePeriodsStatsSummary(data) {
      var _stat$today, _stat$today2, _stat$today$gainTWR, _stat$today3, _stat$today4, _stat$today$gainTWR2, _stat$today5, _stat$today6, _stat$today7, _stat$today8, _stat$today9, _stat$today10, _stat$today11, _stat$today12, _stat$thisWeek, _stat$thisWeek2, _stat$thisWeek$gainTW, _stat$thisWeek3, _stat$thisWeek4, _stat$thisWeek$gainTW2, _stat$thisWeek5, _stat$thisWeek6, _stat$thisWeek7, _stat$thisWeek8, _stat$thisWeek9, _stat$thisWeek10, _stat$thisWeek11, _stat$thisWeek12, _stat$thisMonth, _stat$thisMonth2, _stat$thisMonth$gainT, _stat$thisMonth3, _stat$thisMonth4, _stat$thisMonth$gainT2, _stat$thisMonth5, _stat$thisMonth6, _stat$thisMonth7, _stat$thisMonth8, _stat$thisMonth9, _stat$thisMonth10, _stat$thisMonth11, _stat$thisMonth12, _stat$thisYear, _stat$thisYear2, _stat$thisYear$gainTW, _stat$thisYear3, _stat$thisYear4, _stat$thisYear$gainTW2, _stat$thisYear5, _stat$thisYear6, _stat$thisYear7, _stat$thisYear8, _stat$thisYear9, _stat$thisYear10, _stat$thisYear11, _stat$thisYear12;
      var myThis = this;
      var stat = data;
      var table = '<table class="statistics-table row-border-table">';
      table += '<tr>' + '<td></td>' + "<td>".concat(window.portfolioStrings['ProfitPercent'], "</td>") + "<td><span class=\"dotted-border-bottom\" data-toggle=\"tooltip\" data-title=\"".concat(window.portfolioStrings['TimeWeightedCalculationEliminatesTheDistortingEffectsOfDepositsAndWithdrawals'], "\">").concat(window.portfolioStrings['ProfitPercent'], ", <i class=\"mdi mdi-clock\"></i></span></td>") + "<td>".concat(window.portfolioStrings['Profit'], "</td>") + "<td>".concat(window.portfolioStrings['WinPercent'], "</td>") + "<td>".concat(window.portfolioStrings['Trades'], "</td>") + "<td>".concat(window.portfolioStrings['Volume'], "</td>") + "<td>".concat(window.portfolioStrings['Currency'], "</td>") + '</tr>';
      table += '<tr>' + "<td>".concat(window.portfolioStrings['Today'], "</td>") + "<td data-update=\"risk-factor\" data-type=\"percent\" data-format data-sum=\"0\" data-mul=\"".concat((_stat$today = stat.today) === null || _stat$today === void 0 ? void 0 : _stat$today.gain, "\">").concat(myThis.helper.ToPercent((_stat$today2 = stat.today) === null || _stat$today2 === void 0 ? void 0 : _stat$today2.gain, true), "</td>") + "<td data-update=\"risk-factor\" data-type=\"percent\" data-format data-sum=\"0\" data-mul=\"".concat((_stat$today$gainTWR = (_stat$today3 = stat.today) === null || _stat$today3 === void 0 ? void 0 : _stat$today3.gainTWR) !== null && _stat$today$gainTWR !== void 0 ? _stat$today$gainTWR : (_stat$today4 = stat.today) === null || _stat$today4 === void 0 ? void 0 : _stat$today4.gain, "\">").concat(myThis.helper.ToPercent((_stat$today$gainTWR2 = (_stat$today5 = stat.today) === null || _stat$today5 === void 0 ? void 0 : _stat$today5.gainTWR) !== null && _stat$today$gainTWR2 !== void 0 ? _stat$today$gainTWR2 : (_stat$today6 = stat.today) === null || _stat$today6 === void 0 ? void 0 : _stat$today6.gain, true), "</td>") + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-format data-sum=\"0\" data-mul=\"".concat((_stat$today7 = stat.today) === null || _stat$today7 === void 0 ? void 0 : _stat$today7.profit, "\" data-currency=\"").concat(stat.currency, "\">").concat(myThis.helper.ToDecimal((_stat$today8 = stat.today) === null || _stat$today8 === void 0 ? void 0 : _stat$today8.profit, true), "</td>") + "<td>".concat(myThis.helper.ToPercent((_stat$today9 = stat.today) === null || _stat$today9 === void 0 ? void 0 : _stat$today9.winPercentage), "</td>") + "<td>".concat(myThis.helper.ToIntNumber((_stat$today10 = stat.today) === null || _stat$today10 === void 0 ? void 0 : _stat$today10.trades), "</td>") + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-sum=\"0\" data-mul=\"".concat((_stat$today11 = stat.today) === null || _stat$today11 === void 0 ? void 0 : _stat$today11.lots, "\">").concat(myThis.helper.ToDecimal((_stat$today12 = stat.today) === null || _stat$today12 === void 0 ? void 0 : _stat$today12.lots), "</td>") + "<td data-update=\"currency\">".concat(stat.currency, "</td>") + "</tr>";
      table += '<tr>' + "<td>".concat(window.portfolioStrings['ThisWeek'], "</td>") + "<td data-update=\"risk-factor\" data-type=\"percent\" data-format data-sum=\"0\" data-mul=\"".concat((_stat$thisWeek = stat.thisWeek) === null || _stat$thisWeek === void 0 ? void 0 : _stat$thisWeek.gain, "\">").concat(myThis.helper.ToPercent((_stat$thisWeek2 = stat.thisWeek) === null || _stat$thisWeek2 === void 0 ? void 0 : _stat$thisWeek2.gain, true), "</td>") + "<td data-update=\"risk-factor\" data-type=\"percent\" data-format data-sum=\"0\" data-mul=\"".concat((_stat$thisWeek$gainTW = (_stat$thisWeek3 = stat.thisWeek) === null || _stat$thisWeek3 === void 0 ? void 0 : _stat$thisWeek3.gainTWR) !== null && _stat$thisWeek$gainTW !== void 0 ? _stat$thisWeek$gainTW : (_stat$thisWeek4 = stat.thisWeek) === null || _stat$thisWeek4 === void 0 ? void 0 : _stat$thisWeek4.gain, "\">").concat(myThis.helper.ToPercent((_stat$thisWeek$gainTW2 = (_stat$thisWeek5 = stat.thisWeek) === null || _stat$thisWeek5 === void 0 ? void 0 : _stat$thisWeek5.gainTWR) !== null && _stat$thisWeek$gainTW2 !== void 0 ? _stat$thisWeek$gainTW2 : (_stat$thisWeek6 = stat.thisWeek) === null || _stat$thisWeek6 === void 0 ? void 0 : _stat$thisWeek6.gain, true), "</td>") + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-format data-sum=\"0\" data-mul=\"".concat((_stat$thisWeek7 = stat.thisWeek) === null || _stat$thisWeek7 === void 0 ? void 0 : _stat$thisWeek7.profit, "\" data-currency=\"").concat(stat.currency, "\">").concat(myThis.helper.ToDecimal((_stat$thisWeek8 = stat.thisWeek) === null || _stat$thisWeek8 === void 0 ? void 0 : _stat$thisWeek8.profit, true), "</td>") + "<td>".concat(myThis.helper.ToPercent((_stat$thisWeek9 = stat.thisWeek) === null || _stat$thisWeek9 === void 0 ? void 0 : _stat$thisWeek9.winPercentage), "</td>") + "<td>".concat(myThis.helper.ToIntNumber((_stat$thisWeek10 = stat.thisWeek) === null || _stat$thisWeek10 === void 0 ? void 0 : _stat$thisWeek10.trades), "</td>") + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-sum=\"0\" data-mul=\"".concat((_stat$thisWeek11 = stat.thisWeek) === null || _stat$thisWeek11 === void 0 ? void 0 : _stat$thisWeek11.lots, "\">").concat(myThis.helper.ToDecimal((_stat$thisWeek12 = stat.thisWeek) === null || _stat$thisWeek12 === void 0 ? void 0 : _stat$thisWeek12.lots), "</td>") + "<td data-update=\"currency\">".concat(stat.currency, "</td>") + '</tr>';
      table += '<tr>' + "<td>".concat(window.portfolioStrings['ThisMonth'], "</td>") + "<td data-update=\"risk-factor\" data-type=\"percent\" data-format data-sum=\"0\" data-mul=\"".concat((_stat$thisMonth = stat.thisMonth) === null || _stat$thisMonth === void 0 ? void 0 : _stat$thisMonth.gain, "\">").concat(myThis.helper.ToPercent((_stat$thisMonth2 = stat.thisMonth) === null || _stat$thisMonth2 === void 0 ? void 0 : _stat$thisMonth2.gain, true), "</td>") + "<td data-update=\"risk-factor\" data-type=\"percent\" data-format data-sum=\"0\" data-mul=\"".concat((_stat$thisMonth$gainT = (_stat$thisMonth3 = stat.thisMonth) === null || _stat$thisMonth3 === void 0 ? void 0 : _stat$thisMonth3.gainTWR) !== null && _stat$thisMonth$gainT !== void 0 ? _stat$thisMonth$gainT : (_stat$thisMonth4 = stat.thisMonth) === null || _stat$thisMonth4 === void 0 ? void 0 : _stat$thisMonth4.gain, "\">").concat(myThis.helper.ToPercent((_stat$thisMonth$gainT2 = (_stat$thisMonth5 = stat.thisMonth) === null || _stat$thisMonth5 === void 0 ? void 0 : _stat$thisMonth5.gainTWR) !== null && _stat$thisMonth$gainT2 !== void 0 ? _stat$thisMonth$gainT2 : (_stat$thisMonth6 = stat.thisMonth) === null || _stat$thisMonth6 === void 0 ? void 0 : _stat$thisMonth6.gain, true), "</td>") + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-format data-sum=\"0\" data-mul=\"".concat((_stat$thisMonth7 = stat.thisMonth) === null || _stat$thisMonth7 === void 0 ? void 0 : _stat$thisMonth7.profit, "\" data-currency=\"").concat(stat.currency, "\">").concat(myThis.helper.ToDecimal((_stat$thisMonth8 = stat.thisMonth) === null || _stat$thisMonth8 === void 0 ? void 0 : _stat$thisMonth8.profit, true), "</td>") + "<td>".concat(myThis.helper.ToPercent(stat === null || stat === void 0 || (_stat$thisMonth9 = stat.thisMonth) === null || _stat$thisMonth9 === void 0 ? void 0 : _stat$thisMonth9.winPercentage), "</td>") + "<td>".concat(myThis.helper.ToIntNumber(stat === null || stat === void 0 || (_stat$thisMonth10 = stat.thisMonth) === null || _stat$thisMonth10 === void 0 ? void 0 : _stat$thisMonth10.trades), "</td>") + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-sum=\"0\" data-mul=\"".concat((_stat$thisMonth11 = stat.thisMonth) === null || _stat$thisMonth11 === void 0 ? void 0 : _stat$thisMonth11.lots, "\">").concat(myThis.helper.ToDecimal((_stat$thisMonth12 = stat.thisMonth) === null || _stat$thisMonth12 === void 0 ? void 0 : _stat$thisMonth12.lots), "</td>") + "<td data-update=\"currency\">".concat(stat.currency, "</td>") + '</tr>';
      table += '<tr>' + "<td>".concat(window.portfolioStrings['ThisYear'], "</td>") + "<td data-update=\"risk-factor\" data-type=\"percent\" data-format data-sum=\"0\" data-mul=\"".concat((_stat$thisYear = stat.thisYear) === null || _stat$thisYear === void 0 ? void 0 : _stat$thisYear.gain, "\">").concat(myThis.helper.ToPercent((_stat$thisYear2 = stat.thisYear) === null || _stat$thisYear2 === void 0 ? void 0 : _stat$thisYear2.gain, true), "</td>") + "<td data-update=\"risk-factor\" data-type=\"percent\" data-format data-sum=\"0\" data-mul=\"".concat((_stat$thisYear$gainTW = (_stat$thisYear3 = stat.thisYear) === null || _stat$thisYear3 === void 0 ? void 0 : _stat$thisYear3.gainTWR) !== null && _stat$thisYear$gainTW !== void 0 ? _stat$thisYear$gainTW : (_stat$thisYear4 = stat.thisYear) === null || _stat$thisYear4 === void 0 ? void 0 : _stat$thisYear4.gain, "\">").concat(myThis.helper.ToPercent((_stat$thisYear$gainTW2 = (_stat$thisYear5 = stat.thisYear) === null || _stat$thisYear5 === void 0 ? void 0 : _stat$thisYear5.gainTWR) !== null && _stat$thisYear$gainTW2 !== void 0 ? _stat$thisYear$gainTW2 : (_stat$thisYear6 = stat.thisYear) === null || _stat$thisYear6 === void 0 ? void 0 : _stat$thisYear6.gain, true), "</td>") + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-format data-sum=\"0\" data-mul=\"".concat((_stat$thisYear7 = stat.thisYear) === null || _stat$thisYear7 === void 0 ? void 0 : _stat$thisYear7.profit, "\" data-currency=\"").concat(stat.currency, "\">").concat(myThis.helper.ToDecimal((_stat$thisYear8 = stat.thisYear) === null || _stat$thisYear8 === void 0 ? void 0 : _stat$thisYear8.profit, true), "</td>") + "<td>".concat(myThis.helper.ToPercent((_stat$thisYear9 = stat.thisYear) === null || _stat$thisYear9 === void 0 ? void 0 : _stat$thisYear9.winPercentage), "</td>") + "<td>".concat(myThis.helper.ToIntNumber((_stat$thisYear10 = stat.thisYear) === null || _stat$thisYear10 === void 0 ? void 0 : _stat$thisYear10.trades), "</td>") + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-sum=\"0\" data-mul=\"".concat((_stat$thisYear11 = stat.thisYear) === null || _stat$thisYear11 === void 0 ? void 0 : _stat$thisYear11.lots, "\">").concat(myThis.helper.ToDecimal((_stat$thisYear12 = stat.thisYear) === null || _stat$thisYear12 === void 0 ? void 0 : _stat$thisYear12.lots), "</td>") + "<td data-update=\"currency\">".concat(stat.currency, "</td>") + '</tr>';
      for (var i = (stat === null || stat === void 0 || (_stat$yearlyStats = stat.yearlyStats) === null || _stat$yearlyStats === void 0 ? void 0 : _stat$yearlyStats.length) - 1; i >= 0; i--) {
        var _stat$yearlyStats;
        if (new Date(stat === null || stat === void 0 ? void 0 : stat.yearlyStats[i].date).getUTCFullYear() != new Date().getUTCFullYear()) {
          table += '<tr>' + "<td>".concat(new Date(stat === null || stat === void 0 ? void 0 : stat.yearlyStats[i].date).getUTCFullYear(), "</td>") + "<td data-update=\"risk-factor\" data-type=\"percent\" data-format data-sum=\"0\" data-mul=\"".concat(stat.yearlyStats[i].gainPercent, "\">").concat(myThis.helper.ToPercent(stat.yearlyStats[i].gainPercent, true), "</td>") + "<td data-update=\"risk-factor\" data-type=\"percent\" data-format data-sum=\"0\" data-mul=\"".concat(stat.yearlyStats[i].gainPercentTWR, "\">").concat(myThis.helper.ToPercent(stat.yearlyStats[i].gainPercentTWR, true), "</td>") + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-format data-sum=\"0\" data-mul=\"".concat(stat.yearlyStats[i].profit, "\" data-currency=\"").concat(stat.currency, "\">").concat(myThis.helper.ToDecimal(stat.yearlyStats[i].profit, true), "</td>") + "<td>".concat(myThis.helper.ToPercent((stat === null || stat === void 0 ? void 0 : stat.yearlyStats[i].winTradeCount) / (stat === null || stat === void 0 ? void 0 : stat.yearlyStats[i].tradeCount)), "</td>") + "<td>".concat(myThis.helper.ToIntNumber(stat === null || stat === void 0 ? void 0 : stat.yearlyStats[i].tradeCount), "</td>") + "<td data-update=\"risk-factor\" data-type=\"decimal\" data-sum=\"0\" data-mul=\"".concat(stat.yearlyStats[i].lots, "\">").concat(myThis.helper.ToDecimal(stat.yearlyStats[i].lots), "</td>") + "<td data-update=\"currency\">".concat(stat.currency, "</td>") + '</tr>';
        }
      }
      table += '</table>';
      $("#cbf-portfolio-period-stats").html(table);
      $("#cbf-portfolio-period-stats-section").css('display', 'block');
      InitializeScrollTable("#cbf-portfolio-period-stats table");
    }
  }, {
    key: "OpenPortfolioSettingsDialog",
    value: function OpenPortfolioSettingsDialog() {
      $("#PortfolioName").val(this.portfolioInfo.portfolioName);
      $("#PortfolioRiskFactor").val(this.portfolioInfo.riskFactor);
      $("#PortfolioDefaultCurreny").infiniteselect('val', this.portfolioInfo.defaultTotalCurrency);
      if (this.portfolioId == 0) {
        $("#PortfolioIsPublic").prop('checked', true);
        $("#PortfolioIsPublic").prop('disabled', true);
        $("#edit-portfolio-dialog-delete-button").hide();
      } else {
        $("#PortfolioIsPublic").prop('checked', this.portfolioInfo.isPublic);
        $("#PortfolioIsPublic").prop('disabled', false);
        $("#edit-portfolio-dialog-delete-button").show();
      }
      $("#PortfolioBalance").prop('checked', this.portfolioInfo.showBalance);
      $("#PortfolioTotal").prop('checked', this.portfolioInfo.showTotal);
      $("#edit-portfolio-dialog-add-control").hide();
      $("#edit-portfolio-dialog-update-control").show();
      $("#portfolio-setting-dialog").modal('show');
    }
  }, {
    key: "OpenCreatePortfolioDialog",
    value: function OpenCreatePortfolioDialog() {
      $("#PortfolioName").val('');
      $("#PortfolioRiskFactor").val(1);
      $("#PortfolioDefaultCurreny").infiniteselect('val', '');
      $("#PortfolioIsPublic").prop('checked', false);
      $("#PortfolioIsPublic").prop('disabled', false);
      $("#PortfolioBalance").prop('checked', false);
      $("#PortfolioTotal").prop('checked', false);
      $("#edit-portfolio-dialog-update-control").hide();
      $("#edit-portfolio-dialog-add-control").show();
      $("#portfolio-setting-dialog").modal('show');
    }
  }, {
    key: "GetDataFromPortfolioSettingForm",
    value: function GetDataFromPortfolioSettingForm() {
      var data = {};
      data['Id'] = this.portfolioId;
      data['PortfolioName'] = $("#PortfolioName").val();
      data['IsPublic'] = $("#PortfolioIsPublic").prop('checked');
      data['ShowBalance'] = $("#PortfolioBalance").prop('checked');
      data['ShowTotals'] = $("#PortfolioTotal").prop('checked');
      data['RiskFactor'] = $("#PortfolioRiskFactor").val();
      data['DefaultTotalCurrency'] = $("#PortfolioDefaultCurreny").val();
      return data;
    }
  }, {
    key: "UpdatePortfolio",
    value: function UpdatePortfolio() {
      var myThis = this;
      var data = myThis.GetDataFromPortfolioSettingForm();
      $("#portfolio-setting-dialog-progress").show();
      $("#broker-list-loading").show();
      myThis.currentRiskFactor = null;
      myThis.totalsCurrency = null;
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('PortfoliosLink') + '/' + myThis.portfolioId,
        type: 'PUT',
        data: JSON.stringify(data),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: function success(res) {
          myThis.InitializePage();
          toastr.success("Your portfolio is successfully updated!");
        },
        error: function error() {
          toastr.error("Failed to save portfolio settings! Please try again later.");
        },
        complete: function complete() {
          $("#portfolio-setting-dialog-progress").hide();
          $("#portfolio-setting-dialog").modal('hide');
          $("#broker-list-loading").hide();
        }
      });
    }
  }, {
    key: "CreatePortfolio",
    value: function CreatePortfolio() {
      var myThis = this;
      var data = myThis.GetDataFromPortfolioSettingForm();
      $("#portfolio-setting-dialog-progress").show();
      $("#broker-list-loading").show();
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('PortfoliosLink'),
        type: 'POST',
        data: JSON.stringify(data),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: function success() {
          toastr.success("Your portfolio is successfully created!");
        },
        error: function error() {
          toastr.error("Failed to create your portfolio! Please try again later.");
        },
        complete: function complete() {
          $("#portfolio-setting-dialog-progress").hide();
          $("#portfolio-setting-dialog").modal('hide');
          $("#broker-list-loading").hide();
        }
      });
    }
  }, {
    key: "OpenDeletePortfolioDialog",
    value: function OpenDeletePortfolioDialog() {
      $("#delete-portfolio-confirm-dialog").modal('show');
    }
  }, {
    key: "DeletePortfolio",
    value: function DeletePortfolio() {
      var myThis = this;
      $("#broker-list-loading").show();
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('PortfoliosLink') + '/' + myThis.portfolioId,
        type: 'DELETE',
        success: function success() {
          toastr.success("Your portfolio is successfully deleted!");
          if (window.location.pathname.endsWith("/" + myThis.portfolioId)) {
            var newUrl = window.location.pathname.substr(0, window.location.pathname.length - ("/" + myThis.portfolioId).length);
            window.history.replaceState({
              path: newUrl
            }, '', newUrl);
          }
          myThis.portfolioId = 0;
          myThis.InitializePage();
        },
        error: function error() {
          toastr.error("Failed to delete your portfolio! Please try again later.");
        },
        complete: function complete() {
          $("#broker-list-loading").hide();
        }
      });
    }
  }, {
    key: "ApplyRiskFactor",
    value: function ApplyRiskFactor(riskFactor) {
      var myThis = this;
      riskFactor = parseFloat(riskFactor);
      if (!!riskFactor) {
        myThis.currentRiskFactor = riskFactor;
        myThis.UpdateAllValuesByRiskFactorAndCurrency(myThis);
      }
    }
  }, {
    key: "UpdateAllValuesByRiskFactorAndCurrency",
    value: function UpdateAllValuesByRiskFactorAndCurrency(myThis) {
      var currencies = new Set();
      $('[data-currency]').each(function (index, item) {
        if (!!$(item).data('currency')) {
          currencies.add($(item).data('currency'));
        }
      });
      var promises = [];
      $("#broker-list-loading").show();
      currencies.forEach(function (x) {
        if (!myThis.currencyRates[x]) myThis.currencyRates[x] = new Object();
        if (!myThis.currencyRates[x][myThis.totalsCurrency]) {
          var promise = window.CalculatorHelper.GetExchangeRateAsync(x, myThis.totalsCurrency);
          promise.then(function (res) {
            myThis.currencyRates[x][myThis.totalsCurrency] = res.rate;
          });
          promises.push(promise);
        }
      });
      Promise.all(promises).then(function () {
        $("#broker-list-loading").hide();
        $('[data-update="risk-factor"]').each(function (index, item) {
          var newValue;
          if ($(item).data('mul') == "undefined") {
            newValue = undefined;
          } else {
            newValue = $(item).data('sum') + $(item).data('mul') * myThis.currentRiskFactor;
          }
          if (!!$(item).data("currency")) {
            newValue = newValue * myThis.currencyRates[$(item).data("currency")][myThis.totalsCurrency];
          }
          var format = $(item).data("format") !== undefined;
          var zeroStr = $(item).data("zerostr");
          if ($(item).data('type') == "percent") {
            if (zeroStr) $(item).html(myThis.helper.ToPercent(newValue, format, zeroStr));else $(item).html(myThis.helper.ToPercent(newValue, format));
          } else {
            if (zeroStr) $(item).html(myThis.helper.ToDecimal(newValue, format, zeroStr));else $(item).html(myThis.helper.ToDecimal(newValue, format));
          }
        });
        $('[data-update="currency"]').html(myThis.totalsCurrency);
      });
    }
  }]);
  return AISPortfolio;
}();
var _default = AISPortfolio;
exports["default"] = _default;

},{}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _AISHelper = _interopRequireDefault(require("./AISHelper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var AISStatistics = /*#__PURE__*/function () {
  function AISStatistics(aisRoot, aisDataRoot) {
    _classCallCheck(this, AISStatistics);
    var urlParam = new URLSearchParams(location.search);
    if (urlParam.get('said')) this.aisAccountId = urlParam.get('said');
    this.aisRoot = aisRoot;
    this.aisDataRoot = aisDataRoot;
    this.statistics = {};
    this.equityChartZoomed = false;
    this.urls = {
      StatisticsLink: '/api/v1/mt/statistics',
      StatsHub: '/stats-hub',
      AddStatsHubLink: '/add-stats-hub',
      ProfitChartLink: '/api/v1/mt/statistics/chart/profit',
      EquityChartLink: '/api/v1/mt/statistics/chart/equity',
      EquityDetailChartLink: '/api/v1/mt/statistics/chart/equity-exact',
      OpenProfitChartLink: '/api/v1/mt/statistics/chart/open-profit',
      OpenProfitPercentChartLink: '/api/v1/mt/statistics/chart/open-profit-percent',
      ProfileDrawdownChartLink: '/api/v1/mt/statistics/chart/drawdown',
      ProfileBalanceChartLink: '/api/v1/mt/statistics/chart/balance',
      ProfileGrowthChartLink: '/api/v1/mt/statistics/chart/profit-percent',
      ProfileMonthlyChartLink: '/api/v1/mt/statistics/monthly-analytics-chart',
      ProfileAdvancedSummaryChartLink: '/api/v1/mt/statistics/advanced-symbol-chart',
      ProfileAdvancedPeriodChartLink: '/api/v1/mt/statistics/advanced-period-chart',
      ProfileAdvancedDurationChartLink: '/api/v1/mt/statistics/advanced-duration-chart',
      ProfileAdvancedMAEMFEChartLink: '/api/v1/mt/statistics/advanced-mae-mfe-chart',
      ProfileTradingActivityOpenTradesLink: '/api/v1/mt/trades/open',
      ProfileTradingActivityOpenOrdersLink: '/api/v1/mt/trades/open-order',
      ProfileTradingActivityHistoryLink: '/api/v1/mt/trades/history',
      ProfileTradingActivityExcludedLink: '/api/v1/mt/trades/excluded',
      ProfileTradingActivityExposureLink: '/api/v1/mt/trades/exposure',
      ProfileMonthlyAnalyticsLink: '/api/v1/mt/statistics/monthly-analytics-chart',
      ProfileMonthlyAnalyticsDetailLink: '/api/v1/mt/statistics/monthly-analytics-detail-chart'
    };
    this.customUrls = {
      StatisticsLink: '/api/v1/mt/custom/statistics',
      StatsHub: '/stats-hub',
      AddStatsHubLink: '/add-stats-hub',
      ProfitChartLink: '/api/v1/mt/custom/statistics/chart/profit',
      EquityChartLink: '/api/v1/mt/custom/statistics/chart/equity',
      OpenProfitChartLink: '/api/v1/mt/custom/statistics/chart/open-profit',
      OpenProfitPercentChartLink: '/api/v1/mt/custom/statistics/chart/open-profit-percent',
      ProfileDrawdownChartLink: '/api/v1/mt/custom/statistics/chart/drawdown',
      ProfileBalanceChartLink: '/api/v1/mt/custom/statistics/chart/balance',
      ProfileGrowthChartLink: '/api/v1/mt/custom/statistics/chart/profit-percent',
      ProfileMonthlyChartLink: '/api/v1/mt/custom/statistics/monthly-analytics-chart',
      ProfileAdvancedSummaryChartLink: '/api/v1/mt/custom/statistics/advanced-symbol-chart',
      ProfileAdvancedPeriodChartLink: '/api/v1/mt/custom/statistics/advanced-period-chart',
      ProfileAdvancedDurationChartLink: '/api/v1/mt/custom/statistics/advanced-duration-chart',
      ProfileAdvancedMAEMFEChartLink: '/api/v1/mt/custom/statistics/advanced-mae-mfe-chart',
      ProfileTradingActivityOpenTradesLink: '/api/v1/mt/custom/trades/open',
      ProfileTradingActivityOpenOrdersLink: '/api/v1/mt/custom/trades/open-order',
      ProfileTradingActivityHistoryLink: '/api/v1/mt/custom/trades/history',
      ProfileTradingActivityExcludedLink: '/api/v1/mt/custom/trades/excluded',
      ProfileTradingActivityExposureLink: '/api/v1/mt/custom/trades/exposure',
      ProfileMonthlyAnalyticsLink: '/api/v1/mt/custom/statistics/monthly-analytics-chart',
      ProfileMonthlyAnalyticsDetailLink: '/api/v1/mt/custom/statistics/monthly-analytics-detail-chart',
      UpdateCustomOptionsLink: '/api/v1/mt/custom/statistics/update-custom-options'
    };
    this.usingUrls = this.urls;
    this.currentChart = 'profit-percent';
    this.defaultChart = 'profit-percent';
    this.helper = new _AISHelper["default"]();
    this.apexCharts = {};
    this.tradingActivitySortParam = {};
    this.accountInfo = {};
    this.customOptions = {};
    this.timeOffset = 0;
    this.chartOptionHtmls = {
      'advanced-hourly': "<div class=\"multi-column-menu-3\">\n                        <div>\n                            <div class=\"form-check\">\n                                <input class=\"form-check-input\" type=\"radio\" name=\"VsType\" id=\"VsType-wl\" value=\"winvslos\" checked>\n                                <label class=\"form-check-label\" for=\"VsType-wl\">".concat(window.statsStrings['WinnersVsLosers'], "</label>\n                            </div>\n                            <div class=\"form-check\">\n                                <input class=\"form-check-input\" type=\"radio\" name=\"VsType\" id=\"VsType-ls\" value=\"longvsshort\">\n                                <label class=\"form-check-label\" for=\"VsType-ls\">").concat(window.statsStrings['LongsVsShorts'], "</label>\n                            </div>\n                            <div class=\"form-check\">\n                                <input class=\"form-check-input\" type=\"radio\" name=\"VsType\" id=\"VsType-lsp\" value=\"longpvsshortp\">\n                                <label class=\"form-check-label\" for=\"VsType-lsp\">").concat(window.statsStrings['LongsProfitVsShortsProfit'], "</label>\n                            </div>\n                            <div class=\"form-check\">\n                                <input class=\"form-check-input\" type=\"radio\" name=\"VsType\" id=\"VsType-wlp\" value=\"winpvslosp\">\n                                <label class=\"form-check-label\" for=\"VsType-wlp\">").concat(window.statsStrings['WinnersProfitVsLosersLosses'], "</label>\n                            </div>\n                        </div>\n                        <div class=\"horizontal-separator\"></div>\n                        <div>\n                            <div class=\"form-check\">\n                                <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-pips\" value=\"pips\" disabled>\n                                <label class=\"form-check-label\" for=\"UnitType-pips\">").concat(window.statsStrings['Pips'], "</label>\n                            </div>\n                            <div class=\"form-check\">\n                                <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-gain\" value=\"gain\" disabled>\n                                <label class=\"form-check-label\" for=\"UnitType-gain\">").concat(window.statsStrings['ProfitPercent'], "</label>\n                            </div>\n                            <div class=\"form-check\">\n                                <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-profit\" value=\"profit\" disabled checked>\n                                <label class=\"form-check-label\" for=\"UnitType-profit\">").concat(window.statsStrings['Profit'], "</label>\n                            </div>\n                        </div>\n                    </div>\n                    <span class=\"chart-description\">").concat(window.statsStrings['CalculatedBasedOnClosedTrades'], "</span>"),
      'monthly-profit': "<div class=\"d-flex\">\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-percent\" value=\"percent\" checked=\"\">\n                            <label class=\"form-check-label\" for=\"UnitType-percent\">".concat(window.statsStrings['ProfitPercent'], "</label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-pips\" value=\"pips\">\n                            <label class=\"form-check-label\" for=\"UnitType-pips\">").concat(window.statsStrings['Pips'], "</label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-profit\" value=\"profit\">\n                            <label class=\"form-check-label\" for=\"UnitType-profit\">").concat(window.statsStrings['Profit'], "</label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-lots\" value=\"lots\">\n                            <label class=\"form-check-label\" for=\"UnitType-lots\">").concat(window.statsStrings['Volume'], "</label>\n                        </div>\n                    </div>\n                    <span class=\"chart-description\">").concat(window.statsStrings['CalculatedBasedOnEquityWhenEquityDataIsAvailable'], "</span>"),
      'monthly-profit-twr': "<div class=\"d-flex\">\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-percent\" value=\"percent-twr\" checked=\"\">\n                            <label class=\"form-check-label\" for=\"UnitType-percent\">".concat(window.statsStrings['ProfitPercent'], ", <i class=\"mdi mdi-clock\"></i></label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-pips\" value=\"pips\">\n                            <label class=\"form-check-label\" for=\"UnitType-pips\">").concat(window.statsStrings['Pips'], "</label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-profit\" value=\"profit\">\n                            <label class=\"form-check-label\" for=\"UnitType-profit\">").concat(window.statsStrings['Profit'], "</label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-lots\" value=\"lots\">\n                            <label class=\"form-check-label\" for=\"UnitType-lots\">").concat(window.statsStrings['Volume'], "</label>\n                        </div>\n                    </div>\n                    <span class=\"chart-description\">").concat(window.statsStrings['CalculatedBasedOnEquityWhenEquityDataIsAvailable'], "</span>"),
      'closed-monthly-profit-twr': "<div class=\"d-flex\">\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-percent\" value=\"percent-twr\" checked=\"\">\n                            <label class=\"form-check-label\" for=\"UnitType-percent\">".concat(window.statsStrings['ProfitPercent'], ", <i class=\"mdi mdi-clock\"></i></label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-pips\" value=\"pips\">\n                            <label class=\"form-check-label\" for=\"UnitType-pips\">").concat(window.statsStrings['Pips'], "</label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-profit\" value=\"profit\">\n                            <label class=\"form-check-label\" for=\"UnitType-profit\">").concat(window.statsStrings['Profit'], "</label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-lots\" value=\"lots\">\n                            <label class=\"form-check-label\" for=\"UnitType-lots\">").concat(window.statsStrings['Volume'], "</label>\n                        </div>\n                    </div>\n                    <span class=\"chart-description\">").concat(window.statsStrings['CalculatedBasedOnClosedTrades'], "</span>"),
      'closed-monthly-profit': "<div class=\"d-flex\">\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-percent\" value=\"percent\" checked=\"\">\n                            <label class=\"form-check-label\" for=\"UnitType-percent\">".concat(window.statsStrings['ProfitPercent'], "</label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-pips\" value=\"pips\">\n                            <label class=\"form-check-label\" for=\"UnitType-pips\">").concat(window.statsStrings['Pips'], "</label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-profit\" value=\"profit\">\n                            <label class=\"form-check-label\" for=\"UnitType-profit\">").concat(window.statsStrings['Profit'], "</label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-lots\" value=\"lots\">\n                            <label class=\"form-check-label\" for=\"UnitType-lots\">").concat(window.statsStrings['Volume'], "</label>\n                        </div>\n                    </div>\n                    <span class=\"chart-description\">").concat(window.statsStrings['CalculatedBasedOnClosedTrades'], "</span>"),
      'drawdown': "<div class=\"d-flex\">\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-percent\" value=\"percent\" checked=\"\">\n                            <label class=\"form-check-label\" for=\"UnitType-percent\">".concat(window.statsStrings['Percent'], "</label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-pips\" value=\"pips\">\n                            <label class=\"form-check-label\" for=\"UnitType-pips\">").concat(window.statsStrings['Pips'], "</label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-profit\" value=\"profit\">\n                            <label class=\"form-check-label\" for=\"UnitType-profit\">").concat(window.statsStrings['Money'], "</label>\n                        </div>\n                    </div>\n                    <span class=\"chart-description\">").concat(window.statsStrings['CalculatedBasedOnEquityWhenEquityDataIsAvailable'], "</span>"),
      'balance': "<span class=\"chart-description\">".concat(window.statsStrings['BalanceCalculatedBasedOnClosedTrades'], "</span>"),
      'advanced-maemfe': "<div class=\"multi-column-menu-3\">\n                        <div>\n                            <div class=\"form-check\">\n                                <input class=\"form-check-input\" type=\"radio\" name=\"VsType\" id=\"VsType-mat\" value=\"maevsoutcome\" checked>\n                                <label class=\"form-check-label\" for=\"VsType-mat\">".concat(window.statsStrings['MAEVsTradeOutcome'], "</label>\n                            </div>\n                            <div class=\"form-check\">\n                                <input class=\"form-check-input\" type=\"radio\" name=\"VsType\" id=\"VsType-mft\" value=\"mfevsoutcome\">\n                                <label class=\"form-check-label\" for=\"VsType-mft\">").concat(window.statsStrings['MFEVsTradeOutcome'], "</label>\n                            </div>\n                            <div class=\"form-check\">\n                                <input class=\"form-check-input\" type=\"radio\" name=\"VsType\" id=\"VsType-maf\" value=\"maevsmfe\">\n                                <label class=\"form-check-label\" for=\"VsType-maf\">").concat(window.statsStrings['MAEVsMFEWinnersVsLosers'], "</label>\n                            </div>\n                        </div>\n                        <div class=\"horizontal-separator\"></div>\n                        <div>\n                            <div class=\"form-check\">\n                                <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-pips\" value=\"pips\" checked>\n                                <label class=\"form-check-label\" for=\"UnitType-pips\">").concat(window.statsStrings['Pips'], "</label>\n                            </div>\n                            <div class=\"form-check\">\n                                <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-gain\" value=\"gain\">\n                                <label class=\"form-check-label\" for=\"UnitType-gain\">").concat(window.statsStrings['Percent'], "</label>\n                            </div>\n                            <div class=\"form-check\">\n                                <input class=\"form-check-input\" type=\"radio\" name=\"UnitType\" id=\"UnitType-profit\" value=\"profit\">\n                                <label class=\"form-check-label\" for=\"UnitType-profit\">").concat(window.statsStrings['Money'], "</label>\n                            </div>\n                        </div>\n                    </div>\n                    <span class=\"chart-description\">").concat(window.statsStrings['CalculatedBasedOnClosedTrades'], "</span>"),
      'profit-percent': "<span class=\"chart-description\">".concat(window.statsStrings['CalculatedBasedOnEquityWhenEquityDataIsAvailable'], "</span>"),
      'profit': "<span class=\"chart-description\">".concat(window.statsStrings['CalculatedBasedOnEquityWhenEquityDataIsAvailable'], "</span>"),
      'closed-profit': "<span class=\"chart-description\">".concat(window.statsStrings['CalculatedBasedOnClosedTrades'], "</span>"),
      'equity': "<span class=\"chart-description\">".concat(window.statsStrings['EquityChartMessage'], "</span>"),
      'open-profit': "<span class=\"chart-description\">".concat(window.statsStrings['CalculatedBasedOnEquityWhenEquityDataIsAvailable'], "</span>"),
      'open-profit-percent': "<span class=\"chart-description\">".concat(window.statsStrings['CalculatedBasedOnEquityWhenEquityDataIsAvailable'], "</span>"),
      'profit-percent-twr': "<span class=\"chart-description\">".concat(window.statsStrings['CalculatedBasedOnEquityWhenEquityDataIsAvailable'], "</span>"),
      'closed-profit-percent-twr': "<span class=\"chart-description\">".concat(window.statsStrings['CalculatedBasedOnClosedTrades'], "</span>")
    };
    this.chartOptionHtmls['advanced-daily'] = this.chartOptionHtmls['advanced-hourly'];
    this.chartOptionHtmls['advanced-duration'] = this.chartOptionHtmls['monthly-profit'];
    this.ajaxNum = 0;
    this.customAnalysisLoaded = false;
  }
  _createClass(AISStatistics, [{
    key: "InitializeEventTriggers",
    value: function InitializeEventTriggers() {
      var myThis = this;
      $(document).on('click', '[data-trigger=drawchart]', function () {
        var $this = $(this);
        var chart = $this.data("chart");
        myThis.DrawSummaryChart($this, chart);
      });
      $(document).on('change', '#profile-summary-chart-options input', function () {
        myThis.UpdateSummaryChart();
      });
      $(document).on("change", "input[data-trigger=draw-symbol-summary-chart]", function (e) {
        var tr = $(this).closest('tr');
        var symbol = $(tr).data('id').split('-')[1];
        myThis.DrawAdvancedStatSummaryChart(symbol);
      });
      $(document).on('click', "#monthly-analytics-tablist li a", function () {
        var $this = $(this);
        var year = $this.data('year');
        var type = $("input[name=monthly-analytics-chart-type]:checked").val();
        myThis.DrawMonthlyAnalyticsChart('monthly-analytics-chart', type, year, true);
      });
      $(document).on('change', "input[name=monthly-analytics-chart-type]", function (e) {
        var type = $("input[name=monthly-analytics-chart-type]:checked").val();
        var year = $("#monthly-analytics-tablist li a.active").data('year');
        myThis.DrawMonthlyAnalyticsChart('monthly-analytics-chart', type, year, false);
      });
      $(document).on('change', 'input#periodEquitySwitch', function () {
        if (document.querySelector("#periodEquitySwitch").checked) {
          var _myThis$statistics, _myThis$statistics2;
          myThis.PopulateTradingPeriods((_myThis$statistics = myThis.statistics) === null || _myThis$statistics === void 0 ? void 0 : _myThis$statistics.balanceBasicStats, (_myThis$statistics2 = myThis.statistics) === null || _myThis$statistics2 === void 0 ? void 0 : _myThis$statistics2.yearlyStats);
          $("#periodStatDescription").html(window.statsStrings['CalculatedBasedOnClosedTrades']);
        } else {
          var _myThis$statistics3, _myThis$statistics4;
          myThis.PopulateTradingPeriods((_myThis$statistics3 = myThis.statistics) === null || _myThis$statistics3 === void 0 ? void 0 : _myThis$statistics3.equityBasicStats, (_myThis$statistics4 = myThis.statistics) === null || _myThis$statistics4 === void 0 ? void 0 : _myThis$statistics4.yearlyStats);
          $("#periodStatDescription").html(window.statsStrings['CalculatedBasedOnClosedAndOpenTrades']);
        }
      });
      $(document).on('click', 'td.sort[data-sort-param]', function (e) {
        var $this = $(this);
        var selector = $this.data("id");
        var leftOffset = $(selector + " .tablescroll-wrap").scrollLeft();
        var dir = "asce";
        if ($this.hasClass("asce")) dir = "desc";else dir = "asce";
        $(selector + " td.sort[data-sort-param]").removeClass("asce");
        $(selector + " td.sort[data-sort-param]").removeClass("desc");
        $this.addClass(dir);
        myThis.tradingActivitySortParam[selector] = {
          sortParam: $this.data("sort-param"),
          sortOrder: dir
        };
        window.APIHelper.GetAccessTokenAsync().then(function () {
          $(selector).pagination($(selector).pagination('getSelectedPageNum'));
          $(selector).addHook('afterPaging', function () {
            $(selector + " .tablescroll-wrap").scrollLeft(leftOffset);
          });
        });
      });
      $(document).on('click', '[data-toggle="summary-chart"]', function () {
        var symbol = $(this).data('symbol');
        if (!$('#advanced-stats-summary-tab tr[data-id="' + myThis.aisAccountId + '-' + symbol + '"]').is(":hidden")) {
          $('#advanced-stats-summary-tab tr[data-id="' + myThis.aisAccountId + '-' + symbol + '"] td div.advanced-summary-chart').html(window.statsStrings['LoadingData']);
        }
        if ($('#advanced-stats-summary-tab tr[data-id="' + myThis.aisAccountId + '-' + symbol + '"]').is(":hidden")) {
          myThis.DrawAdvancedStatSummaryChart(symbol);
        }
        $(this).parents().next('.summary-chart-row').toggle();
      });
      $(document).on('click', '#custom-analysis-option-list button', function (e) {
        var $this = $(this);
        var id = $this.attr('id');
        myThis.ChangeCustomAnalysisOptionContent($this, id);
      });
      $(document).on('click', '#custom-analysis-period a', function (e) {
        var $this = $(this);
        $('#custom-analysis-period li').removeClass('active');
        $this.parent().addClass('active');
        var val = $this.attr('name');
        if (val == "-1") {
          var currentDate = new Date();
          currentDate.setDate(currentDate.getDate() + 1);
          var startDate = window.tradeStartDate;
          $('#StartDate').datetimepicker('format', 'YYYY-MM-DD HH:mm');
          $('#StartDate').datetimepicker('date', new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() - 1, 12, 0));
          $('#EndDate').val("");
        } else {
          var stDate = new Date();
          var enDate = new Date();
          enDate.setDate(enDate.getDate() + 1);
          var num = parseInt(val.charAt(0));
          var unit = val.charAt(1);
          switch (unit) {
            case 'D':
              stDate.setDate(stDate.getDate() - num);
              break;
            case 'W':
              stDate.setDate(stDate.getDate() - num * 7);
              break;
            case 'M':
              stDate.setMonth(stDate.getMonth() - num);
              break;
            case 'Y':
              stDate.setFullYear(stDate.getFullYear() - num);
              break;
          }
          $('#StartDate').datetimepicker('format', 'YYYY-MM-DD HH:mm');
          $('#StartDate').datetimepicker('date', stDate);
          $("#EndDate").val("");
        }
      });
      $(document).on('change', '#DurationUnit', function (e) {
        var val = e.target.value;
        $('#DurationUnitSpan').html(" (" + val + ")");
      });
      $(document).on('mouseup touchend', function (e) {
        var container = $('.bootstrap-datetimepicker-widget');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          container.prev().datetimepicker('hide');
        }
      });
      $(document).on('change', '#custom-analysis-form input[name=CustomDeposit]', function (e) {
        var customDeposit = e.target.value;
        if (customDeposit > 10000000 && $('#CustomDepositErrorMessage').hasClass('hide')) {
          $('#CustomDepositErrorMessage').removeClass('hide');
        }
        if (customDeposit <= 10000000 && !$('#CustomDepositErrorMessage').hasClass('hide')) {
          $('#CustomDepositErrorMessage').addClass('hide');
        }
      });
      $(document).on('change', '#custom-analysis-form input[name=RiskFactor]', function (e) {
        var riskFactor = e.target.value;
        if (riskFactor == "") {
          if ($('#RiskFactorEmptyErrorMessage').hasClass('hide')) $('#RiskFactorEmptyErrorMessage').removeClass('hide');
        } else {
          if (!$('#RiskFactorEmptyErrorMessage').hasClass('hide')) $('#RiskFactorEmptyErrorMessage').addClass('hide');
          if (riskFactor == 0 && $('#RiskFactorGreaterThanZeroErrorMessage').hasClass('hide')) {
            $('#RiskFactorGreaterThanZeroErrorMessage').removeClass('hide');
          }
          if (riskFactor > 0 && !$('#RiskFactorGreaterThanZeroErrorMessage').hasClass('hide')) {
            $('#RiskFactorGreaterThanZeroErrorMessage').addClass('hide');
          }
        }
      });
      var statsConnection = new signalR.HubConnectionBuilder().withUrl(myThis.SignalRUrl('StatsHub')).configureLogging(signalR.LogLevel.Warning).withAutomaticReconnect().build();
      statsConnection.start();
      statsConnection.on("UpdateMt4UserStats", function (aisId, state) {
        if (state == "updated" && aisId == myThis.aisAccountId) {
          console.log('Refresh stats page');
          myThis.InitializePage(true);
        }
      });
      var addMt4Connection = new signalR.HubConnectionBuilder().withUrl(myThis.SignalRUrl('AddStatsHubLink')).configureLogging(signalR.LogLevel.Warning).withAutomaticReconnect().build();
      addMt4Connection.start();
      addMt4Connection.on("VerifyMT4Account", function (accountId, state, message) {
        if (accountId == myThis.aisAccountId) {
          if (state == "finish") {
            myThis.InitializePage(true);
            toastr.success(window.statsStrings['YourAccountHasBeenSuccessfullyVerified']);
            $("#edit-trading-account-dialog").modal('hide');
          } else if (state == "error") {
            $("#verificaton-process[data-id=" + accountId + "]").html(window.statsStrings['FailedToVerify']);
            $("#verificaton-process[data-id=" + accountId + "]").removeClass("processing");
            $("#verificaton-process[data-id=" + accountId + "]").addClass("error");
            toastr.error(window.statsStrings['FailedToVerify']);
          } else {
            $("#verificaton-process[data-id=" + accountId + "]").removeClass("error");
            $("#verificaton-process[data-id=" + accountId + "]").removeClass("finish");
            $("#verificaton-process[data-id=" + accountId + "]").addClass("processing");
            $("#verificaton-process[data-id=" + accountId + "]").html(window.statsStrings['ConnectingToAccount']);
          }
        }
      });
    }
  }, {
    key: "Url",
    value: function Url(key) {
      return this.aisRoot + (this.usingUrls || {})[key];
    }
  }, {
    key: "SignalRUrl",
    value: function SignalRUrl(key) {
      return this.aisDataRoot + (this.urls || {})[key];
    }
  }, {
    key: "GetCustomOptions",
    value: function GetCustomOptions() {
      this.customOptions["StartDate"] = $("#custom-analysis-form input[name=StartDate]").val();
      this.customOptions["EndDate"] = $("#custom-analysis-form input[name=EndDate]").val();
      var symbols = new Array();
      $("li[id^=symbols-bool]").each(function (i, v) {
        if (v.querySelector("input").checked) {
          symbols.push(v.querySelector("input").name);
        }
      });
      this.customOptions["Symbols"] = symbols;
      var weekdays = new Array();
      $("li[id^=weekdays-bool]").each(function (i, v) {
        if (v.querySelector("input").checked) {
          weekdays.push(i);
        }
      });
      this.customOptions["Weekdays"] = weekdays;
      var hours = new Array();
      $("li[id^=hours-bool]").each(function (i, v) {
        if (v.querySelector("input").checked) {
          hours.push(i);
        }
      });
      this.customOptions["Hours"] = hours;
      var analyzeBy = new Array();
      $("li[id^=analyzeby-bool]").each(function (i, v) {
        if (v.querySelector("input").checked) {
          analyzeBy.push(v.querySelector("input").name);
        }
      });
      this.customOptions["AnalyzeBy"] = analyzeBy;
      this.customOptions["GainMin"] = $("#custom-analysis-form input[name=gain-min]").val();
      this.customOptions["GainMax"] = $("#custom-analysis-form input[name=gain-max]").val();
      this.customOptions["ProfitMin"] = $("#custom-analysis-form input[name=profit-min]").val();
      this.customOptions["ProfitMax"] = $("#custom-analysis-form input[name=profit-max]").val();
      this.customOptions["DurationMin"] = $("#custom-analysis-form input[name=duration-min]").val();
      this.customOptions["DurationMax"] = $("#custom-analysis-form input[name=duration-max]").val();
      this.customOptions["DurationUnit"] = $("#custom-analysis-form select[name=DurationUnit]").find(":selected").val();
      this.customOptions["PipsMin"] = $("#custom-analysis-form input[name=pips-min]").val();
      this.customOptions["PipsMax"] = $("#custom-analysis-form input[name=pips-max]").val();
      this.customOptions["LotsMin"] = $("#custom-analysis-form input[name=lots-min]").val();
      this.customOptions["LotsMax"] = $("#custom-analysis-form input[name=lots-max]").val();
      var tradeTypes = new Array();
      $("li[id^=tradetypes-bool]").each(function (i, v) {
        if (v.querySelector("input").checked) {
          tradeTypes.push(v.querySelector("input").name);
        }
      });
      this.customOptions["TradeTypes"] = tradeTypes;
      this.customOptions["CustomDeposit"] = $("#custom-analysis-form input[name=CustomDeposit]").val();
      this.customOptions["RiskFactor"] = $("#custom-analysis-form input[name=RiskFactor]").val();
    }
  }, {
    key: "DateToString",
    value: function DateToString(d) {
      var dformat = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join('-') + ' ' + [d.getHours(), d.getMinutes()].join(':');
      return dformat;
    }
  }, {
    key: "ShowLoadingSpin",
    value: function ShowLoadingSpin() {
      if ($("#stat-spinner").length) {
        $(".stat-spinner").show();
      } else {
        $(".main-content-pane").prepend("<div class=\"stat-spinner\" id=\"stat-spinner\">\n                                                <div class=\"loading-spin\" id=\"loading-spin\">\n                                                    <div class=\"loading-dots\">\n                                                        <span class=\"dot dot1\"></span>\n                                                        <span class=\"dot dot2\"></span>\n                                                        <span class=\"dot dot3\"></span>\n                                                        <span class=\"dot dot4\"></span>\n                                                        <span class=\"dot dot5\"></span>\n                                                        <span class=\"dot dot6\"></span>\n                                                        <span class=\"dot dot7\"></span>\n                                                        <span class=\"dot dot8\"></span>\n                                                        <span class=\"dot dot9\"></span>\n                                                    </div>\n                                                    <div class=\"loading-text\">\n                                                        ".concat(window.statsStrings['LoadingSpinText'], "\n                                                    </div>\n                                                </div >\n                                            </div >"));
        window.spinInitialTop = $("#stat-spinner").height() * 9 / 100;
        var screenwidth = window.innerWidth > 0 ? window.innerWidth : screen.width;
        if (screenwidth < 768) {
          window.spinInitialTop = $("#stat-spinner").height() * 4 / 100;
        }
      }
      var top = window.spinInitialTop + $(document).scrollTop();
      if ($(document).scrollTop() > $('header').height()) {
        top -= $('header').height() - 50;
      }
      $('#loading-spin').css('top', top);
      var screenwidth = window.innerWidth > 0 ? window.innerWidth : screen.width;
      $('body').addClass("stop-scrolling");
    }
  }, {
    key: "HideLoadingSpin",
    value: function HideLoadingSpin() {
      $('body').removeClass('stop-scrolling');
      $('.stat-spinner').hide();
    }
  }, {
    key: "ApplyCustomAnalysis",
    value: function ApplyCustomAnalysis() {
      this.ShowLoadingSpin();
      this.usingUrls = this.customUrls;
      this.GetCustomOptions();
      $("#custom-analysis-dialog").modal('hide');
      if (this.IsInitialCustomOptions()) {
        this.ResetAnalysis();
      } else {
        var _this$accountInfo;
        if (this.customOptions["StartDate"] == "" || this.customOptions["StartDate"] == null) {
          this.customOptions["StartDate"] = this.DateToString(window.tradeStartDate);
        }
        if (this.customOptions["EndDate"] == "" || this.customOptions["EndDate"] == null) {
          this.customOptions["EndDate"] = this.DateToString(new Date());
        }
        this.InitializePage();
        $("#periodStatDescription").html(window.statsStrings['CalculatedBasedOnClosedTrades']);
        $('#periodStatDescription').next().hide();
        $('#advancedStatDescription').html(window.statsStrings['CalculatedBasedOnClosedTrades']);
        $("#reset-analysis").removeClass('hide');
        if (!((_this$accountInfo = this.accountInfo) !== null && _this$accountInfo !== void 0 && _this$accountInfo.owner)) {
          $('#partial-history-description').hide();
        }
      }
    }
  }, {
    key: "ClearDate",
    value: function ClearDate(id) {
      $('#' + id).val('');
    }
  }, {
    key: "PinState",
    value: function PinState(method) {
      $("#custom-analysis-dialog").modal('hide');
      $("#broker-list-loading").show();
      if (method == 0) {
        $("#custom-analysis-form")[0].reset();
        $("#custom-analysis-period li a[name=-1]").click();
        if (!$('#unsave-default').hasClass('hide')) $('#unsave-default').addClass("hide");
        if ($('#save-default').hasClass('hide')) $('#save-default').removeClass('hide');
      }
      if (method == 1) {
        if ($('#unsave-default').hasClass('hide')) $('#unsave-default').removeClass("hide");
        if (!$('#save-default').hasClass('hide')) $('#save-default').addClass('hide');
      }
      this.GetCustomOptions();
      this.usingUrls = this.customUrls;
      var myThis = this;
      myThis.customOptions["Period"] = null;
      if (myThis.customOptions["EndDate"] == "") {
        myThis.customOptions["Period"] = $('#custom-analysis-period li.active').text();
      }
      for (var key in myThis.customOptions) {
        if (myThis.customOptions[key] == "") myThis.customOptions[key] = null;
      }
      if (myThis.customOptions["StartDate"] != null) myThis.customOptions["StartDate"] = new Date(myThis.customOptions["StartDate"]);
      if (myThis.customOptions["EndDate"] != null) myThis.customOptions["EndDate"] = new Date(myThis.customOptions["EndDate"]);
      var periodRequest = JSON.stringify(myThis.customOptions);
      if (myThis.IsInitialCustomOptions()) {
        periodRequest = null;
      }
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('UpdateCustomOptionsLink') + "/" + myThis.aisAccountId,
        type: "POST",
        contentType: "application/json",
        data: periodRequest,
        success: function success(res) {
          myThis.ApplyCustomAnalysis();
        },
        error: function error(xhr, statusText) {}
      });
    }
  }, {
    key: "IsInitialCustomOptions",
    value: function IsInitialCustomOptions() {
      var stDate = window.tradeStartDate;
      var enDate = window.tradeEndDate;
      var customStDate = new Date(this.customOptions["StartDate"]);
      var customEnDate = new Date(this.customOptions["EndDate"]);
      if (this.customOptions["StartDate"] == null || this.customOptions["StartDate"] == "") {
        customStDate = stDate;
      }
      if (this.customOptions["EndDate"] == null || this.customOptions["EndDate"] == "") {
        customEnDate = new Date();
      }
      var customSymbolLen = $("#symbol-ul li").length;
      if (customStDate <= stDate && customEnDate >= enDate && (this.customOptions["CustomDeposit"] == "" || this.customOptions["CustomDeposit"] == 0 || this.customOptions["CustomDeposit"] == null) && (this.customOptions["Period"] == null || this.customOptions["Period"] == "All") && this.customOptions["RiskFactor"] == 1 && (this.customOptions["Symbols"] == null || this.customOptions["Symbols"].length == 0 || this.customOptions["Symbols"].length == customSymbolLen) && (this.customOptions["Weekdays"] == null || this.customOptions["Weekdays"].length == 0 || this.customOptions["Weekdays"].length == 7) && (this.customOptions["Hours"] == null || this.customOptions["Hours"].length == 0 || this.customOptions["Hours"].length == 24) && (this.customOptions["GainMin"] == "" || this.customOptions["GainMin"] == null) && (this.customOptions["GainMax"] == "" || this.customOptions["GainMax"] == null) && (this.customOptions["ProfitMin"] == "" || this.customOptions["ProfitMin"] == null) && (this.customOptions["ProfitMax"] == "" || this.customOptions["ProfitMax"] == null) && (this.customOptions["DurationMin"] == "" || this.customOptions["DurationMin"] == null) && (this.customOptions["DurationMax"] == "" || this.customOptions["DurationMax"] == null) && (this.customOptions["PipsMin"] == "" || this.customOptions["PipsMin"] == null) && (this.customOptions["PipsMax"] == "" || this.customOptions["PipsMin"] == null) && (this.customOptions["LotsMin"] == "" || this.customOptions["LotsMin"] == null) && (this.customOptions["LotsMax"] == "" || this.customOptions["LotsMax"] == null) && (this.customOptions["TradeTypes"] == null || this.customOptions["TradeTypes"].length == 0)) {
        return true;
      }
      return false;
    }
  }, {
    key: "ResetAnalysis",
    value: function ResetAnalysis() {
      this.ShowLoadingSpin();
      $("#custom-analysis-form")[0].reset();
      $("#custom-analysis-period li a[name=-1]").click();
      this.customOptions = {};
      this.usingUrls = this.urls;
      this.InitializePage();
      $("#periodStatDescription").html(window.statsStrings['CalculatedBasedOnClosedAndOpenTrades']);
      $('#periodStatDescription').next().show();
      $('#advancedStatDescription').html(window.statsStrings['CalculatedBasedOnClosedAndOpenTrades']);
      $("#reset-analysis").addClass('hide');
    }
  }, {
    key: "InitializePage",
    value: function InitializePage(refresh) {
      var myThis = this;
      InitializeStatsWidget(myThis.aisRoot);
      myThis.InitAccountSummary(refresh);
      if (!refresh) {
        myThis.DrawMonthlyAnalyticsChart('monthly-analytics-chart', 'percent', new Date().getUTCFullYear(), true);
      } else {
        var type = $("input[name=monthly-analytics-chart-type]:checked").val();
        var year = $("#monthly-analytics-tablist li a.active").data('year');
        myThis.DrawMonthlyAnalyticsChart('monthly-analytics-chart', type, year, false);
      }
      myThis.InitializeTradingActivityTable("#trading-activity-history", myThis.Url('ProfileTradingActivityHistoryLink'));
      myThis.InitializeTradingActivityTable("#trading-activity-excluded", myThis.Url('ProfileTradingActivityExcludedLink'));
      $('.nav-pills a').on('shown.bs.tab', function (e) {
        var href = $(this).attr("href");
        $(href + " table").trigger('scroll');
      });
    }
  }, {
    key: "SetPartialAccountHistory",
    value: function SetPartialAccountHistory() {
      var _myThis$accountInfo;
      var myThis = this;
      myThis.customOptions = JSON.parse((_myThis$accountInfo = myThis.accountInfo) === null || _myThis$accountInfo === void 0 ? void 0 : _myThis$accountInfo.customOptions);
      if (!$('#trade-filter').hasClass('hide')) $('#trade-filter').addClass("hide");
      if ($('#partial-history-alert').hasClass('hide')) $('#partial-history-alert').removeClass("hide");
      if ($('#unsave-default').hasClass('hide')) $('#unsave-default').removeClass("hide");
      if (!$('#save-default').hasClass('hide')) $('#save-default').addClass('hide');
      if (myThis.customOptions["Period"] != null && myThis.customOptions["Period"] != "All") {
        var val = myThis.customOptions["Period"];
        $("#custom-analysis-period li a[name=" + val + "]").click();
      } else {
        var flag = 0;
        if (myThis.customOptions["EndDate"] == null) {
          var cDate = new Date();
          cDate.setDate(cDate.getDate() + 1);
          myThis.customOptions["EndDate"] = cDate;
          flag = 1;
        }
        if (myThis.customOptions["StartDate"] == null) {
          myThis.customOptions["StartDate"] = window.tradeStartDate;
        }
        $('#StartDate').datetimepicker('format', 'YYYY-MM-DD HH:mm');
        $('#StartDate').datetimepicker('date', myThis.customOptions["StartDate"]);
        $('#EndDate').datetimepicker('format', 'YYYY-MM-DD HH:mm');
        $('#EndDate').datetimepicker('date', myThis.customOptions["EndDate"]);
        if (flag == 1) $("#EndDate").val("");
      }
      if (myThis.customOptions["Symbols"] == null) myThis.customOptions["Symbols"] = [];
      if (myThis.customOptions["Weekdays"] == null) myThis.customOptions["Weekdays"] = [];
      if (myThis.customOptions["Hours"] == null) myThis.customOptions["Hours"] = [];
      if (myThis.customOptions["AnalyzeBy"] == null) myThis.customOptions["AnalyzeBy"] = [];
      if (myThis.customOptions["TradeTypes"] == null) myThis.customOptions["TradeTypes"] = [];
      myThis.customOptions["Symbols"].forEach(function (symbol) {
        return $("li[id=symbols-bool-" + symbol + "] input[type=checkbox]").prop("checked", true);
      });
      myThis.customOptions["Weekdays"].forEach(function (weekday) {
        return $("li[id=weekdays-bool-" + weekday + "] input[type=checkbox]").prop("checked", true);
      });
      myThis.customOptions["Hours"].forEach(function (hour) {
        return $("li[id=hours-bool-" + hour + "] input[type=checkbox]").prop("checked", true);
      });
      myThis.customOptions["AnalyzeBy"].forEach(function (analyzeBy) {
        return $("li[id=analyzeby-bool-" + analyzeBy + "] input[type=checkbox]").prop("checked", true);
      });
      $("#custom-analysis-form input[name=gain-min]").val(myThis.customOptions["GainMin"]);
      $("#custom-analysis-form input[name=gain-max]").val(myThis.customOptions["GainMax"]);
      $("#custom-analysis-form input[name=profit-min]").val(myThis.customOptions["ProfitMin"]);
      $("#custom-analysis-form input[name=profit-max]").val(myThis.customOptions["ProfitMax"]);
      $("#custom-analysis-form input[name=duration-min]").val(myThis.customOptions["DurationMin"]);
      $("#custom-analysis-form input[name=duration-max]").val(myThis.customOptions["DurationMax"]);
      $("#custom-analysis-form select[name=DurationUnit] option[value=" + myThis.customOptions["DurationUnit"] + "]").prop("selected", true);
      $("#custom-analysis-form input[name=pips-min]").val(myThis.customOptions["PipsMin"]);
      $("#custom-analysis-form input[name=pips-max]").val(myThis.customOptions["PipsMax"]);
      $("#custom-analysis-form input[name=lots-min]").val(myThis.customOptions["LotsMin"]);
      $("#custom-analysis-form input[name=lots-max]").val(myThis.customOptions["LotsMax"]);
      myThis.customOptions["TradeTypes"].forEach(function (tradeType) {
        return $("li[id=tradetypes-bool-" + tradeType + "] input[type=checkbox]").prop("checked", true);
      });
      $("#custom-analysis-form input[name=CustomDeposit]").val(myThis.customOptions["CustomDeposit"]);
      $("#custom-analysis-form input[name=RiskFactor]").val(myThis.customOptions["RiskFactor"]);
      myThis.customOptions["StartDate"] = $("#custom-analysis-form input[name=StartDate]").val();
      myThis.customOptions["EndDate"] = $("#custom-analysis-form input[name=EndDate]").val();
      myThis.ajaxNum++;
      myThis.usingUrls = myThis.customUrls;
      myThis.InitializePage();
      $("#periodStatDescription").html(window.statsStrings['CalculatedBasedOnClosedTrades']);
      $('#periodStatDescription').next().hide();
      $('#advancedStatDescription').html(window.statsStrings['CalculatedBasedOnClosedTrades']);
      $("#reset-analysis").removeClass('hide');
    }
  }, {
    key: "InitAccountSummary",
    value: function InitAccountSummary(refresh) {
      var myThis = this;
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('StatisticsLink') + '/' + myThis.aisAccountId,
        type: "GET",
        data: this.customOptions,
        traditional: true,
        success: function success(res) {
          var _res$statistics, _res$statistics2, _res$statistics3, _res$statistics4, _res$statistics5, _res$statistics6, _res$statistics7, _res$statistics8, _advancedStat;
          myThis.accountInfo = res.accountInfo;
          myThis.HideLoadingSpin();
          if (refresh) {
            var _res$accountInfo;
            if (((_res$accountInfo = res.accountInfo) === null || _res$accountInfo === void 0 ? void 0 : _res$accountInfo.customOptions) != null) {
              if (myThis.customAnalysisLoaded == true) {
                myThis.SetPartialAccountHistory();
                return;
              }
            }
          }
          if ((_res$statistics = res.statistics) !== null && _res$statistics !== void 0 && _res$statistics.hasIncompleteData) {
            $("#incomplete-data-alert").removeClass("hide");
          }
          if (myThis.customAnalysisLoaded == true) {
            if (myThis.IsInitialCustomOptions() == false && Object.keys(myThis.customOptions).length > 0) {
              if (!$('#trade-filter').hasClass('hide')) $('#trade-filter').addClass("hide");
              if ($('#partial-history-alert').hasClass('hide')) $('#partial-history-alert').removeClass("hide");
            } else {
              if ($('#trade-filter').hasClass('hide')) $('#trade-filter').removeClass("hide");
              if (!$('#partial-history-alert').hasClass('hide')) $('#partial-history-alert').addClass("hide");
            }
          }
          if (Math.abs(((_res$statistics2 = res.statistics) === null || _res$statistics2 === void 0 ? void 0 : _res$statistics2.profitPercent) - ((_res$statistics3 = res.statistics) === null || _res$statistics3 === void 0 ? void 0 : _res$statistics3.profitPercentTWR)) <= 1e-7) {
            $(".profile-summary-info .profile-summary-button[data-chart=profit-percent-twr]").remove();
            $('#statistics-charts-dropdown-menu ul li[data-chart=profit-percent-twr]').remove();
          }
          if (Math.abs(((_res$statistics4 = res.statistics) === null || _res$statistics4 === void 0 ? void 0 : _res$statistics4.monthlyProfit) - ((_res$statistics5 = res.statistics) === null || _res$statistics5 === void 0 ? void 0 : _res$statistics5.monthlyProfitTWR)) <= 1e-7) {
            $(".profile-summary-info .profile-summary-button[data-chart=monthly-profit-twr]").remove();
            $('#statistics-charts-dropdown-menu ul li[data-chart=monthly-profit-twr]').remove();
          }
          if (Math.abs(((_res$statistics6 = res.statistics) === null || _res$statistics6 === void 0 ? void 0 : _res$statistics6.closedProfitPercentTWR) - ((_res$statistics7 = res.statistics) === null || _res$statistics7 === void 0 ? void 0 : _res$statistics7.closedProfitPercent)) <= 1e-7) {
            $(".profile-summary-info .profile-summary-button[data-chart=closed-profit-percent-twr]").remove();
            $('#statistics-charts-dropdown-menu ul li[data-chart=closed-profit-percent-twr]').remove();
          }
          if (Object.keys(myThis.customOptions).length > 0 && !myThis.IsInitialCustomOptions()) {
            $(".profile-summary-info .profile-summary-button[data-chart=equity]").hide();
            $('#statistics-charts-dropdown-menu ul li[data-chart=equity]').hide();
            $(".profile-summary-info .profile-summary-button[data-chart=open-profit]").hide();
            $('#statistics-charts-dropdown-menu ul li[data-chart=open-profit]').hide();
            $(".profile-summary-info .profile-summary-button[data-chart=open-profit-percent]").hide();
            $('#statistics-charts-dropdown-menu ul li[data-chart=open-profit-percent]').hide();
          } else {
            $(".profile-summary-info .profile-summary-button[data-chart=equity]").show();
            $('#statistics-charts-dropdown-menu ul li[data-chart=equity]').show();
            $(".profile-summary-info .profile-summary-button[data-chart=open-profit]").show();
            $('#statistics-charts-dropdown-menu ul li[data-chart=open-profit]').show();
            $(".profile-summary-info .profile-summary-button[data-chart=open-profit-percent]").show();
            $('#statistics-charts-dropdown-menu ul li[data-chart=open-profit-percent]').show();
          }
          myThis.timeOffset = ((_res$statistics8 = res.statistics) === null || _res$statistics8 === void 0 ? void 0 : _res$statistics8.timezone) * 60;
          myThis.statistics = res.statistics;
          myThis.InitializeTradingActivityTable("#trading-activity-open-trades", myThis.Url('ProfileTradingActivityOpenTradesLink'));
          myThis.InitializeTradingActivityTable("#trading-activity-open-orders", myThis.Url('ProfileTradingActivityOpenOrdersLink'));
          myThis.InitializePermission();
          myThis.PopualteAccountSummary(res);
          myThis.PullAdditionalAccountInfo(res);
          var profitType = 'equity';
          var basicStat, advancedStat;
          if (profitType == "equity") {
            var _res$statistics9, _res$statistics10;
            basicStat = res === null || res === void 0 || (_res$statistics9 = res.statistics) === null || _res$statistics9 === void 0 ? void 0 : _res$statistics9.equityBasicStats;
            advancedStat = res === null || res === void 0 || (_res$statistics10 = res.statistics) === null || _res$statistics10 === void 0 ? void 0 : _res$statistics10.equityAdvancedStats;
          } else {
            var _res$statistics11, _res$statistics12;
            basicStat = res === null || res === void 0 || (_res$statistics11 = res.statistics) === null || _res$statistics11 === void 0 ? void 0 : _res$statistics11.balanceBasicStats;
            advancedStat = res === null || res === void 0 || (_res$statistics12 = res.statistics) === null || _res$statistics12 === void 0 ? void 0 : _res$statistics12.balanceAdvancedStats;
          }
          if (document.querySelector("#periodEquitySwitch").checked) {
            var _myThis$statistics5, _myThis$statistics6;
            myThis.PopulateTradingPeriods((_myThis$statistics5 = myThis.statistics) === null || _myThis$statistics5 === void 0 ? void 0 : _myThis$statistics5.balanceBasicStats, (_myThis$statistics6 = myThis.statistics) === null || _myThis$statistics6 === void 0 ? void 0 : _myThis$statistics6.yearlyStats);
          } else {
            var _myThis$statistics7, _myThis$statistics8;
            myThis.PopulateTradingPeriods((_myThis$statistics7 = myThis.statistics) === null || _myThis$statistics7 === void 0 ? void 0 : _myThis$statistics7.equityBasicStats, (_myThis$statistics8 = myThis.statistics) === null || _myThis$statistics8 === void 0 ? void 0 : _myThis$statistics8.yearlyStats);
          }
          myThis.PopulateAdvancedTradesStats(res === null || res === void 0 ? void 0 : res.statistics, basicStat);
          myThis.PopulateAdvancedSummaryStats((_advancedStat = advancedStat) === null || _advancedStat === void 0 ? void 0 : _advancedStat.summary);
          if (!refresh) {
            var _myThis$accountInfo2;
            if ((_myThis$accountInfo2 = myThis.accountInfo) !== null && _myThis$accountInfo2 !== void 0 && _myThis$accountInfo2.owner) {
              myThis.defaultChart = 'profit';
            }
            $(".profile-summary-info .profile-summary-button").removeClass("active");
            $(".profile-summary-info .profile-summary-button[data-chart=".concat(myThis.defaultChart, "]")).addClass("active");
            $('#statistics-charts-dropdown-menu ul li').removeClass("active");
            $("#statistics-charts-dropdown-menu ul li[data-chart=".concat(myThis.defaultChart, "]")).addClass("active");
            $("#statistics-charts-dropdown-menu a[data-toggle=dropdown]").html($("#statistics-charts-dropdown-menu ul li[data-chart=".concat(myThis.defaultChart, "]")).html());
            myThis.currentChart = myThis.defaultChart;
            myThis.InitializeSummaryChartOptions(myThis.defaultChart);
          }
          myThis.UpdateSummaryChart();
        },
        error: function error(e) {
          $(".portfolio-profile-detail-pane").html("<span class=\"not-found\">".concat(window.statsStrings['OopsThatPageCanTBeFound'], "</span>"));
        },
        complete: function complete() {
          $("#broker-list-loading").hide();
        }
      });
    }
  }, {
    key: "PullAdditionalAccountInfo",
    value: function PullAdditionalAccountInfo(data) {
      var myThis = this;
      var duration = this.helper.GetDuraction(data.statistics.lastUpdated, new Date());
      var requestData = {
        clientId: data.accountInfo.cbfClientProfileId,
        brokerName: data.accountInfo.brokerServerName,
        currency: data.statistics.accountCurrency
      };
      if (data.isContestAccountStatistics) {
        var _data$contestStatisti;
        requestData.contestId = (_data$contestStatisti = data.contestStatistics) === null || _data$contestStatisti === void 0 ? void 0 : _data$contestStatisti.contestId;
      } else {
        $("#bug-report-alert").show();
      }
      $.ajax({
        url: "/".concat(window.CURRENT_LANG, "/api/trading-account/accountInfo"),
        type: 'GET',
        data: requestData,
        success: function success(res) {
          var _data$accountInfo, _data$accountInfo2, _data$accountInfo3, _data$statistics2, _data$statistics3, _data$statistics4, _data$accountInfo4;
          var accountInfoHtml = '';
          if (data.isContestAccountStatistics) {
            var contestHtml = "<span class=\"dotted-border-bottom\" data-toggle=\"tooltip\" data-title=\"".concat(window.statsStrings['ContestPopover'], "\">").concat(window.statsStrings["Contest"], "</span>");
            accountInfoHtml += "<div class=\"info\">".concat(contestHtml, "</div>");
          } else {
            var _data$statistics;
            var popoverHtml = '';
            if (((_data$statistics = data.statistics) === null || _data$statistics === void 0 ? void 0 : _data$statistics.accountType) == "Real") {
              popoverHtml = "<span class=\"dotted-border-bottom\" data-toggle=\"tooltip\" data-title=\"".concat(window.statsStrings['RealPopover'], "\">").concat(window.statsStrings['Real'], "</span>");
            } else {
              popoverHtml = "<span class=\"dotted-border-bottom\" data-toggle=\"tooltip\" data-title=\"".concat(window.statsStrings['DemoPopover'], "\">").concat(window.statsStrings['Demo'], "</span>");
            }
            accountInfoHtml += "<div class=\"info\">".concat(popoverHtml, "</div>");
          }
          accountInfoHtml += "<a class=\"info\" href=\"".concat(res.BrokerLink, "\">").concat((_data$accountInfo = data.accountInfo) === null || _data$accountInfo === void 0 ? void 0 : _data$accountInfo.brokerServerName, "</a>");
          accountInfoHtml += "<span class=\"info\">".concat(window.statsStrings["LastSync0Ago"].replace("{0}", duration), "</span>");
          accountInfoHtml += "<span class=\"info\">".concat(window.statsStrings["Added0"].replace("{0}", myThis.helper.ToShortDate((_data$accountInfo2 = data.accountInfo) === null || _data$accountInfo2 === void 0 ? void 0 : _data$accountInfo2.added, "short")), "</span>");
          if (data.isContestAccountStatistics) accountInfoHtml += "<span class=\"info\">".concat(window.statsStrings["Started0"].replace("{0}", myThis.helper.ToShortDate(res.ContestStarted, "short")), "</span>");
          accountInfoHtml += "<div class=\"info\"><span class=\"dotted-border-bottom\" data-toggle=\"tooltip\" data-title=\"".concat(window.statsStrings["MaximumAvailableLeverage"], "\">1 : ").concat(data.statistics.accountLeverage, "</span></div>");
          accountInfoHtml += "<div class=\"info\"><span class=\"dotted-border-bottom\" data-toggle=\"tooltip\" data-title=\"".concat(window.statsStrings["TradingPlatform"], "\">").concat((_data$accountInfo3 = data.accountInfo) === null || _data$accountInfo3 === void 0 ? void 0 : _data$accountInfo3.platformType, "</span></div>");
          accountInfoHtml += "<div class=\"info\"><span class=\"dotted-border-bottom\" data-toggle=\"tooltip\" data-title=\"".concat(window.statsStrings["ThisAccountIsDenominatedIn0"].replace("{0}", res.CurrencyName), "\">").concat((_data$statistics2 = data.statistics) === null || _data$statistics2 === void 0 ? void 0 : _data$statistics2.accountCurrency, "</span></div>");
          if (!!((_data$statistics3 = data.statistics) !== null && _data$statistics3 !== void 0 && _data$statistics3.timezone) && !isNaN(parseInt((_data$statistics4 = data.statistics) === null || _data$statistics4 === void 0 ? void 0 : _data$statistics4.timezone))) {
            var _data$statistics5;
            if (((_data$statistics5 = data.statistics) === null || _data$statistics5 === void 0 ? void 0 : _data$statistics5.timezone) >= 0) accountInfoHtml += "<div class=\"info\"><span class=\"dotted-border-bottom\" data-toggle=\"tooltip\" data-title=\"".concat(window.statsStrings["TheTimezoneOfThisAccount"], "\">GMT +").concat(data.statistics.timezone.toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false
            }), ":00</span></div>");else accountInfoHtml += "<div class=\"info\"><span class=\"dotted-border-bottom\" data-toggle=\"tooltip\" data-title=\"".concat(window.statsStrings["TheTimezoneOfThisAccount"], "\">GMT ").concat(data.statistics.timezone.toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false
            }), ":00</span></div>");
          }
          if ((_data$accountInfo4 = data.accountInfo) !== null && _data$accountInfo4 !== void 0 && _data$accountInfo4.showBalance) {
            var _data$statistics6, _data$statistics7;
            accountInfoHtml += "<span class=\"info\">".concat(window.statsStrings['Deposits'], ": ").concat(myThis.helper.ToDecimal((_data$statistics6 = data.statistics) === null || _data$statistics6 === void 0 ? void 0 : _data$statistics6.deposits), "</span>");
            accountInfoHtml += "<span class=\"info\">".concat(window.statsStrings['Withdrawls'], ": ").concat(myThis.helper.ToDecimal((_data$statistics7 = data.statistics) === null || _data$statistics7 === void 0 ? void 0 : _data$statistics7.withdrawls), "</span>");
          }
          $("#account-info").html(accountInfoHtml);
          $("#account-info [data-toggle=tooltip]").tooltip('dispose').tooltip({
            boundary: 'window'
          });
        }
      });
    }
  }, {
    key: "InitializePermission",
    value: function InitializePermission() {
      var _this$accountInfo2, _this$accountInfo3, _this$accountInfo4;
      if (!((_this$accountInfo2 = this.accountInfo) !== null && _this$accountInfo2 !== void 0 && _this$accountInfo2.showBalance)) {
        $("input[name=UnitType][value=profit]").attr("disabled", true);
        $("input[data-trigger=draw-symbol-summary-chart]").attr("disabled", true);
      }
      if (!((_this$accountInfo3 = this.accountInfo) !== null && _this$accountInfo3 !== void 0 && _this$accountInfo3.showVolume)) {
        $("input[name=UnitType][value=lots]").attr("disabled", true);
      }
      if ((_this$accountInfo4 = this.accountInfo) !== null && _this$accountInfo4 !== void 0 && _this$accountInfo4.owner) {
        $("#account-edit-icon").show();
        $("#save-default").show();
        $("#unsave-default").show();
        $("a[data-id=embed-script-copy]").show();
        $("#tab-widgets").show();
        $("#tab-widgets-box").show();
      } else {
        $("#tab-widgets").remove();
        $("#tab-widgets-box").remove();
      }
    }
  }, {
    key: "PopualteAccountSummary",
    value: function PopualteAccountSummary(data) {
      var _data$accountInfo5, _data$accountInfo6, _data$statistics$mont, _data$statistics24, _data$statistics25, _data$statistics$mont2, _data$statistics26, _data$statistics27, _data$statistics$clos, _data$statistics28, _data$statistics29, _stat, _data$accountInfo8;
      var profitType = Object.keys(this.customOptions).length > 0 ? 'balance' : 'equity';
      var stat;
      if (profitType == "equity") {
        var _data$statistics8;
        stat = data === null || data === void 0 || (_data$statistics8 = data.statistics) === null || _data$statistics8 === void 0 ? void 0 : _data$statistics8.equityBasicStats;
      } else {
        var _data$statistics9;
        stat = data === null || data === void 0 || (_data$statistics9 = data.statistics) === null || _data$statistics9 === void 0 ? void 0 : _data$statistics9.balanceBasicStats;
      }
      var langSlug = "";
      if (window.CURRENT_LANG != 'en') langSlug += "/" + window.CURRENT_LANG;
      var breadcrumb = "<a class=\"breadcrumb-item\" href=\"".concat(langSlug, "/\">").concat(window.statsStrings['Home'], "</a>");
      breadcrumb += "<a class=\"breadcrumb-item\" href=\"".concat(langSlug, "/performances\">").concat(window.statsStrings['Performances'], "</a>");
      breadcrumb += "<a class=\"breadcrumb-item\" href=\"".concat(langSlug, "/social-profile/view?scid=").concat(data.accountInfo.cbfClientProfileId, "\">").concat(data.accountInfo.cbfClientPublicName, "</a>");
      breadcrumb += "<span class=\"breadcrumb-item\"> ".concat(data.accountInfo.accountName, "</span >");
      $("#site-breadcrumb").html(breadcrumb);
      $("head title").html(((_data$accountInfo5 = data.accountInfo) === null || _data$accountInfo5 === void 0 ? void 0 : _data$accountInfo5.accountName) + ' ' + window.statsStrings['Statistics']);
      $("#account-name").html((_data$accountInfo6 = data.accountInfo) === null || _data$accountInfo6 === void 0 ? void 0 : _data$accountInfo6.accountName);
      if (!!data.accountInfo.comment) {
        var _data$accountInfo7;
        $("#contest-description").html((_data$accountInfo7 = data.accountInfo) === null || _data$accountInfo7 === void 0 ? void 0 : _data$accountInfo7.comment);
        $("#contest-description").shorten({
          showChars: 200,
          ellipsesText: "...",
          moreText: window.statsStrings["More"],
          lessText: window.statsStrings["Less"]
        });
      } else {
        $("#contest-description").remove();
      }
      if (data.isContestAccountStatistics) {
        var _data$contestStatisti2, _data$contestStatisti3, _data$contestStatisti4, _data$contestStatisti5, _data$contestStatisti6, _data$statistics10, _data$contestStatisti7, _data$statistics11, _data$statistics12, _data$statistics13, _data$contestStatisti8;
        $("#summary-equity").html(this.helper.ToDecimal((_data$contestStatisti2 = data.contestStatistics) === null || _data$contestStatisti2 === void 0 ? void 0 : _data$contestStatisti2.equity));
        $("#summary-balance").html(this.helper.ToDecimal((_data$contestStatisti3 = data.contestStatistics) === null || _data$contestStatisti3 === void 0 ? void 0 : _data$contestStatisti3.balance));
        $("#summary-open-profit").html(this.helper.ToDecimal((_data$contestStatisti4 = data.contestStatistics) === null || _data$contestStatisti4 === void 0 ? void 0 : _data$contestStatisti4.openProfit));
        $("#summary-open-profit-percent").html(this.helper.ToPercent((_data$contestStatisti5 = data.contestStatistics) === null || _data$contestStatisti5 === void 0 ? void 0 : _data$contestStatisti5.openProfitPercent));
        $("#summary-profit").html(this.helper.ToDecimal((_data$contestStatisti6 = data.contestStatistics) === null || _data$contestStatisti6 === void 0 ? void 0 : _data$contestStatisti6.profit));
        $("#summary-closed-profit").html(this.helper.ToDecimal((_data$statistics10 = data.statistics) === null || _data$statistics10 === void 0 ? void 0 : _data$statistics10.closedProfit));
        $("#summary-profit-percent").html(this.helper.ToPercent((_data$contestStatisti7 = data.contestStatistics) === null || _data$contestStatisti7 === void 0 ? void 0 : _data$contestStatisti7.profitPercent));
        $("#summary-closed-profit-percent").html(this.helper.ToPercent((_data$statistics11 = data.statistics) === null || _data$statistics11 === void 0 ? void 0 : _data$statistics11.closedProfitPercent));
        $("#summary-profit-percent-twr").html(this.helper.ToPercent((_data$statistics12 = data.statistics) === null || _data$statistics12 === void 0 ? void 0 : _data$statistics12.profitPercentTWR));
        $("#summary-closed-profit-percent-twr").html(this.helper.ToPercent((_data$statistics13 = data.statistics) === null || _data$statistics13 === void 0 ? void 0 : _data$statistics13.closedProfitPercentTWR));
        if (!!((_data$contestStatisti8 = data.contestStatistics) !== null && _data$contestStatisti8 !== void 0 && _data$contestStatisti8.maxAllowedDD)) {
          var _data$contestStatisti9;
          $("#summary-max-allowed-dd").html(this.helper.ToDecimal((_data$contestStatisti9 = data.contestStatistics) === null || _data$contestStatisti9 === void 0 ? void 0 : _data$contestStatisti9.maxAllowedDD));
          $("#summary-max-allowed-dd-button").show();
        } else {
          $("#summary-max-allowed-dd-button").hide();
        }
      } else {
        var _data$statistics14, _data$statistics15, _data$statistics16, _data$statistics17, _data$statistics18, _data$statistics19, _data$statistics20, _data$statistics21, _data$statistics22, _data$statistics23;
        $("#summary-equity").html(this.helper.ToDecimal((_data$statistics14 = data.statistics) === null || _data$statistics14 === void 0 ? void 0 : _data$statistics14.accountEquity));
        $("#summary-balance").html(this.helper.ToDecimal((_data$statistics15 = data.statistics) === null || _data$statistics15 === void 0 ? void 0 : _data$statistics15.accountBalance));
        $("#summary-open-profit").html(this.helper.ToDecimal((_data$statistics16 = data.statistics) === null || _data$statistics16 === void 0 ? void 0 : _data$statistics16.accountProfit));
        $("#summary-open-profit-percent").html(this.helper.ToPercent((_data$statistics17 = data.statistics) === null || _data$statistics17 === void 0 ? void 0 : _data$statistics17.openProfitPercent));
        $("#summary-profit").html(this.helper.ToDecimal((_data$statistics18 = data.statistics) === null || _data$statistics18 === void 0 ? void 0 : _data$statistics18.profit));
        $("#summary-closed-profit").html(this.helper.ToDecimal((_data$statistics19 = data.statistics) === null || _data$statistics19 === void 0 ? void 0 : _data$statistics19.closedProfit));
        $("#summary-profit-percent").html(this.helper.ToPercent((_data$statistics20 = data.statistics) === null || _data$statistics20 === void 0 ? void 0 : _data$statistics20.profitPercent));
        $("#summary-closed-profit-percent").html(this.helper.ToPercent((_data$statistics21 = data.statistics) === null || _data$statistics21 === void 0 ? void 0 : _data$statistics21.closedProfitPercent));
        $("#summary-profit-percent-twr").html(this.helper.ToPercent((_data$statistics22 = data.statistics) === null || _data$statistics22 === void 0 ? void 0 : _data$statistics22.profitPercentTWR));
        $("#summary-closed-profit-percent-twr").html(this.helper.ToPercent((_data$statistics23 = data.statistics) === null || _data$statistics23 === void 0 ? void 0 : _data$statistics23.closedProfitPercentTWR));
      }
      $("#summary-monthly-percent").html(this.helper.ToPercent((_data$statistics$mont = data === null || data === void 0 || (_data$statistics24 = data.statistics) === null || _data$statistics24 === void 0 ? void 0 : _data$statistics24.monthlyProfit) !== null && _data$statistics$mont !== void 0 ? _data$statistics$mont : data === null || data === void 0 || (_data$statistics25 = data.statistics) === null || _data$statistics25 === void 0 ? void 0 : _data$statistics25.monthlyProfitTWR));
      $("#summary-monthly-percent-twr").html(this.helper.ToPercent((_data$statistics$mont2 = data === null || data === void 0 || (_data$statistics26 = data.statistics) === null || _data$statistics26 === void 0 ? void 0 : _data$statistics26.monthlyProfitTWR) !== null && _data$statistics$mont2 !== void 0 ? _data$statistics$mont2 : data === null || data === void 0 || (_data$statistics27 = data.statistics) === null || _data$statistics27 === void 0 ? void 0 : _data$statistics27.monthlyProfit));
      $("#summary-closed-monthly-percent").html(this.helper.ToPercent((_data$statistics$clos = data === null || data === void 0 || (_data$statistics28 = data.statistics) === null || _data$statistics28 === void 0 ? void 0 : _data$statistics28.closedMonthlyProfitTWR) !== null && _data$statistics$clos !== void 0 ? _data$statistics$clos : data === null || data === void 0 || (_data$statistics29 = data.statistics) === null || _data$statistics29 === void 0 ? void 0 : _data$statistics29.closedMonthlyProfit));
      $("#summary-drawdown").html(this.helper.ToPercent((_stat = stat) === null || _stat === void 0 ? void 0 : _stat.drawDown));
      if ((data === null || data === void 0 || (_data$accountInfo8 = data.accountInfo) === null || _data$accountInfo8 === void 0 ? void 0 : _data$accountInfo8.isVerified) === true) {
        $("#trade-authority-verify-badge").removeClass("not-verified");
        $("#trade-authority-verify-badge").find('span:first-child').html(window.statsStrings['Verified'] + ' ' + window.statsStrings['TradeAuthority']);
        $("#trade-authority-verify-badge").tooltip('dispose');
        $("#trade-authority-verify-badge").data('title', window.statsStrings["TheUserProvedTheyHaveAuthorityToPlaceTradesOnTheAccount"]);
        $("#trade-authority-verify-badge").tooltip();
      }
      $("#trade-authority-verify-badge").css('visibility', 'visible');
    }
  }, {
    key: "PopulateTradingPeriods",
    value: function PopulateTradingPeriods(stat, yearlyStats) {
      var _stat$today$gainTWR, _stat$today, _stat$today2, _stat$today$gain, _stat$today3, _stat$today4, _stat$today5, _stat$today6, _stat$today7, _stat$today8, _stat$thisWeek$gain, _stat$thisWeek, _stat$thisWeek2, _stat$thisWeek$gainTW, _stat$thisWeek3, _stat$thisWeek4, _stat$thisWeek5, _stat$thisWeek6, _stat$thisWeek7, _stat$thisWeek8, _stat$thisMonth$gain, _stat$thisMonth, _stat$thisMonth2, _stat$thisMonth$gainT, _stat$thisMonth3, _stat$thisMonth4, _stat$thisMonth5, _stat$thisMonth6, _stat$thisMonth7, _stat$thisMonth8, _stat$thisYear$gain, _stat$thisYear, _stat$thisYear2, _stat$thisYear$gainTW, _stat$thisYear3, _stat$thisYear4, _stat$thisYear5, _stat$thisYear6, _stat$thisYear7, _stat$thisYear8;
      $('#trading-periods-tab [data-key="today-profit-percentage"]').html(this.helper.ToPercent((_stat$today$gainTWR = stat === null || stat === void 0 || (_stat$today = stat.today) === null || _stat$today === void 0 ? void 0 : _stat$today.gainTWR) !== null && _stat$today$gainTWR !== void 0 ? _stat$today$gainTWR : stat === null || stat === void 0 || (_stat$today2 = stat.today) === null || _stat$today2 === void 0 ? void 0 : _stat$today2.gain));
      $('#trading-periods-tab [data-key="today-profit-percentage-twr"]').html(this.helper.ToPercent((_stat$today$gain = stat === null || stat === void 0 || (_stat$today3 = stat.today) === null || _stat$today3 === void 0 ? void 0 : _stat$today3.gain) !== null && _stat$today$gain !== void 0 ? _stat$today$gain : stat === null || stat === void 0 || (_stat$today4 = stat.today) === null || _stat$today4 === void 0 ? void 0 : _stat$today4.gainTWR));
      $('#trading-periods-tab [data-key="today-profit"]').html(this.helper.ToDecimal(stat === null || stat === void 0 || (_stat$today5 = stat.today) === null || _stat$today5 === void 0 ? void 0 : _stat$today5.profit));
      $('#trading-periods-tab [data-key="today-win-percentage"]').html(this.helper.ToPercent(stat === null || stat === void 0 || (_stat$today6 = stat.today) === null || _stat$today6 === void 0 ? void 0 : _stat$today6.winPercentage));
      $('#trading-periods-tab [data-key="today-trades"]').html(this.helper.ToIntNumber(stat === null || stat === void 0 || (_stat$today7 = stat.today) === null || _stat$today7 === void 0 ? void 0 : _stat$today7.trades));
      $('#trading-periods-tab [data-key="today-lots"]').html(this.helper.ToDecimal(stat === null || stat === void 0 || (_stat$today8 = stat.today) === null || _stat$today8 === void 0 ? void 0 : _stat$today8.lots));
      $('#trading-periods-tab [data-key="week-profit-percentage"]').html(this.helper.ToPercent((_stat$thisWeek$gain = stat === null || stat === void 0 || (_stat$thisWeek = stat.thisWeek) === null || _stat$thisWeek === void 0 ? void 0 : _stat$thisWeek.gain) !== null && _stat$thisWeek$gain !== void 0 ? _stat$thisWeek$gain : stat === null || stat === void 0 || (_stat$thisWeek2 = stat.thisWeek) === null || _stat$thisWeek2 === void 0 ? void 0 : _stat$thisWeek2.gainTWR));
      $('#trading-periods-tab [data-key="week-profit-percentage-twr"]').html(this.helper.ToPercent((_stat$thisWeek$gainTW = stat === null || stat === void 0 || (_stat$thisWeek3 = stat.thisWeek) === null || _stat$thisWeek3 === void 0 ? void 0 : _stat$thisWeek3.gainTWR) !== null && _stat$thisWeek$gainTW !== void 0 ? _stat$thisWeek$gainTW : stat === null || stat === void 0 || (_stat$thisWeek4 = stat.thisWeek) === null || _stat$thisWeek4 === void 0 ? void 0 : _stat$thisWeek4.gain));
      $('#trading-periods-tab [data-key="week-profit"]').html(this.helper.ToDecimal(stat === null || stat === void 0 || (_stat$thisWeek5 = stat.thisWeek) === null || _stat$thisWeek5 === void 0 ? void 0 : _stat$thisWeek5.profit));
      $('#trading-periods-tab [data-key="week-win-percentage"]').html(this.helper.ToPercent(stat === null || stat === void 0 || (_stat$thisWeek6 = stat.thisWeek) === null || _stat$thisWeek6 === void 0 ? void 0 : _stat$thisWeek6.winPercentage));
      $('#trading-periods-tab [data-key="week-trades"]').html(this.helper.ToIntNumber(stat === null || stat === void 0 || (_stat$thisWeek7 = stat.thisWeek) === null || _stat$thisWeek7 === void 0 ? void 0 : _stat$thisWeek7.trades));
      $('#trading-periods-tab [data-key="week-lots"]').html(this.helper.ToDecimal(stat === null || stat === void 0 || (_stat$thisWeek8 = stat.thisWeek) === null || _stat$thisWeek8 === void 0 ? void 0 : _stat$thisWeek8.lots));
      $('#trading-periods-tab [data-key="month-profit-percentage"]').html(this.helper.ToPercent((_stat$thisMonth$gain = stat === null || stat === void 0 || (_stat$thisMonth = stat.thisMonth) === null || _stat$thisMonth === void 0 ? void 0 : _stat$thisMonth.gain) !== null && _stat$thisMonth$gain !== void 0 ? _stat$thisMonth$gain : stat === null || stat === void 0 || (_stat$thisMonth2 = stat.thisMonth) === null || _stat$thisMonth2 === void 0 ? void 0 : _stat$thisMonth2.gainTWR));
      $('#trading-periods-tab [data-key="month-profit-percentage-twr"]').html(this.helper.ToPercent((_stat$thisMonth$gainT = stat === null || stat === void 0 || (_stat$thisMonth3 = stat.thisMonth) === null || _stat$thisMonth3 === void 0 ? void 0 : _stat$thisMonth3.gainTWR) !== null && _stat$thisMonth$gainT !== void 0 ? _stat$thisMonth$gainT : stat === null || stat === void 0 || (_stat$thisMonth4 = stat.thisMonth) === null || _stat$thisMonth4 === void 0 ? void 0 : _stat$thisMonth4.gain));
      $('#trading-periods-tab [data-key="month-profit"]').html(this.helper.ToDecimal(stat === null || stat === void 0 || (_stat$thisMonth5 = stat.thisMonth) === null || _stat$thisMonth5 === void 0 ? void 0 : _stat$thisMonth5.profit));
      $('#trading-periods-tab [data-key="month-win-percentage"]').html(this.helper.ToPercent(stat === null || stat === void 0 || (_stat$thisMonth6 = stat.thisMonth) === null || _stat$thisMonth6 === void 0 ? void 0 : _stat$thisMonth6.winPercentage));
      $('#trading-periods-tab [data-key="month-trades"]').html(this.helper.ToIntNumber(stat === null || stat === void 0 || (_stat$thisMonth7 = stat.thisMonth) === null || _stat$thisMonth7 === void 0 ? void 0 : _stat$thisMonth7.trades));
      $('#trading-periods-tab [data-key="month-lots"]').html(this.helper.ToDecimal(stat === null || stat === void 0 || (_stat$thisMonth8 = stat.thisMonth) === null || _stat$thisMonth8 === void 0 ? void 0 : _stat$thisMonth8.lots));
      $('#trading-periods-tab [data-key="year-profit-percentage"]').html(this.helper.ToPercent((_stat$thisYear$gain = stat === null || stat === void 0 || (_stat$thisYear = stat.thisYear) === null || _stat$thisYear === void 0 ? void 0 : _stat$thisYear.gain) !== null && _stat$thisYear$gain !== void 0 ? _stat$thisYear$gain : stat === null || stat === void 0 || (_stat$thisYear2 = stat.thisYear) === null || _stat$thisYear2 === void 0 ? void 0 : _stat$thisYear2.gainTWR));
      $('#trading-periods-tab [data-key="year-profit-percentage-twr"]').html(this.helper.ToPercent((_stat$thisYear$gainTW = stat === null || stat === void 0 || (_stat$thisYear3 = stat.thisYear) === null || _stat$thisYear3 === void 0 ? void 0 : _stat$thisYear3.gainTWR) !== null && _stat$thisYear$gainTW !== void 0 ? _stat$thisYear$gainTW : stat === null || stat === void 0 || (_stat$thisYear4 = stat.thisYear) === null || _stat$thisYear4 === void 0 ? void 0 : _stat$thisYear4.gain));
      $('#trading-periods-tab [data-key="year-profit"]').html(this.helper.ToDecimal(stat === null || stat === void 0 || (_stat$thisYear5 = stat.thisYear) === null || _stat$thisYear5 === void 0 ? void 0 : _stat$thisYear5.profit));
      $('#trading-periods-tab [data-key="year-win-percentage"]').html(this.helper.ToPercent(stat === null || stat === void 0 || (_stat$thisYear6 = stat.thisYear) === null || _stat$thisYear6 === void 0 ? void 0 : _stat$thisYear6.winPercentage));
      $('#trading-periods-tab [data-key="year-trades"]').html(this.helper.ToIntNumber(stat === null || stat === void 0 || (_stat$thisYear7 = stat.thisYear) === null || _stat$thisYear7 === void 0 ? void 0 : _stat$thisYear7.trades));
      $('#trading-periods-tab [data-key="year-lots"]').html(this.helper.ToDecimal(stat === null || stat === void 0 || (_stat$thisYear8 = stat.thisYear) === null || _stat$thisYear8 === void 0 ? void 0 : _stat$thisYear8.lots));
      $("#trading-periods-tab table tr:nth-child(n+6)").remove();
      var yearlyStatsHtml = '';
      for (var i = 0; i < yearlyStats.length; i++) {
        if (new Date(yearlyStats[i].date).getUTCFullYear() != new Date().getUTCFullYear()) {
          var _yearlyStats$i$gainPe;
          yearlyStatsHtml += '<tr>';
          yearlyStatsHtml += '<td>' + new Date(yearlyStats[i].date).getUTCFullYear() + '</td>';
          yearlyStatsHtml += '<td>' + this.helper.ToPercent(yearlyStats[i].gainPercent) + '</td>';
          yearlyStatsHtml += '<td>' + this.helper.ToPercent((_yearlyStats$i$gainPe = yearlyStats[i].gainPercentTWR) !== null && _yearlyStats$i$gainPe !== void 0 ? _yearlyStats$i$gainPe : yearlyStats[i].gainPercent) + '</td>';
          yearlyStatsHtml += '<td>' + this.helper.ToDecimal(yearlyStats[i].profit) + '</td>';
          yearlyStatsHtml += '<td>' + this.helper.ToPercent(yearlyStats[i].winTradeCount / yearlyStats[i].tradeCount) + '</td>';
          yearlyStatsHtml += '<td>' + this.helper.ToIntNumber(yearlyStats[i].tradeCount) + '</td>';
          yearlyStatsHtml += '<td>' + this.helper.ToDecimal(yearlyStats[i].lots) + '</td>';
          yearlyStatsHtml += '</tr>';
        }
      }
      $("#trading-periods-tab table tbody").append(yearlyStatsHtml);
    }
  }, {
    key: "PopulateAdvancedTradesStats",
    value: function PopulateAdvancedTradesStats(stats, data) {
      var _stats$closedMonthlyP;
      if (!data) return;
      var myThis = this;
      $('#advanced-stats-trades-tab [data-key="trades"]').html(data["trades"]);
      if (data["trades"] == 0) $('#advanced-stats-trades-tab [data-key="profitability"]').html(myThis.helper.ToPercent(0));else $('#advanced-stats-trades-tab [data-key="profitability"]').html(myThis.helper.ToPercent(data["winTrades"] / data["trades"]));
      $('#advanced-stats-trades-tab [data-key="pips"]').html(myThis.helper.ToDecimal(data["pips"]));
      $('#advanced-stats-trades-tab [data-key="averageWin"]').html('<span class="opacity-3">' + myThis.helper.ToDecimal(data["averageWinPips"]) + ' pips</span> ' + myThis.helper.ToDecimal(data["averageWin"]));
      $('#advanced-stats-trades-tab [data-key="averageLoss"]').html('<span class="opacity-3">' + myThis.helper.ToDecimal(data["averageLossPips"]) + ' pips</span> ' + myThis.helper.ToDecimal(data["averageLoss"]));
      $('#advanced-stats-trades-tab [data-key="lots"]').html(myThis.helper.ToDecimal(data["lots"]));
      $('#advanced-stats-trades-tab [data-key="commissions"]').html(myThis.helper.ToDecimal(data["commissions"]));
      if (data["longs"] == 0) $('#advanced-stats-trades-tab [data-key="longsWon"]').html('<span class="opacity-3">' + data["longsWon"] + '/' + data["longs"] + '</span> ' + myThis.helper.ToPercent(0));else $('#advanced-stats-trades-tab [data-key="longsWon"]').html('<span class="opacity-3">' + data["longsWon"] + '/' + data["longs"] + '</span> ' + myThis.helper.ToPercent(data["longsWon"] / data["longs"]));
      if (data["shorts"] == 0) $('#advanced-stats-trades-tab [data-key="shortsWon"]').html('<span class="opacity-3">' + data["shortsWon"] + '/' + data["shorts"] + '</span> ' + myThis.helper.ToPercent(0));else $('#advanced-stats-trades-tab [data-key="shortsWon"]').html('<span class="opacity-3">' + data["shortsWon"] + '/' + data["shorts"] + '</span> ' + myThis.helper.ToPercent(data["shortsWon"] / data["shorts"]));
      $('#advanced-stats-trades-tab [data-key="bestTrade"]').html('<span class="opacity-3">' + myThis.helper.ToShortDate(data["bestTradeDate"], "short") + '</span> ' + myThis.helper.ToDecimal(data["bestTrade"]));
      $('#advanced-stats-trades-tab [data-key="worstTrade"]').html('<span class="opacity-3">' + myThis.helper.ToShortDate(data["worstTradeDate"], "short") + '</span> ' + myThis.helper.ToDecimal(data["worstTrade"]));
      $('#advanced-stats-trades-tab [data-key="bestTradePips"]').html('<span class="opacity-3">' + myThis.helper.ToShortDate(data["bestTradePipsDate"], "short") + '</span> ' + myThis.helper.ToDecimal(data["bestTradePips"]));
      $('#advanced-stats-trades-tab [data-key="worstTradePips"]').html('<span class="opacity-3">' + myThis.helper.ToShortDate(data["worstTradePipsDate"], "short") + '</span> ' + myThis.helper.ToDecimal(data["worstTradePips"]));
      $('#advanced-stats-trades-tab [data-key="avgTradeLength"]').html(myThis.helper.ToTimeSpan(data["avgTradeLength"]));
      $('#advanced-stats-trades-tab [data-key="profitFactor"]').html(myThis.helper.ToDecimal(data["profitFactor"]));
      $('#advanced-stats-trades-tab [data-key="standardDeviation"]').html(myThis.helper.ToDecimal(data["standardDeviation"]));
      $('#advanced-stats-trades-tab [data-key="sharpeRatio"]').html(myThis.helper.ToDecimal(data["sharpeRatio"]));
      $('#advanced-stats-trades-tab [data-key="zScore"]').html(myThis.helper.ToPercent(data["zScore"]));
      $('#advanced-stats-trades-tab [data-key="expectancy"]').html('<span class="opacity-3">' + myThis.helper.ToDecimal(data["expectancyPips"]) + ' pips</span> ' + myThis.helper.ToDecimal(data["expectancy"]));
      $('#advanced-stats-trades-tab [data-key="ahpr"]').html(myThis.helper.ToPercent(data["ahpr"]));
      $('#advanced-stats-trades-tab [data-key="ghpr"]').html(myThis.helper.ToPercent(data["ghpr"]));
      $('#advanced-stats-trades-tab [data-key="closed-profit"]').html(myThis.helper.ToDecimal(stats["closedProfit"]));
      $('#advanced-stats-trades-tab [data-key="closed-profit-percent"]').html(myThis.helper.ToPercent(stats["closedProfitPercent"]));
      $('#advanced-stats-trades-tab [data-key="closed-profit-percent-twr"]').html(myThis.helper.ToPercent(stats["closedProfitPercentTWR"]));
      $('#advanced-stats-trades-tab [data-key="closed-monthly-profit"]').html(myThis.helper.ToPercent((_stats$closedMonthlyP = stats["closedMonthlyProfitTWR"]) !== null && _stats$closedMonthlyP !== void 0 ? _stats$closedMonthlyP : stats["closedMonthlyProfit"]));
    }
  }, {
    key: "PopulateAdvancedSummaryStats",
    value: function PopulateAdvancedSummaryStats(data) {
      var myThis = this;
      $('#advanced-stats-summary-tab table tr:nth-child(n + 3)').remove();
      if (!data) return;
      var html = '';
      for (var i = 0; i < data.length; i++) {
        var _data$i, _data$i2, _data$i3, _data$i4, _data$i5, _data$i6, _data$i7, _data$i8, _data$i9, _data$i10, _data$i11, _data$i12, _data$i13, _data$i14, _data$i15, _data$i16, _data$i17, _data$i18;
        var row = '<tr>';
        row += '<td>' + ((_data$i = data[i]) === null || _data$i === void 0 ? void 0 : _data$i.symbol) + '</td>';
        row += '<td>' + ((_data$i2 = data[i]) === null || _data$i2 === void 0 ? void 0 : _data$i2.longTrades) + '</td>';
        row += '<td>' + this.helper.ToDecimal((_data$i3 = data[i]) === null || _data$i3 === void 0 ? void 0 : _data$i3.longPips, true) + '</td>';
        row += '<td>' + this.helper.ToDecimal((_data$i4 = data[i]) === null || _data$i4 === void 0 ? void 0 : _data$i4.longProfits, true) + "</td>";
        row += '<td>' + ((_data$i5 = data[i]) === null || _data$i5 === void 0 ? void 0 : _data$i5.shortTrades) + '</td>';
        row += '<td>' + this.helper.ToDecimal((_data$i6 = data[i]) === null || _data$i6 === void 0 ? void 0 : _data$i6.shortPips, true) + '</td>';
        row += '<td>' + this.helper.ToDecimal((_data$i7 = data[i]) === null || _data$i7 === void 0 ? void 0 : _data$i7.shortProfits, true) + '</td>';
        row += '<td>' + ((_data$i8 = data[i]) === null || _data$i8 === void 0 ? void 0 : _data$i8.totalTrades) + '</td>';
        row += '<td>' + this.helper.ToDecimal((_data$i9 = data[i]) === null || _data$i9 === void 0 ? void 0 : _data$i9.totalPips, true) + '</td>';
        row += '<td>' + this.helper.ToDecimal((_data$i10 = data[i]) === null || _data$i10 === void 0 ? void 0 : _data$i10.totalProfits, true) + '</td>';
        row += '<td class="stats-positive">' + ((_data$i11 = data[i]) === null || _data$i11 === void 0 ? void 0 : _data$i11.winTrades) + '(' + this.helper.ToPercent(((_data$i12 = data[i]) === null || _data$i12 === void 0 ? void 0 : _data$i12.winTrades) / ((_data$i13 = data[i]) === null || _data$i13 === void 0 ? void 0 : _data$i13.totalTrades)) + ')' + '</td>';
        row += '<td class="stats-negative">' + ((_data$i14 = data[i]) === null || _data$i14 === void 0 ? void 0 : _data$i14.lossTrades) + '(' + this.helper.ToPercent(((_data$i15 = data[i]) === null || _data$i15 === void 0 ? void 0 : _data$i15.lossTrades) / ((_data$i16 = data[i]) === null || _data$i16 === void 0 ? void 0 : _data$i16.totalTrades)) + ')' + '</td>';
        row += '<td data-toggle="summary-chart" data-symbol="' + ((_data$i17 = data[i]) === null || _data$i17 === void 0 ? void 0 : _data$i17.symbol) + '" data-ais-id="' + myThis.aisAccountId + '"><img src="/Content/dist/images/icons/line-chart.svg" /></td>';
        row += '</tr>';
        row += '<tr class="summary-chart-row" data-id="' + myThis.aisAccountId + '-' + ((_data$i18 = data[i]) === null || _data$i18 === void 0 ? void 0 : _data$i18.symbol) + '"> <td colspan="13"> <div><div class="advanced-summary-chart">Loading data</div></div>';
        row += "<div class=\"d-flex justify-content-center\">\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" data-trigger=\"draw-symbol-summary-chart\" name=\"advanced-summary-chart-type-".concat(data[i].symbol, "\" id=\"advanced-summary-chart-pips-").concat(data[i].symbol, "\" value=\"pips\" checked>\n                            <label class=\"form-check-label\" for=\"advanced-summary-chart-pips-").concat(data[i].symbol, "\">").concat(window.statsStrings['Pips'], "</label>\n                        </div>\n                        <div class=\"form-check\">\n                            <input class=\"form-check-input\" type=\"radio\" data-trigger=\"draw-symbol-summary-chart\" name=\"advanced-summary-chart-type-").concat(data[i].symbol, "\" id=\"advanced-summary-chart-profit-").concat(data[i].symbol, "\" value=\"profit\">\n                            <label class=\"form-check-label\" for=\"advanced-summary-chart-profit-").concat(data[i].symbol, "\">").concat(window.statsStrings['Profit'], "</label>\n                        </div>\n                    </div>");
        row += '</td> </tr>';
        html += row;
      }
      $('#advanced-stats-summary-tab table').append(html);
    }
  }, {
    key: "PopulateAdvancedRiskOfRuin",
    value: function PopulateAdvancedRiskOfRuin(data) {
      if (!data) return;
      for (var i = 0; i < data.length; i++) {
        if (data[i].probabilityOfLoss > 1e-4) $('#advanced-stats-riskofruin-tab tr:nth-child(2) td:nth-child(' + (i + 2) + ')').html(this.helper.ToPercent(data[i].probabilityOfLoss));
        if (data[i].consecutiveLossingTrades > 0) $('#advanced-stats-riskofruin-tab tr:nth-child(3) td:nth-child(' + (i + 2) + ')').html(data[i].consecutiveLossingTrades);
      }
      $("#advanced-stats-riskofruin-tab tr td:nth-child(n+2)").hover(function () {
        var $el = $(this);
        var index = $el.parent().children().index($el);
        $('#advanced-stats-riskofruin-tab tr td:nth-child(' + (index + 1) + ')').addClass("hover");
        $('#advanced-stats-riskofruin-tab tr:last-child td').html(window.statsStrings['ThereIsA0ChanceOfLosing1OfTheAccountThisWillRequire2ConsecutiveLosingTrades'].replace("{0}", $('#advanced-stats-riskofruin-tab tr:nth-child(1) td:nth-child(' + (index + 1) + ')').text()).replace('{1}', $('#advanced-stats-riskofruin-tab tr:nth-child(2) td:nth-child(' + (index + 1) + ')').text()).replace("{2}", $('#advanced-stats-riskofruin-tab tr:nth-child(3) td:nth-child(' + (index + 1) + ')').text()));
      }, function () {
        $('#advanced-stats-riskofruin-tab td').removeClass("hover");
        $('#advanced-stats-riskofruin-tab tr:last-child td').html(window.statsStrings['HoverOverTheDesiredColumnForADetailedExplanation']);
      });
    }
  }, {
    key: "GetDefaultChartOption",
    value: function GetDefaultChartOption(chartType, xaxisType, res) {
      // chartType: line, area, bar | res: data | xaxisType: category, datetime

      if (!res.series || res.series.length == 0 || !res.series[0].data || res.series[0].data.length == 0) return null;
      var options = {
        chart: {
          type: chartType,
          height: '100%',
          foreColor: 'rgba(255, 255, 255, 0.7)',
          background: 'transparent',
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        colors: ['#44a2f8', '#26E7A6', '#FEBC3B'],
        theme: {
          mode: 'dark'
        },
        dataLabels: {
          enabled: false
        },
        series: res.series,
        xaxis: {
          categories: res.categories,
          type: xaxisType,
          axisTicks: {
            show: true
          }
        },
        stroke: {
          width: 2,
          curve: 'smooth'
        },
        markers: {
          size: 0
        },
        grid: {
          show: true,
          borderColor: 'rgba(255, 255, 255, 0.22)',
          strokeDashArray: 0,
          xaxis: {
            lines: {
              show: true
            }
          },
          yaxis: {
            lines: {
              show: true
            }
          },
          row: {
            opacity: 0.3
          },
          column: {
            opacity: 0.3
          }
        }
      };
      if (chartType == "area") {
        options.fill = {
          type: ['gradient', 'solid'],
          colors: ['#44a2f8', '#343540'],
          gradient: {
            shadeIntensity: .4,
            opacityFrom: .6,
            opacityTo: 0,
            stops: [0, 100]
          },
          opacity: 1
        };
      }
      if (!!res.categories && res.categories.length > 20) {
        options.xaxis.tickAmount = 20;
      }
      if (xaxisType == 'datetime') {
        options.xaxis.labels = {
          datetimeUTC: false
        };
      }
      for (var i = 0; i < options.series.length; i++) {
        var twr = false;
        if (options.series[i].name.includes("-twr")) {
          options.series[i].name = options.series[i].name.replace("-twr", "");
          twr = true;
        }
        if (!!window.statsStrings[options.series[i].name]) options.series[i].name = window.statsStrings[options.series[i].name];
        if (twr) {
          options.series[i].name += ',<i class="mdi mdi-clock"></i>';
        }
      }
      return options;
    }
  }, {
    key: "DrawProfileProfitChart",
    value: function DrawProfileProfitChart(containerId, chartParams) {
      var myThis = this;
      var customParams = myThis.customOptions;
      var sendParams = _objectSpread(_objectSpread({}, chartParams), customParams);
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('ProfitChartLink') + '?AisAccountId=' + myThis.aisAccountId,
        type: "GET",
        data: sendParams,
        traditional: true,
        success: function success(res) {
          $('.chart-spinner').hide();
          var options = myThis.GetDefaultChartOption('line', 'datetime', res);
          if (options == null) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\">".concat(window.statsStrings['NoData'], "</span>"));
          } else {
            options.yaxis = [{
              forceNiceScale: false,
              labels: {
                formatter: function formatter(val) {
                  return myThis.helper.ToChartMoney(val);
                }
              }
            }];
            if (!myThis.apexCharts[containerId]) {
              $("#" + containerId).html('');
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            } else {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            }
          }
        },
        error: function error(xhr, statusText) {
          if (xhr.status == 423) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\"><i class=\"mdi mdi-lock\"></span>");
          }
        }
      });
    }
  }, {
    key: "DrawProfileEquityChart",
    value: function DrawProfileEquityChart(containerId) {
      var myThis = this;
      var customParams = myThis.customOptions;
      var url = myThis.Url('EquityChartLink') + '?AisAccountId=' + myThis.aisAccountId;
      if (myThis.equityChartZoomed) {
        url = myThis.Url('EquityDetailChartLink') + '?AisAccountId=' + myThis.aisAccountId;
      }
      window.APIHelper.SafeServiceAPICall({
        url: url,
        type: "GET",
        traditional: true,
        data: customParams,
        success: function success(res) {
          $('.chart-spinner').hide();
          var options = myThis.GetDefaultChartOption('line', 'datetime', res);
          if (options == null) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\">".concat(window.statsStrings['NoData'], "</span>"));
          } else {
            options.chart.events = {
              beforeZoom: function beforeZoom() {
                if (!myThis.equityChartZoomed) {
                  $('.chart-spinner').show();
                  myThis.equityChartZoomed = true;
                  myThis.DrawProfileEquityChart(containerId);
                }
              },
              beforeResetZoom: function beforeResetZoom() {
                $('.chart-spinner').show();
                myThis.equityChartZoomed = false;
                myThis.DrawProfileEquityChart(containerId);
              }
            };
            if (myThis.equityChartZoomed) {
              options.tooltip = {
                x: {
                  formatter: function formatter(x) {
                    return new Date(x).toLocaleString('en-GB', {
                      timeZone: 'UTC'
                    });
                  }
                }
              };
            }
            options.yaxis = [{
              forceNiceScale: false,
              labels: {
                formatter: function formatter(val) {
                  return myThis.helper.ToChartMoney(val);
                }
              }
            }];
            if (!myThis.apexCharts[containerId]) {
              $("#" + containerId).html('');
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            } else {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            }
          }
        },
        error: function error(xhr, statusText) {
          if (xhr.status == 423) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\"><i class=\"mdi mdi-lock\"></span>");
          }
        }
      });
    }
  }, {
    key: "DrawProfileOpenProfitChart",
    value: function DrawProfileOpenProfitChart(containerId) {
      var myThis = this;
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('OpenProfitChartLink') + '?AisAccountId=' + myThis.aisAccountId,
        type: "GET",
        traditional: true,
        data: myThis.customOptions,
        success: function success(res) {
          $('.chart-spinner').hide();
          var options = myThis.GetDefaultChartOption('line', 'datetime', res);
          if (options == null) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\">".concat(window.statsStrings['NoData'], "</span>"));
          } else {
            options.yaxis = [{
              forceNiceScale: false,
              labels: {
                formatter: function formatter(val) {
                  return myThis.helper.ToChartMoney(val);
                }
              }
            }];
            if (!myThis.apexCharts[containerId]) {
              $("#" + containerId).html('');
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            } else {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            }
          }
        },
        error: function error(xhr, statusText) {
          if (xhr.status == 423) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\"><i class=\"mdi mdi-lock\"></span>");
          }
        }
      });
    }
  }, {
    key: "DrawProfileOpenProfitPercentChart",
    value: function DrawProfileOpenProfitPercentChart(containerId) {
      var myThis = this;
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('OpenProfitPercentChartLink') + '?AisAccountId=' + myThis.aisAccountId,
        type: "GET",
        data: myThis.customOptions,
        traditional: true,
        success: function success(res) {
          $('.chart-spinner').hide();
          var options = myThis.GetDefaultChartOption('line', 'datetime', res);
          if (options == null) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\">".concat(window.statsStrings['NoData'], "</span>"));
          } else {
            options.yaxis = [{
              forceNiceScale: false,
              labels: {
                formatter: function formatter(val) {
                  return myThis.helper.ToPercent(val);
                }
              }
            }];
            if (!myThis.apexCharts[containerId]) {
              $("#" + containerId).html('');
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            } else {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            }
          }
        },
        error: function error(xhr, statusText) {
          if (xhr.status == 423) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\"><i class=\"mdi mdi-lock\"></span>");
          }
        }
      });
    }
  }, {
    key: "DrawProfileDrawdownChart",
    value: function DrawProfileDrawdownChart(containerId, chartParams) {
      var myThis = this;
      var customParams = myThis.customOptions;
      var sendParams = _objectSpread(_objectSpread({}, chartParams), customParams);
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('ProfileDrawdownChartLink') + '?AisAccountId=' + myThis.aisAccountId,
        type: "GET",
        data: sendParams,
        traditional: true,
        success: function success(res) {
          $('.chart-spinner').hide();
          var options = myThis.GetDefaultChartOption('line', 'datetime', res);
          if (options == null) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\">".concat(window.statsStrings['NoData'], "</span>"));
          } else {
            if (chartParams["UnitType"].toLowerCase() != "percent") {
              options.yaxis = {
                forceNiceScale: false,
                labels: {
                  formatter: function formatter(val) {
                    return myThis.helper.ToChartMoney(val);
                  }
                }
              };
            } else {
              options.yaxis = {
                forceNiceScale: false,
                labels: {
                  formatter: function formatter(value) {
                    return myThis.helper.ToPercent(value);
                  }
                }
              };
            }
            if (!myThis.apexCharts[containerId]) {
              $("#" + containerId).html('');
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            } else {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            }
          }
        },
        error: function error(xhr, statusText) {
          if (xhr.status == 423) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\"><i class=\"mdi mdi-lock\"></span>");
          }
        }
      });
    }
  }, {
    key: "DrawProfileBalanceChart",
    value: function DrawProfileBalanceChart(containerId, chartParams) {
      var myThis = this;
      var customParams = this.customOptions;
      var sendParams = _objectSpread(_objectSpread({}, chartParams), customParams);
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('ProfileBalanceChartLink') + '?AisAccountId=' + myThis.aisAccountId,
        type: "GET",
        data: sendParams,
        traditional: true,
        success: function success(res) {
          $('.chart-spinner').hide();
          var options = myThis.GetDefaultChartOption('line', 'datetime', res);
          if (options == null) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\">".concat(window.statsStrings['NoData'], "</span>"));
          } else {
            options.yaxis = [{
              forceNiceScale: false,
              labels: {
                formatter: function formatter(val) {
                  return myThis.helper.ToChartMoney(val);
                }
              }
            }];
            if (!myThis.apexCharts[containerId]) {
              $("#" + containerId).html('');
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            } else {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            }
          }
        },
        error: function error(xhr, statusText) {
          if (xhr.status == 423) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\"><i class=\"mdi mdi-lock\"></span>");
          }
        }
      });
    }
  }, {
    key: "DrawProfileGrowthChart",
    value: function DrawProfileGrowthChart(containerId, chartParams) {
      var myThis = this;
      var customParams = this.customOptions;
      var sendParams = _objectSpread(_objectSpread({}, chartParams), customParams);
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('ProfileGrowthChartLink') + '?AisAccountId=' + myThis.aisAccountId,
        type: "GET",
        data: sendParams,
        traditional: true,
        success: function success(res) {
          $('.chart-spinner').hide();
          var options = myThis.GetDefaultChartOption('line', 'datetime', res);
          if (options == null) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\">".concat(window.statsStrings['NoData'], "</span>"));
          } else {
            options.yaxis = {
              forceNiceScale: false,
              labels: {
                formatter: function formatter(value) {
                  return myThis.helper.ToPercent(value);
                }
              }
            };
            if (!myThis.apexCharts[containerId]) {
              $("#" + containerId).html('');
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            } else {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            }
          }
        },
        error: function error(xhr, statusText) {
          if (xhr.status == 423) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\"><i class=\"mdi mdi-lock\"></span>");
          }
        }
      });
    }
  }, {
    key: "DrawProfileMonthlyChart",
    value: function DrawProfileMonthlyChart(containerId, chartParams) {
      var myThis = this;
      var customParams = this.customOptions;
      var sendParams = _objectSpread(_objectSpread({}, chartParams), customParams);
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('ProfileMonthlyChartLink') + '?AisAccountId=' + myThis.aisAccountId,
        type: "GET",
        data: sendParams,
        traditional: true,
        success: function success(res) {
          $('.chart-spinner').hide();
          var options = myThis.GetDefaultChartOption('line', 'category', res);
          if (options == null) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\">".concat(window.statsStrings['NoData'], "</span>"));
          } else {
            if (chartParams["UnitType"].toLowerCase().includes("percent")) {
              options.yaxis = {
                forceNiceScale: false,
                labels: {
                  formatter: function formatter(value) {
                    return myThis.helper.ToPercent(value);
                  }
                }
              };
            } else {
              options.yaxis = {
                forceNiceScale: false,
                labels: {
                  formatter: function formatter(val) {
                    return myThis.helper.ToChartMoney(val);
                  }
                }
              };
            }
            if (!myThis.apexCharts[containerId]) {
              $("#" + containerId).html('');
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            } else {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            }
          }
        },
        error: function error(xhr, statusText) {
          if (xhr.status == 423) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\"><i class=\"mdi mdi-lock\"></span>");
          }
        }
      });
    }
  }, {
    key: "DrawAdvancedPeriodChart",
    value: function DrawAdvancedPeriodChart(containerId, period, chartParams) {
      var myThis = this;
      var customParams = this.customOptions;
      var sendParams = _objectSpread(_objectSpread({}, chartParams), customParams);
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('ProfileAdvancedPeriodChartLink') + '?AisAccountId=' + myThis.aisAccountId + '&period=' + period,
        type: "GET",
        data: sendParams,
        traditional: true,
        success: function success(res) {
          $('.chart-spinner').hide();
          var options = myThis.GetDefaultChartOption('line', 'category', res);
          if (options == null) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\">".concat(window.statsStrings['NoData'], "</span>"));
          } else {
            if (chartParams["VsType"] == "winvslos" || chartParams["VsType"] == "longvsshort") {
              options.yaxis = {
                forceNiceScale: false,
                labels: {
                  formatter: function formatter(value) {
                    return value.toFixed(0);
                  }
                }
              };
            } else {
              if (chartParams["UnitType"] == "gain") {
                options.yaxis = {
                  forceNiceScale: false,
                  labels: {
                    formatter: function formatter(value) {
                      return myThis.helper.ToPercent(value);
                    }
                  }
                };
              } else {
                options.yaxis = {
                  forceNiceScale: false,
                  labels: {
                    formatter: function formatter(val) {
                      return myThis.helper.ToChartMoney(val);
                    }
                  }
                };
              }
            }
            if (!myThis.apexCharts[containerId]) {
              $("#" + containerId).html('');
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            } else {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            }
          }
        },
        error: function error(xhr, statusText) {
          if (xhr.status == 423) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\"><i class=\"mdi mdi-lock\"></span>");
          }
        }
      });
    }
  }, {
    key: "DrawAdvancedDurationChart",
    value: function DrawAdvancedDurationChart(containerId, chartParams) {
      var myThis = this;
      var customParams = this.customOptions;
      var sendParams = _objectSpread(_objectSpread({}, chartParams), customParams);
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('ProfileAdvancedDurationChartLink') + '?AisAccountId=' + myThis.aisAccountId + '&tradescount=' + 200,
        type: "GET",
        data: sendParams,
        traditional: true,
        success: function success(res) {
          $('.chart-spinner').hide();
          var options = myThis.GetDefaultChartOption('scatter', 'category', res);
          if (options == null) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\">".concat(window.statsStrings['NoData'], "</span>"));
          } else {
            options.markers = {};
            options.xaxis = {
              labels: {
                formatter: function formatter(value) {
                  var d = value / 24;
                  if (value < 24) return value.toFixed(0) + "h";else return d - d % 1 + "d " + (value % 24).toFixed(0) + " h";
                }
              },
              tickAmount: 20
            };
            if (chartParams["UnitType"].toLowerCase() == "growth") {
              options.yaxis = {
                labels: {
                  formatter: function formatter(val) {
                    return myThis.helper.ToPercent(val);
                  }
                }
              };
            } else {
              options.yaxis = {
                labels: {
                  formatter: function formatter(val) {
                    return myThis.helper.ToChartMoney(val);
                  }
                }
              };
            }
            if (!myThis.apexCharts[containerId]) {
              $("#" + containerId).html('');
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            } else {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            }
          }
        },
        error: function error(xhr, statusText) {
          if (xhr.status == 423) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\"><i class=\"mdi mdi-lock\"></span>");
          }
        }
      });
    }
  }, {
    key: "DrawAdvancedMAEMFEChart",
    value: function DrawAdvancedMAEMFEChart(containerId, chartParams) {
      var myThis = this;
      var customParams = this.customOptions;
      var sendParams = _objectSpread(_objectSpread({}, chartParams), customParams);
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('ProfileAdvancedMAEMFEChartLink') + '?AisAccountId=' + myThis.aisAccountId + '&tradescount=' + 200,
        type: "GET",
        data: sendParams,
        traditional: true,
        success: function success(res) {
          $('.chart-spinner').hide();
          var options = myThis.GetDefaultChartOption('scatter', 'category', res);
          if (options == null) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\">".concat(window.statsStrings['NoData'], "</span>"));
          } else {
            options.markers = {};
            if (chartParams["UnitType"] == "gain") {
              options.yaxis = {
                labels: {
                  formatter: function formatter(val) {
                    return myThis.helper.ToPercent(val);
                  }
                }
              };
              options.xaxis = {
                labels: {
                  formatter: function formatter(val) {
                    return myThis.helper.ToPercent(val);
                  }
                },
                tickAmount: 20
              };
            } else {
              options.yaxis = {
                labels: {
                  formatter: function formatter(val) {
                    return myThis.helper.ToChartMoney(val);
                  }
                }
              };
              options.xaxis = {
                labels: {
                  formatter: function formatter(val) {
                    return myThis.helper.ToChartMoney(val);
                  }
                },
                tickAmount: 20
              };
            }
            if (!myThis.apexCharts[containerId]) {
              $("#" + containerId).html('');
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            } else {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            }
          }
        },
        error: function error(xhr, statusText) {
          if (xhr.status == 423) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\"><i class=\"mdi mdi-lock\"></span>");
          }
        }
      });
    }
  }, {
    key: "DrawMonthlyAnalyticsChart",
    value: function DrawMonthlyAnalyticsChart(containerId, type, year, updateDetail) {
      var myThis = this;
      var profitType = 'equity';
      var customParams = this.customOptions;
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('ProfileMonthlyAnalyticsLink') + '?AisAccountId=' + myThis.aisAccountId,
        data: _objectSpread({
          UnitType: type,
          year: year,
          profitType: profitType
        }, customParams),
        type: "GET",
        traditional: true,
        success: function success(res) {
          $('.chart-spinner').hide();
          var html = '';
          for (var i = 0; i < res.years.length; i++) {
            if (res.years[i] == year) {
              html += '<li class="nav-item"><a class="nav-link active" data-year="' + res.years[i] + '">' + res.years[i] + '</a></li>';
            } else {
              html += '<li class="nav-item"><a class="nav-link" data-year="' + res.years[i] + '">' + res.years[i] + '</a></li>';
            }
          }
          $("#monthly-analytics-tablist").html(html);
          var options = myThis.GetDefaultChartOption('bar', 'category', res);
          if (options == null) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\">".concat(window.statsStrings['NoData'], "</span>"));
          } else {
            options.chart.events = {
              click: function click(event, chartContext, config) {
                if (config.dataPointIndex >= 0) {
                  console.log(config.config.xaxis.categories[config.dataPointIndex]);
                  myThis.DrawMonthlyAnalyticsDetailCharts(config.config.xaxis.categories[config.dataPointIndex]);
                }
              }
            };
            if (type != "percent") {
              options.yaxis = {
                forceNiceScale: false,
                labels: {
                  formatter: function formatter(val) {
                    return myThis.helper.ToChartMoney(val);
                  }
                }
              };
            } else {
              options.yaxis = {
                forceNiceScale: false,
                labels: {
                  formatter: function formatter(value) {
                    return myThis.helper.ToPercent(value);
                  }
                }
              };
            }
            if (!myThis.apexCharts[containerId]) {
              $("#" + containerId).html('');
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            } else {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = new ApexCharts(document.querySelector("#" + containerId), options);
              myThis.apexCharts[containerId].render();
            }
          }
          if (updateDetail) {
            if (myThis.apexCharts['monthly-analytics-reward-chart']) {
              myThis.apexCharts['monthly-analytics-reward-chart'].destroy();
              myThis.apexCharts['monthly-analytics-reward-chart'] = null;
            }
            if (myThis.apexCharts['monthly-analytics-currencies-chart']) {
              myThis.apexCharts['monthly-analytics-currencies-chart'].destroy();
              myThis.apexCharts['monthly-analytics-currencies-chart'] = null;
            }
            if (myThis.apexCharts['monthly-analytics-avgholding-chart']) {
              myThis.apexCharts['monthly-analytics-avgholding-chart'].destroy();
              myThis.apexCharts['monthly-analytics-avgholding-chart'] = null;
            }
            $("#monthly-analytics-reward-chart").html("<span class=\"no-data-display\">".concat(window.statsStrings['PleaseSelectAMonth'], "</span>"));
            $("#monthly-analytics-reward-chart").parent().find('div.resize-triggers').remove();
            $("#monthly-analytics-currencies-chart").html("<span class=\"no-data-display\">".concat(window.statsStrings['PleaseSelectAMonth'], "</span>"));
            $("#monthly-analytics-currencies-chart").parent().find('div.resize-triggers').remove();
            $("#monthly-analytics-avgholding-chart").html("<span class=\"no-data-display\">".concat(window.statsStrings['PleaseSelectAMonth'], "</span>"));
            $("#monthly-analytics-avgholding-chart").parent().find('div.resize-triggers').remove();
          }
        },
        error: function error(xhr, statusText) {
          if (xhr.status == 423) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\"><i class=\"mdi mdi-lock\"></span>");
          }
        }
      });
    }
  }, {
    key: "DrawMonthlyAnalyticsDetailCharts",
    value: function DrawMonthlyAnalyticsDetailCharts(month) {
      var myThis = this;
      var profitType = 'equity';
      var customParams = this.customOptions;
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('ProfileMonthlyAnalyticsDetailLink') + '?AisAccountId=' + myThis.aisAccountId + '&month=' + month + '&profitType=' + profitType,
        type: "GET",
        data: customParams,
        traditional: true,
        success: function success(res) {
          $('.chart-spinner').hide();
          var options = myThis.GetDefaultChartOption('bar', 'category', res.rewardChart);
          options.chart.stacked = true;
          options.plotOptions = {
            bar: {
              horizontal: true
            }
          };
          document.querySelector("#monthly-analytics-reward-chart").innerHTML = '';
          if (!myThis.apexCharts['monthly-analytics-reward-chart']) {
            myThis.apexCharts['monthly-analytics-reward-chart'] = new ApexCharts(document.querySelector("#monthly-analytics-reward-chart"), options);
            myThis.apexCharts['monthly-analytics-reward-chart'].render();
          } else {
            myThis.apexCharts['monthly-analytics-reward-chart'].destroy();
            myThis.apexCharts['monthly-analytics-reward-chart'] = new ApexCharts(document.querySelector("#monthly-analytics-reward-chart"), options);
            myThis.apexCharts['monthly-analytics-reward-chart'].render();
          }
          var currenciesOptions = {
            chart: {
              type: 'pie',
              height: '100%',
              foreColor: 'rgba(255, 255, 255, 0.7)',
              background: 'transparent',
              stacked: true
            },
            series: res.currenciesPopularityChart.series[0].data,
            labels: res.currenciesPopularityChart.categories
          };
          document.querySelector("#monthly-analytics-currencies-chart").innerHTML = '';
          if (!myThis.apexCharts['monthly-analytics-currencies-chart']) {
            myThis.apexCharts['monthly-analytics-currencies-chart'] = new ApexCharts(document.querySelector("#monthly-analytics-currencies-chart"), currenciesOptions);
            myThis.apexCharts['monthly-analytics-currencies-chart'].render();
          } else {
            myThis.apexCharts['monthly-analytics-currencies-chart'].destroy();
            myThis.apexCharts['monthly-analytics-currencies-chart'] = new ApexCharts(document.querySelector("#monthly-analytics-currencies-chart"), currenciesOptions);
            myThis.apexCharts['monthly-analytics-currencies-chart'].render();
          }
          var holidingTimeOptions = myThis.GetDefaultChartOption('bar', 'category', res.averageHoldingTimeChart);
          holidingTimeOptions.chart.stacked = true;
          holidingTimeOptions.xaxis = {
            labels: {
              formatter: function formatter(value) {
                var d = value / 24;
                if (value < 24) return value.toFixed(0) + "h";else return d - d % 1 + "d " + (value % 24).toFixed(0) + " h";
              }
            },
            categories: res.averageHoldingTimeChart.categories
          };
          holidingTimeOptions.tooltip = {
            y: {
              formatter: function formatter(value) {
                var d = value / 24;
                if (value < 24) return value.toFixed(0) + "h";else return d - d % 1 + "d " + (value % 24).toFixed(0) + " h";
              }
            }
          };
          holidingTimeOptions.dataLabels = {
            enabled: false
          };
          holidingTimeOptions.plotOptions = {
            bar: {
              horizontal: true
            }
          };
          document.querySelector("#monthly-analytics-avgholding-chart").innerHTML = '';
          if (!myThis.apexCharts['monthly-analytics-avgholding-chart']) {
            myThis.apexCharts['monthly-analytics-avgholding-chart'] = new ApexCharts(document.querySelector("#monthly-analytics-avgholding-chart"), holidingTimeOptions);
            myThis.apexCharts['monthly-analytics-avgholding-chart'].render();
          } else {
            myThis.apexCharts['monthly-analytics-avgholding-chart'].destroy();
            myThis.apexCharts['monthly-analytics-avgholding-chart'] = new ApexCharts(document.querySelector("#monthly-analytics-avgholding-chart"), holidingTimeOptions);
            myThis.apexCharts['monthly-analytics-avgholding-chart'].render();
          }
        },
        error: function error(xhr, statusText) {
          if (xhr.status == 423) {
            if (myThis.apexCharts[containerId]) {
              myThis.apexCharts[containerId].destroy();
              myThis.apexCharts[containerId] = null;
            }
            $("#" + containerId).html("<span class=\"no-data-display\"><i class=\"mdi mdi-lock\"></span>");
          }
        }
      });
    }
  }, {
    key: "InitializeTradingActivityTable",
    value: function InitializeTradingActivityTable(selector, dataSourceLink) {
      var myThis = this;
      var container = $(selector).pagination({
        dataSource: dataSourceLink + "?aisAccountId=" + myThis.aisAccountId,
        ajaxFunction: function ajaxFunction(t) {
          return window.APIHelper.SafeServiceAPICall(t);
        },
        locator: 'items',
        pageSize: 20,
        pageRange: 1,
        totalNumberLocator: function totalNumberLocator(response) {
          return response.totalCount;
        },
        ajax: {
          data: myThis.customOptions,
          traditional: true,
          beforeSend: function beforeSend(jqXHR, settings) {
            if (myThis.tradingActivitySortParam[selector] != undefined) {
              settings.url += '&sortParam=' + myThis.tradingActivitySortParam[selector].sortParam + '&sortOrder=' + myThis.tradingActivitySortParam[selector].sortOrder;
            }
            return true;
          }
        },
        formatAjaxError: function formatAjaxError(jqXHR, textStatus, errorThrown) {
          var $this = this;
          if (jqXHR.status == 401) {
            window.APIHelper.GetAccessTokenAsync().then(function () {
              $(selector).pagination($this.pageNumber);
            });
          } else if (jqXHR.status == 423) {
            $(selector).html("<div class=\"section-tab-body flex justify-content-center\"><span class=\"no-data-display\" style=\"margin: 16px;\"><i class=\"mdi mdi-lock\"/></span></div>");
          }
          if (selector == "#trading-activity-excluded") {
            $("a[href='".concat(selector, "']")).hide();
          }
        },
        callback: function callback(data, pagination) {
          if (selector == "#trading-activity-excluded") {
            if (data.length == 0) $("a[href='".concat(selector, "']")).hide();else $("a[href='".concat(selector, "']")).show();
          }
          if (data.length == 0) {
            $(selector).html("<div class=\"section-tab-body flex justify-content-center\"><span class=\"no-data-display\" style=\"margin: 16px;\">".concat(window.statsStrings['NoData'], "</span></div>"));
          } else {
            var sortParam = "closeTime",
              sortOrder = "desc";
            if (!!myThis.tradingActivitySortParam[selector]) {
              sortParam = myThis.tradingActivitySortParam[selector].sortParam;
              sortOrder = myThis.tradingActivitySortParam[selector].sortOrder.toLowerCase();
            }
            var html = '<table class="statistics-table">';
            var header = '<tr>';
            if (sortParam == "openTime") header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"openTime\" class=\"sort ").concat(sortOrder, "\">").concat(window.statsStrings['OpenDate'], "</td>");else header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"openTime\" class=\"sort\">").concat(window.statsStrings['OpenDate'], "</td>");
            if (selector == '#trading-activity-history' || selector == "#trading-activity-excluded") {
              if (sortParam == "closeTime") header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"closeTime\" class=\"sort ").concat(sortOrder, "\">").concat(window.statsStrings['CloseDate'], "</td>");else header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"closeTime\" class=\"sort\">").concat(window.statsStrings['CloseDate'], "</td>");
            }
            if (sortParam == "symbol") header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"symbol\" class=\"sort ").concat(sortOrder, "\">").concat(window.statsStrings['Symbol'], "</td>");else header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"symbol\" class=\"sort\">").concat(window.statsStrings['Symbol'], "</td>");
            if (sortParam == "type") header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"type\" class=\"sort ").concat(sortOrder, "\">").concat(window.statsStrings['Action'], "</td>");else header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"type\" class=\"sort\">").concat(window.statsStrings['Action'], "</td>");
            if (sortParam == "lots") header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"lots\" class=\"sort ").concat(sortOrder, "\">").concat(window.statsStrings['Volume'], "</td>");else header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"lots\" class=\"sort\">").concat(window.statsStrings['Volume'], "</td>");
            if (sortParam == "openPrice") header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"openPrice\" class=\"sort ").concat(sortOrder, "\">").concat(window.statsStrings['OpenPrice'], "</td>");else header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"openPrice\" class=\"sort\">").concat(window.statsStrings['OpenPrice'], "</td>");
            var closePriceLabel = window.statsStrings['ClosePrice'];
            if (selector == '#trading-activity-open-trades' || selector == "#trading-activity-open-orders") {
              closePriceLabel = window.statsStrings['CurrentPrice'];
            }
            if (sortParam == "closePrice") header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"closePrice\" class=\"sort ").concat(sortOrder, "\">").concat(closePriceLabel, "</td>");else header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"closePrice\" class=\"sort\">").concat(closePriceLabel, "</td>");
            if (sortParam == "stopLoss") header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"stopLoss\" class=\"sort ").concat(sortOrder, "\">SL</td>");else header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"stopLoss\" class=\"sort\">SL</td>");
            if (sortParam == "takeProfit") header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"takeProfit\" class=\"sort ").concat(sortOrder, "\">TP</td>");else header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"takeProfit\" class=\"sort\">TP</td>");
            if (sortParam == "pips") header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"pips\" class=\"sort ").concat(sortOrder, "\">").concat(window.statsStrings['Pips'], "</td>");else header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"pips\" class=\"sort\">").concat(window.statsStrings['Pips'], "</td>");
            header += "<td data-id=\"".concat(selector, "\">").concat(window.statsStrings['Swap'], "</td>");
            header += "<td data-id=\"".concat(selector, "\">").concat(window.statsStrings['Commission'], "</td>");
            if (sortParam == "profit") header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"profit\" class=\"sort ").concat(sortOrder, "\">").concat(window.statsStrings['Profit'], "</td>");else header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"profit\" class=\"sort\">").concat(window.statsStrings['Profit'], "</td>");
            if (sortParam == "duration") header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"duration\" class=\"sort ").concat(sortOrder, "\">").concat(window.statsStrings['Duration'], "</td>");else header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"duration\" class=\"sort\">").concat(window.statsStrings['Duration'], "</td>");
            if (sortParam == "gain") header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"gain\" class=\"sort ").concat(sortOrder, "\">").concat(window.statsStrings['ProfitPercent'], "</td>");else header += "<td data-id=\"".concat(selector, "\" data-sort-param=\"gain\" class=\"sort\">").concat(window.statsStrings['ProfitPercent'], "</td>");
            header += "<td data-id=\"".concat(selector, "\">").concat(window.statsStrings['Comment'], "</td>");
            header += '</tr>';
            html += header;
            var curDate = new Date(new Date().getTime() + myThis.timeOffset * 60 * 1000);
            for (var i = 0; i < data.length; i++) {
              var row = '<tr>';
              row += '<td>' + myThis.helper.ToLongDate(data[i].openTime, 'UTC') + '</td>';
              if (selector == '#trading-activity-history' || selector == "#trading-activity-excluded") {
                row += '<td>' + myThis.helper.ToLongDate(data[i].closeTime, 'UTC') + '</td>';
              }
              row += '<td>' + data[i].symbol + '</td>';
              row += '<td>' + window.statsStrings[data[i].type] + '</td>';
              row += '<td>' + myThis.helper.ToDecimal(data[i].lots) + '</td>';
              row += '<td>' + myThis.helper.ToDigitsDecimal(data[i].openPrice, data[i].digits) + '</td>';
              row += '<td>' + myThis.helper.ToDigitsDecimal(data[i].closePrice, data[i].digits) + '</td>';
              if (data[i].stopLoss == 0) row += '<td>-</td>';else row += '<td>' + myThis.helper.ToDigitsDecimal(data[i].stopLoss, data[i].digits) + '</td>';
              if (data[i].takeProfit == 0) row += '<td>-</td>';else row += '<td>' + myThis.helper.ToDigitsDecimal(data[i].takeProfit, data[i].digits) + '</td>';
              if (data[i].type == "Balance" || data[i].type == "Credit") {
                row += '<td></td>';
              } else {
                row += '<td>' + myThis.helper.ToDecimal(data[i].pips, true) + '</td>';
              }
              row += '<td>' + myThis.helper.ToDecimal(data[i].swap) + '</td>';
              row += '<td>' + myThis.helper.ToDecimal(data[i].commission) + '</td>';
              row += '<td>' + myThis.helper.ToDecimal(data[i].profit + data[i].swap + data[i].commission, true) + '</td>';
              if (selector == '#trading-activity-history' || selector == "#trading-activity-excluded") {
                row += '<td>' + myThis.helper.GetDuraction(data[i].openTime, data[i].closeTime) + '</td>';
              } else {
                row += '<td>' + myThis.helper.GetDuraction(data[i].openTime, curDate) + '</td>';
              }
              row += '<td>' + myThis.helper.ToPercent(data[i].gain) + '</td>';
              if (data[i].comment) {
                row += '<td>' + data[i].comment + '</td>';
              } else {
                row += '<td></td>';
              }
              row += '</tr>';
              html += row;
            }
            html += '</table>';
            $(selector + " .section-tab-body").html(html);
            InitializeScrollTable(selector + " .section-tab-body table");
          }
        }
      });
      container.addHook('beforePaging', function () {
        window.APIHelper.GetAccessTokenAsync();
      });
    }
  }, {
    key: "DrawAdvancedStatSummaryChart",
    value: function DrawAdvancedStatSummaryChart(symbol) {
      var myThis = this;
      var type = $("input[name=advanced-summary-chart-type-".concat(symbol, "]:checked")).val();
      var profitType = 'equity';
      var customParams = this.customOptions;
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('ProfileAdvancedSummaryChartLink') + '?AisAccountId=' + myThis.aisAccountId + '&Symbol=' + symbol + '&UnitType=' + type + '&profitType=' + profitType,
        type: "GET",
        data: customParams,
        success: function success(res) {
          var options = myThis.GetDefaultChartOption('line', 'datetime', res);
          if (options == null) {
            $('#advanced-stats-summary-tab tr[data-id="' + myThis.aisAccountId + '-' + symbol + '"] td div.advanced-summary-chart').html('<span class="no-data-display">No data</span>');
          } else {
            options.stroke = {
              width: [2, 2, 0]
            };
            options.yaxis = {
              forceNiceScale: false,
              labels: {
                formatter: function formatter(val) {
                  return myThis.helper.ToChartMoney(val);
                }
              }
            };
            if (myThis.apexCharts["symbol-summary-chart-".concat(symbol)]) {
              myThis.apexCharts["symbol-summary-chart-".concat(symbol)].destroy();
            }
            $('#advanced-stats-summary-tab tr[data-id="' + myThis.aisAccountId + '-' + symbol + '"] td div.advanced-summary-chart').html('');
            myThis.apexCharts["symbol-summary-chart-".concat(symbol)] = new ApexCharts(document.querySelector('#advanced-stats-summary-tab tr[data-id="' + myThis.aisAccountId + '-' + symbol + '"] td div.advanced-summary-chart'), options);
            myThis.apexCharts["symbol-summary-chart-".concat(symbol)].render();
          }
        },
        error: function error(xhr, statusText) {
          if (xhr.status == 423) {
            $('#advanced-stats-summary-tab tr[data-id="' + myThis.aisAccountId + '-' + symbol + '"] td div.advanced-summary-chart').html('<span class="no-data-display"><i class="mdi mdi-lock"></span>');
          }
        }
      });
    }
  }, {
    key: "DrawSummaryChart",
    value: function DrawSummaryChart($el, chart) {
      var myThis = this;
      $('#statistics-charts-dropdown-menu li[data-trigger=drawchart]').removeClass('active');
      $("button.profile-summary-button[data-trigger=drawchart]").removeClass('active');
      $("[data-trigger=drawchart][data-chart=".concat(chart, "]")).addClass('active');
      $("#statistics-charts-dropdown-menu a[data-toggle=dropdown]").html($('#statistics-charts-dropdown-menu ul li[data-chart=' + chart + ']').html());
      if ($el.hasClass("profile-summary-button")) {
        if (window.matchMedia('screen and (max-width: 767px)').matches) {
          $('html, body').animate({
            scrollTop: $('.profile-summary .profile-chart-box').offset().top - 64
          }, 100);
        }
      }
      if (myThis.currentChart == chart) return;
      myThis.currentChart = chart;
      myThis.InitializeSummaryChartOptions(chart);
      myThis.InitializePermission();
      var chartParams = {};
      chartParams["ProfitType"] = 'equity';
      $('.chart-spinner').show();
      switch (chart) {
        case 'equity':
          myThis.DrawProfileEquityChart('profile-summary-chart');
          break;
        case 'profit':
          myThis.DrawProfileProfitChart('profile-summary-chart');
          break;
        case 'closed-profit':
          chartParams["ProfitType"] = "balance";
          myThis.DrawProfileProfitChart('profile-summary-chart', chartParams);
          break;
        case 'open-profit':
          myThis.DrawProfileOpenProfitChart('profile-summary-chart', chartParams);
          break;
        case 'balance':
          chartParams["UnitType"] = "lots";
          myThis.DrawProfileBalanceChart('profile-summary-chart', chartParams);
          break;
        case 'open-profit-percent':
          myThis.DrawProfileOpenProfitPercentChart('profile-summary-chart');
          break;
        case 'profit-percent':
          chartParams["ProfitType"] = "equity";
          myThis.DrawProfileGrowthChart('profile-summary-chart', chartParams);
          break;
        case 'closed-profit-percent':
          chartParams["ProfitType"] = "balance";
          myThis.DrawProfileGrowthChart('profile-summary-chart', chartParams);
          break;
        case 'profit-percent-twr':
          chartParams["ProfitType"] = "equity-twr";
          myThis.DrawProfileGrowthChart('profile-summary-chart', chartParams);
          break;
        case 'closed-profit-percent-twr':
          chartParams["ProfitType"] = "balance-twr";
          myThis.DrawProfileGrowthChart('profile-summary-chart', chartParams);
          break;
        case 'drawdown':
          chartParams["UnitType"] = "percent";
          myThis.DrawProfileDrawdownChart('profile-summary-chart', chartParams);
          break;
        case 'monthly-profit':
          chartParams["ProfitType"] = 'equity';
          chartParams["UnitType"] = "percent";
          myThis.DrawProfileMonthlyChart('profile-summary-chart', chartParams);
          break;
        case 'monthly-profit-twr':
          chartParams["ProfitType"] = 'equity';
          chartParams["UnitType"] = "percent-twr";
          myThis.DrawProfileMonthlyChart('profile-summary-chart', chartParams);
          break;
        case 'closed-monthly-profit':
          chartParams["ProfitType"] = "balance";
          chartParams["UnitType"] = "percent";
          myThis.DrawProfileMonthlyChart('profile-summary-chart', chartParams);
          break;
        case 'closed-monthly-profit-twr':
          chartParams["ProfitType"] = "balance";
          chartParams["UnitType"] = "percent-twr";
          myThis.DrawProfileMonthlyChart('profile-summary-chart', chartParams);
          break;
        case 'advanced-hourly':
          chartParams["VsType"] = "winvslos";
          myThis.DrawAdvancedPeriodChart("profile-summary-chart", 0, chartParams);
          break;
        case 'advanced-daily':
          chartParams["VsType"] = "winvslos";
          myThis.DrawAdvancedPeriodChart("profile-summary-chart", 1, chartParams);
          break;
        case 'advanced-duration':
          chartParams["UnitType"] = "percent";
          myThis.DrawAdvancedDurationChart("profile-summary-chart", chartParams);
          break;
        case 'advanced-maemfe':
          chartParams['VsType'] = 'maevsoutcome';
          chartParams['UnitType'] = 'pips';
          myThis.DrawAdvancedMAEMFEChart("profile-summary-chart", chartParams);
          break;
      }
    }
  }, {
    key: "UpdateSummaryChart",
    value: function UpdateSummaryChart() {
      var myThis = this;
      var chartParams = {};
      $("#profile-summary-chart-options input:checked").each(function () {
        chartParams[this.name] = this.value;
      });
      var profitType = 'equity';
      chartParams["ProfitType"] = profitType;
      if (myThis.currentChart == "advanced-hourly" || myThis.currentChart == "advanced-daily") {
        if (chartParams["VsType"] == 'winvslos' || chartParams["VsType"] == 'longvsshort') {
          $("#profile-summary-chart-options input[name=UnitType]").attr("disabled", true);
          chartParams["UnitType"] = undefined;
        } else {
          $("#profile-summary-chart-options input[name=UnitType]").removeAttr("disabled");
          myThis.InitializePermission();
        }
      }
      switch (myThis.currentChart) {
        case 'equity':
          myThis.DrawProfileEquityChart('profile-summary-chart');
          break;
        case 'profit':
          myThis.DrawProfileProfitChart('profile-summary-chart');
          break;
        case 'closed-profit':
          chartParams["ProfitType"] = "balance";
          myThis.DrawProfileProfitChart('profile-summary-chart');
          break;
        case 'open-profit':
          myThis.DrawProfileOpenProfitChart('profile-summary-chart');
          break;
        case 'balance':
          myThis.DrawProfileBalanceChart('profile-summary-chart', chartParams);
          break;
        case 'open-profit-percent':
          myThis.DrawProfileOpenProfitPercentChart('profile-summary-chart');
          break;
        case 'profit-percent':
          chartParams["ProfitType"] = "equity";
          myThis.DrawProfileGrowthChart('profile-summary-chart', chartParams);
          break;
        case 'closed-profit-percent':
          chartParams["ProfitType"] = "balance";
          myThis.DrawProfileGrowthChart('profile-summary-chart', chartParams);
          break;
        case 'profit-percent-twr':
          chartParams["ProfitType"] = "equity-twr";
          myThis.DrawProfileGrowthChart('profile-summary-chart', chartParams);
          break;
        case 'closed-profit-percent-twr':
          chartParams["ProfitType"] = "balance-twr";
          myThis.DrawProfileGrowthChart('profile-summary-chart', chartParams);
          break;
        case 'drawdown':
          myThis.DrawProfileDrawdownChart('profile-summary-chart', chartParams);
          break;
        case 'monthly-profit':
        case 'monthly-profit-twr':
          chartParams["ProfitType"] = "equity";
          myThis.DrawProfileMonthlyChart('profile-summary-chart', chartParams);
          break;
        case 'closed-monthly-profit':
        case 'closed-monthly-profit-twr':
          chartParams["ProfitType"] = "balance";
          myThis.DrawProfileMonthlyChart('profile-summary-chart', chartParams);
          break;
        case 'advanced-hourly':
          myThis.DrawAdvancedPeriodChart("profile-summary-chart", 0, chartParams);
          break;
        case 'advanced-daily':
          myThis.DrawAdvancedPeriodChart("profile-summary-chart", 1, chartParams);
          break;
        case 'advanced-duration':
          myThis.DrawAdvancedDurationChart("profile-summary-chart", chartParams);
          break;
        case 'advanced-maemfe':
          myThis.DrawAdvancedMAEMFEChart("profile-summary-chart", chartParams);
          break;
      }
    }
  }, {
    key: "InitializeSummaryChartOptions",
    value: function InitializeSummaryChartOptions(chart) {
      $("#profile-summary-chart-options").html(this.chartOptionHtmls[chart] || '');
    }
  }, {
    key: "ChangeCustomAnalysisOptionContent",
    value: function ChangeCustomAnalysisOptionContent($el, id) {
      var myThis = this;
      $("#custom-analysis-option-list button").removeClass('active');
      $el.addClass('active');
      $("#custom-analysis-option-content").children().css({
        "display": "none"
      });
      $("#custom-analysis-" + id).css({
        "display": "block"
      });
    }
  }]);
  return AISStatistics;
}();
var _default = AISStatistics;
exports["default"] = _default;

},{"./AISHelper":2}],6:[function(require,module,exports){
'use strict';

var _AISHelper = _interopRequireDefault(require("../../includes/AISHelper.js"));
var _AISStatistics = _interopRequireDefault(require("../../includes/AISStatistics.js"));
var _AISPortfolio = _interopRequireDefault(require("../../includes/AISPortfolio.js"));
var _AISContest = _interopRequireDefault(require("../../includes/AISContest.js"));
var _AISPerformances = _interopRequireDefault(require("../../includes/AISPerformances.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
window.AISHelper = _AISHelper["default"];
window.AISStatistics = _AISStatistics["default"];
window.AISPortfolio = _AISPortfolio["default"];
window.AISContest = _AISContest["default"];
window.AISPerformances = _AISPerformances["default"];
(function ($) {
  $.fn.shorten = function (settings) {
    var config = {
      showChars: 100,
      ellipsesText: "...",
      moreText: "more",
      lessText: "less"
    };
    if (settings) {
      $.extend(config, settings);
    }
    $(document).off("click", '.morelink');
    $(document).on({
      click: function click() {
        var $this = $(this);
        if ($this.hasClass('less')) {
          $this.removeClass('less');
          $this.html(config.moreText);
        } else {
          $this.addClass('less');
          $this.html(config.lessText);
        }
        $this.parent().prev().toggle();
        $this.prev().toggle();
        return false;
      }
    }, '.morelink');
    return this.each(function () {
      var $this = $(this);
      if ($this.hasClass("shortened")) return;
      $this.addClass("shortened");
      var content = $this.html();
      if (content.length > config.showChars) {
        var c = content.substr(0, config.showChars);
        var h = content.substr(config.showChars, content.length - config.showChars);
        var html = c + '<span class="moreellipses">' + config.ellipsesText + ' </span><span class="morecontent"><span>' + h + '</span> <a href="#" class="morelink">' + config.moreText + '</a></span>';
        $this.html(html);
        $(".morecontent span").hide();
      }
    });
  };
})(jQuery);

},{"../../includes/AISContest.js":1,"../../includes/AISHelper.js":2,"../../includes/AISPerformances.js":3,"../../includes/AISPortfolio.js":4,"../../includes/AISStatistics.js":5}]},{},[6]);
